(window.theme = window.theme || {}),
    (window.theme = window.theme || {}),
    (theme.Sections = function e() {
        (this.constructors = {}),
            (this.instances = []),
            document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
            document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
            document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
            document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
            document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
            document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function (e, t) {
            var s = e.getAttribute("data-section-id"),
                r = e.getAttribute("data-section-type");
            if (void 0 !== (t = t || this.constructors[r])) {
                var n = Object.assign(new t(e), { id: s, type: r, container: e });
                this.instances.push(n);
            }
        },
        _onSectionLoad: function (e) {
            var t = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
            t && this._createInstance(t);
        },
        _onSectionUnload: function (e) {
            this.instances = this.instances.filter(function (t) {
                var s = t.id === e.detail.sectionId;
                return s && "function" == typeof t.onUnload && t.onUnload(e), !s;
            });
        },
        _onSelect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        },
        register: function (e, t) {
            (this.constructors[e] = t),
                document.querySelectorAll('[data-section-type="' + e + '"]').forEach(
                    function (e) {
                        this._createInstance(e, t);
                    }.bind(this)
                );
        },
    })),
    (window.slate = window.slate || {}),
    (slate.utils = {
        getParameterByName: function (e, t) {
            t || (t = window.location.href);
            var s = RegExp("[?&]" + (e = e.replace(/[[\]]/g, "\\$&")) + "(=([^&#]*)|&|#|$)").exec(t);
            return s ? (s[2] ? decodeURIComponent(s[2].replace(/\+/g, " ")) : "") : null;
        },
        resizeSelects: function (e) {
            e.forEach(function (e) {
                var t = document.createElement("span");
                (t.innerHTML = e.selectedOptions[0].label), document.querySelector(".site-footer").appendChild(t);
                var s = t.offsetWidth + 55;
                t.remove(), (e.style.width = s + "px");
            });
        },
        keyboardKeys: { TAB: 9, ENTER: 13, ESCAPE: 27, LEFTARROW: 37, RIGHTARROW: 39 },
    }),
    (window.slate = window.slate || {}),
    (slate.rte = {
        wrapTable: function (e) {
            e.tables.forEach(function (t) {
                var s = document.createElement("div");
                s.classList.add(e.tableWrapperClass), t.parentNode.insertBefore(s, t), s.appendChild(t);
            });
        },
        wrapIframe: function (e) {
            e.iframes.forEach(function (t) {
                var s = document.createElement("div");
                s.classList.add(e.iframeWrapperClass), t.parentNode.insertBefore(s, t), s.appendChild(t), (t.src = t.src);
            });
        },
    }),
    (window.slate = window.slate || {}),
    (slate.a11y = {
        state: { firstFocusable: null, lastFocusable: null },
        pageLinkFocus: function (e) {
            if (e) {
                var t = "js-focus-hidden";
                e.setAttribute("tabIndex", "-1"),
                    e.focus(),
                    e.classList.add(t),
                    e.addEventListener(
                        "blur",
                        function s() {
                            e.classList.remove(t), e.removeAttribute("tabindex");
                        },
                        { once: !0 }
                    );
            }
        },
        trapFocus: function (e) {
            var t = Array.from(e.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (e) {
                var t = e.offsetWidth,
                    s = e.offsetHeight;
                return 0 !== t && 0 !== s && "none" !== getComputedStyle(e).getPropertyValue("display");
            });
            (this.state.firstFocusable = t[0]),
                (this.state.lastFocusable = t[t.length - 1]),
                e.elementToFocus || (e.elementToFocus = e.container),
                e.container.setAttribute("tabindex", "-1"),
                e.elementToFocus.focus(),
                this._setupHandlers(),
                document.addEventListener("focusin", this._onFocusInHandler),
                document.addEventListener("focusout", this._onFocusOutHandler);
        },
        _setupHandlers: function () {
            this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
                this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this));
        },
        _onFocusOut: function () {
            document.removeEventListener("keydown", this._manageFocusHandler);
        },
        _onFocusIn: function (e) {
            (e.target === this.state.lastFocusable || e.target === this.state.firstFocusable) && document.addEventListener("keydown", this._manageFocusHandler);
        },
        _manageFocus: function (e) {
            e.keyCode === slate.utils.keyboardKeys.TAB &&
                (e.target !== this.state.lastFocusable || e.shiftKey || (e.preventDefault(), this.state.firstFocusable.focus()),
                e.target === this.state.firstFocusable && e.shiftKey && (e.preventDefault(), this.state.lastFocusable.focus()));
        },
        removeTrapFocus: function (e) {
            e.container && e.container.removeAttribute("tabindex"), document.removeEventListener("focusin", this._onFocusInHandler);
        },
        accessibleLinks: function (e) {
            var t = document.querySelector("body"),
                s = { newWindow: "a11y-new-window-message", external: "a11y-external-message", newWindowExternal: "a11y-new-window-external-message" };
            (void 0 !== e.links && e.links.length) || (e.links = document.querySelectorAll("a[href]:not([aria-describedby])")),
                e.links.forEach(function (e) {
                    var t,
                        r,
                        n = e.getAttribute("target"),
                        a = e.getAttribute("rel"),
                        o = ((t = e), (r = window.location.hostname), t.hostname !== r),
                        c = "_blank" === n;
                    if ((o && e.setAttribute("aria-describedby", s.external), c)) {
                        if (!a || -1 === a.indexOf("noopener")) {
                            var l = void 0 === a ? "" : a + " ";
                            (l += "noopener"), e.setAttribute("rel", l);
                        }
                        e.setAttribute("aria-describedby", s.newWindow);
                    }
                    o && c && e.setAttribute("aria-describedby", s.newWindowExternal);
                }),
                (function e(r) {
                    "object" != typeof r && (r = {});
                    var n = Object.assign({ newWindow: "Opens in a new window.", external: "Opens external website.", newWindowExternal: "Opens external website in a new window." }, r),
                        a = document.createElement("ul"),
                        o = "";
                    for (var c in n) o += "<li id=" + s[c] + ">" + n[c] + "</li>";
                    a.setAttribute("hidden", !0), (a.innerHTML = o), t.appendChild(a);
                })(e.messages);
        },
    }),
    (theme.Images = {
        preload: function e(t, s) {
            "string" == typeof t && (t = [t]);
            for (var r = 0; r < t.length; r++) {
                var n = t[r];
                this.loadImage(this.getSizedImageUrl(n, s));
            }
        },
        loadImage: function e(t) {
            new Image().src = t;
        },
        switchImage: function e(t, s, r) {
            var n = this.imageSize(s.src),
                a = this.getSizedImageUrl(t.src, n);
            r ? r(a, t, s) : (s.src = a);
        },
        imageSize: function e(t) {
            var s = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return null === s ? null : void 0 !== s[2] ? s[1] + s[2] : s[1];
        },
        getSizedImageUrl: function e(t, s) {
            if (null === s) return t;
            if ("master" === s) return this.removeProtocol(t);
            var r = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null !== r) {
                var n = t.split(r[0]),
                    a = r[0];
                return this.removeProtocol(n[0] + "_" + s + a);
            }
            return null;
        },
        removeProtocol: function e(t) {
            return t.replace(/http(s)?:/, "");
        },
    }),
    (theme.Currency = {
        formatMoney: function e(t, s) {
            "string" == typeof t && (t = t.replace(".", ""));
            var r = "",
                n = /\{\{\s*(\w+)\s*\}\}/,
                a = s || "${{amount}}";
            function o(e, t, s, r) {
                if (((s = s || ","), (r = r || "."), isNaN(e) || null === e)) return 0;
                var n,
                    a = (e = (e / 100).toFixed(t)).split(".");
                return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) + (a[1] ? r + a[1] : "");
            }
            switch (a.match(n)[1]) {
                case "amount":
                    r = o(t, 2);
                    break;
                case "amount_no_decimals":
                    r = o(t, 0);
                    break;
                case "amount_with_comma_separator":
                    r = o(t, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    r = o(t, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    r = o(t, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    r = o(t, 2, "'");
            }
            return a.replace(n, r);
        },
    }),
    (slate.Variants = (function () {
        function e(e) {
            (this.container = e.container),
                (this.product = e.product),
                (this.originalSelectorId = e.originalSelectorId),
                (this.enableHistoryState = e.enableHistoryState),
                (this.singleOptions = this.container.querySelectorAll(e.singleOptionSelector)),
                (this.currentVariant = this._getVariantFromOptions()),
                this.singleOptions.forEach(
                    function (e) {
                        e.addEventListener("change", this._onSelectChange.bind(this));
                    }.bind(this)
                );
        }
        return (
            (e.prototype = Object.assign({}, e.prototype, {
                _getCurrentOptions: function () {
                    var e = [];
                    return (
                        this.singleOptions.forEach(function (t) {
                            var s = t.getAttribute("type");
                            (!("radio" === s || "checkbox" === s) || t.checked) && e.push({ value: t.value, index: t.getAttribute("data-index") });
                        }),
                        e
                    );
                },
                _getVariantFromOptions: function () {
                    var e = this._getCurrentOptions();
                    return this.product.variants.find(function (t) {
                        return e.every(function (e) {
                            return t[e.index] === e.value;
                        });
                    });
                },
                _onSelectChange: function () {
                    var e = this._getVariantFromOptions();
                    this.container.dispatchEvent(new CustomEvent("variantChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 })),
                        e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), (this.currentVariant = e), this._updateShipping(e), this.enableHistoryState && this._updateHistoryState(e));
                },
                _updateImages: function (e) {
                    var t = e.featured_image || {},
                        s = this.currentVariant.featured_image || {};
                    e.featured_image && t.src !== s.src && this.container.dispatchEvent(new CustomEvent("variantImageChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 }));
                },
                _updatePrice: function (e) {
                    (e.price !== this.currentVariant.price || e.compare_at_price !== this.currentVariant.compare_at_price) &&
                        this.container.dispatchEvent(new CustomEvent("variantPriceChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 }));
                },
                _updateSKU: function (e) {
                    e.sku !== this.currentVariant.sku && this.container.dispatchEvent(new CustomEvent("variantSKUChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 }));
                },
                _updateShipping: function (e) {
                    let t = document.querySelector("[data-product-inventory-" + e.id + "]").innerHTML.split(","),
                        s = document.querySelector("[data-product-delivery]").innerHTML.split(",");
                    var r = -1,
                        n = t[0],
                        a = t[1],
                        o = t[2],
                        c = t[3];
                    if ((n > 0 ? (r = s[0]) : a > 0 ? (r = s[1]) : o > 0 ? (r = s[2]) : c > 0 && (r = s[3]), 0 == r))
                        (document.querySelector("[data-product-shipping-0]").style.display = "block"),
                            (document.querySelector("[data-product-shipping-1]").style.display = "none"),
                            (document.querySelector("[data-product-shipping-2]").style.display = "none");
                    else if (1 == r)
                        (document.querySelector("[data-product-shipping-0]").style.display = "none"),
                            (document.querySelector("[data-product-shipping-1]").style.display = "block"),
                            (document.querySelector("[data-product-shipping-2]").style.display = "none");
                    else if (r > 1) {
                        (document.querySelector("[data-product-shipping-0]").style.display = "none"),
                            (document.querySelector("[data-product-shipping-1]").style.display = "none"),
                            (document.querySelector("[data-product-shipping-2]").style.display = "block");
                        var l = Number(r) + 2;
                        document.querySelector("[data-product-shipping-2-text]").innerHTML = "Delivered in " + r + "-" + l + " days ";
                    } else
                        (document.querySelector("[data-product-shipping-0]").style.display = "none"),
                            (document.querySelector("[data-product-shipping-1]").style.display = "none"),
                            (document.querySelector("[data-product-shipping-2]").style.display = "none");
                },
                _updateHistoryState: function (e) {
                    if (history.replaceState && e) {
                        var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                        window.history.replaceState({ path: t }, "", t);
                    }
                },
                _updateMasterSelect: function (e) {
                    var t = this.container.querySelector(this.originalSelectorId);
                    t && (t.value = e.id);
                },
            })),
            e
        );
    })()),
    (this.Shopify = this.Shopify || {}),
    (this.Shopify.theme = this.Shopify.theme || {}),
    (this.Shopify.theme.PredictiveSearch = (function () {
        "use strict";
        function e() {
            var e = Error.call(this);
            return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
        }
        function t(e) {
            var t = Error.call(this);
            return (t.name = "Not found"), (t.message = "Not found"), (t.status = e), t;
        }
        function s() {
            var e = Error.call(this);
            return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
        }
        function r(e) {
            var t = Error.call(this);
            return (t.name = "Content-Type error"), (t.message = "Content-Type was not provided or is of wrong type"), (t.status = e), t;
        }
        function n(e) {
            var t = Error.call(this);
            return (t.name = "JSON parse error"), (t.message = "JSON syntax error"), (t.status = e), t;
        }
        function a(e, t, s, r) {
            var n = Error.call(this);
            return (n.name = t), (n.message = s), (n.status = e), (n.retryAfter = r), n;
        }
        function o(e, t, s) {
            var r = Error.call(this);
            return (r.name = t), (r.message = s), (r.status = e), r;
        }
        function c(e, t, s) {
            var r = Error.call(this);
            return (r.name = t), (r.message = s), (r.status = e), r;
        }
        function l(e) {
            (this._store = {}), (this._keys = []), e && e.bucketSize ? (this.bucketSize = e.bucketSize) : (this.bucketSize = 20);
        }
        function d() {
            this.events = {};
        }
        function u(e) {
            (this.eventName = e), (this.callbacks = []);
        }
        (l.prototype.set = function (e, t) {
            if (this.count() >= this.bucketSize) {
                var s = this._keys.splice(0, 1);
                this.delete(s);
            }
            return this._keys.push(e), (this._store[e] = t), this._store;
        }),
            (l.prototype.get = function (e) {
                return this._store[e];
            }),
            (l.prototype.has = function (e) {
                return Boolean(this._store[e]);
            }),
            (l.prototype.count = function () {
                return Object.keys(this._store).length;
            }),
            (l.prototype.delete = function (e) {
                var t = Boolean(this._store[e]);
                return delete this._store[e], t && !this._store[e];
            }),
            (d.prototype.on = function (e, t) {
                var s = this.events[e];
                s || ((s = new u(e)), (this.events[e] = s)), s.registerCallback(t);
            }),
            (d.prototype.off = function (e, t) {
                var s = this.events[e];
                s && s.callbacks.indexOf(t) > -1 && (s.unregisterCallback(t), 0 === s.callbacks.length && delete this.events[e]);
            }),
            (d.prototype.dispatch = function (e, t) {
                var s = this.events[e];
                s && s.fire(t);
            }),
            (u.prototype.registerCallback = function (e) {
                this.callbacks.push(e);
            }),
            (u.prototype.unregisterCallback = function (e) {
                var t = this.callbacks.indexOf(e);
                t > -1 && this.callbacks.splice(t, 1);
            }),
            (u.prototype.fire = function (e) {
                this.callbacks.slice(0).forEach(function (t) {
                    t(e);
                });
            });
        var h,
            p,
            m =
                ((h = function l(d, u, h, p, m) {
                    var v = new XMLHttpRequest();
                    (v.onreadystatechange = function () {
                        if (v.readyState === XMLHttpRequest.DONE) {
                            var l = v.getResponseHeader("Content-Type");
                            if (v.status >= 500) {
                                m(new s());
                                return;
                            }
                            if (404 === v.status) {
                                m(new t(v.status));
                                return;
                            }
                            if ("string" != typeof l || null === l.toLowerCase().match("application/json")) {
                                m(new r(v.status));
                                return;
                            }
                            if (417 === v.status) {
                                try {
                                    var d = JSON.parse(v.responseText);
                                    m(new o(v.status, d.message, d.description));
                                } catch (u) {
                                    m(new n(v.status));
                                }
                                return;
                            }
                            if (422 === v.status) {
                                try {
                                    var f = JSON.parse(v.responseText);
                                    m(new c(v.status, f.message, f.description));
                                } catch (y) {
                                    m(new n(v.status));
                                }
                                return;
                            }
                            if (429 === v.status) {
                                try {
                                    var g = JSON.parse(v.responseText);
                                    m(new a(v.status, g.message, g.description, v.getResponseHeader("Retry-After")));
                                } catch (b) {
                                    m(new n(v.status));
                                }
                                return;
                            }
                            if (200 === v.status) {
                                try {
                                    var S = JSON.parse(v.responseText);
                                    (S.query = h), p(S);
                                } catch (L) {
                                    m(new n(v.status));
                                }
                                return;
                            }
                            try {
                                var E = JSON.parse(v.responseText);
                                m(new e(v.status, E.message, E.description));
                            } catch (C) {
                                m(new n(v.status));
                            }
                        }
                    }),
                        v.open("get", d + "/suggest.json?q=" + encodeURIComponent(h) + "&" + u),
                        console.log(u),
                        v.setRequestHeader("Content-Type", "application/json"),
                        v.send();
                }),
                (p = null),
                function () {
                    var e = this,
                        t = arguments;
                    clearTimeout(p),
                        (p = setTimeout(function () {
                            (p = null), h.apply(e, t);
                        }, 10));
                });
        function v(e, t) {
            if (!e) throw TypeError("No params object was specified");
            (this.searchUrl = t),
                (this._retryAfter = null),
                (this._currentQuery = null),
                (this.dispatcher = new d()),
                (this.cache = new l({ bucketSize: 40 })),
                (this.queryParams = (function e(t, s) {
                    var r = "";
                    return (
                        (s = s || null),
                        Object.keys(t).forEach(function (n) {
                            var a,
                                o = n + "=";
                            switch ((s && (o = s + "[" + n + "]"), (a = t[n]), Object.prototype.toString.call(a).slice(8, -1).toLowerCase())) {
                                case "object":
                                    r += e(t[n], s ? o : n);
                                    break;
                                case "array":
                                    r += o + "=" + t[n].join(",") + "&";
                                    break;
                                default:
                                    s && (o += "="), (r += o + encodeURIComponent(t[n]) + "&");
                            }
                        }),
                        r
                    );
                })(e));
        }
        function f(e) {
            return "string" != typeof e ? null : e.trim().replace(" ", "-").toLowerCase();
        }
        return (
            (v.TYPES = { PRODUCT: "product", PAGE: "page", ARTICLE: "article" }),
            (v.FIELDS = { AUTHOR: "author", BODY: "body", PRODUCT_TYPE: "product_type", TAG: "tag", TITLE: "title", VARIANTS_BARCODE: "variants.barcode", VARIANTS_SKU: "variants.sku", VARIANTS_TITLE: "variants.title", VENDOR: "vendor" }),
            (v.UNAVAILABLE_PRODUCTS = { SHOW: "show", HIDE: "hide", LAST: "last" }),
            (v.prototype.query = function e(e) {
                try {
                    !(function e(t) {
                        var s;
                        if (null == t) throw (((s = TypeError("'query' is missing")).type = "argument"), s);
                        if ("string" != typeof t) throw (((s = TypeError("'query' is not a string")).type = "argument"), s);
                    })(e);
                } catch (t) {
                    this.dispatcher.dispatch("error", t);
                    return;
                }
                if ("" === e) return this;
                this._currentQuery = f(e);
                var s = this.cache.get(this._currentQuery);
                return s
                    ? (this.dispatcher.dispatch("success", s), this)
                    : (m(
                          this.searchUrl,
                          this.queryParams,
                          e,
                          function (e) {
                              this.cache.set(f(e.query), e), f(e.query) === this._currentQuery && ((this._retryAfter = null), this.dispatcher.dispatch("success", e));
                          }.bind(this),
                          function (e) {
                              e.retryAfter && (this._retryAfter = e.retryAfter), this.dispatcher.dispatch("error", e);
                          }.bind(this)
                      ),
                      this);
            }),
            (v.prototype.on = function e(t, s) {
                return this.dispatcher.on(t, s), this;
            }),
            (v.prototype.off = function e(t, s) {
                return this.dispatcher.off(t, s), this;
            }),
            v
        );
    })()),
    (this.Shopify = this.Shopify || {}),
    (this.Shopify.theme = this.Shopify.theme || {}),
    (this.Shopify.theme.PredictiveSearchComponent = (function (e) {
        "use strict";
        var t = {
            resources: {
                type: [(e = e && e.hasOwnProperty("default") ? e.default : e).TYPES.PRODUCT, "collection"],
                options: { unavailable_products: e.UNAVAILABLE_PRODUCTS.LAST, fields: [e.FIELDS.TITLE, e.FIELDS.VENDOR, e.FIELDS.PRODUCT_TYPE, e.FIELDS.VARIANTS_TITLE] },
            },
        };
        function s(s) {
            if (
                !s ||
                !s.selectors ||
                !s.selectors.input ||
                !n(s.selectors.input) ||
                !s.selectors.result ||
                !n(s.selectors.result) ||
                !s.resultTemplateFct ||
                !o(s.resultTemplateFct) ||
                !s.numberOfResultsTemplateFct ||
                !o(s.numberOfResultsTemplateFct) ||
                !s.loadingResultsMessageTemplateFct ||
                !o(s.loadingResultsMessageTemplateFct)
            ) {
                var r,
                    a,
                    c,
                    l,
                    d = TypeError("PredictiveSearchComponent config is not valid");
                throw ((d.type = "argument"), d);
            }
            if (
                ((this.nodes = ((r = s.selectors), { input: document.querySelector(r.input), reset: document.querySelector(r.reset), result: document.querySelector(r.result) })),
                (a = this.nodes),
                !a || !a.input || !a.result || "INPUT" !== a.input.tagName)
            ) {
                console.warn("Could not find valid nodes");
                return;
            }
            (this.searchUrl = s.searchUrl || "/search"),
                (this._searchKeyword = ""),
                (this.resultTemplateFct = s.resultTemplateFct),
                (this.numberOfResultsTemplateFct = s.numberOfResultsTemplateFct),
                (this.loadingResultsMessageTemplateFct = s.loadingResultsMessageTemplateFct),
                (this.numberOfResults = s.numberOfResults || 4),
                (this.classes = {
                    visibleVariant: s.visibleVariant ? s.visibleVariant : "predictive-search-wrapper--visible",
                    itemSelected: s.itemSelectedClass ? s.itemSelectedClass : "predictive-search-item--selected",
                    clearButtonVisible: s.clearButtonVisibleClass ? s.clearButtonVisibleClass : "predictive-search__clear-button--visible",
                }),
                (this.selectors = { searchResult: s.searchResult ? s.searchResult : "[data-search-result]" }),
                (this.callbacks =
                    ((c = s),
                    {
                        onBodyMousedown: c.onBodyMousedown,
                        onBeforeOpen: c.onBeforeOpen,
                        onOpen: c.onOpen,
                        onBeforeClose: c.onBeforeClose,
                        onClose: c.onClose,
                        onInputFocus: c.onInputFocus,
                        onInputKeyup: c.onInputKeyup,
                        onInputBlur: c.onInputBlur,
                        onInputReset: c.onInputReset,
                        onBeforeDestroy: c.onBeforeDestroy,
                        onDestroy: c.onDestroy,
                    })),
                (l = this.nodes.input).setAttribute("autocorrect", "off"),
                l.setAttribute("autocomplete", "off"),
                l.setAttribute("autocapitalize", "off"),
                l.setAttribute("spellcheck", "false"),
                this._addInputEventListeners(),
                this._addBodyEventListener(),
                this._addAccessibilityAnnouncer(),
                this._toggleClearButtonVisibility(),
                (this.predictiveSearch = new e(s.PredictiveSearchAPIConfig ? s.PredictiveSearchAPIConfig : t, this.searchUrl)),
                this.predictiveSearch.on("success", this._handlePredictiveSearchSuccess.bind(this)),
                this.predictiveSearch.on("error", this._handlePredictiveSearchError.bind(this));
        }
        function r(e) {
            return Object.prototype.toString.call(e);
        }
        function n(e) {
            return "[object String]" === r(e);
        }
        function a(e) {
            return "[object Boolean]" === r(e);
        }
        function o(e) {
            return "[object Function]" === r(e);
        }
        return (
            (s.prototype.isResultVisible = !1),
            (s.prototype.results = {}),
            (s.prototype._latencyTimer = null),
            (s.prototype._resultNodeClicked = !1),
            (s.prototype._addInputEventListeners = function () {
                var e = this.nodes.input,
                    t = this.nodes.reset;
                e &&
                    ((this._handleInputFocus = this._handleInputFocus.bind(this)),
                    (this._handleInputBlur = this._handleInputBlur.bind(this)),
                    (this._handleInputKeyup = this._handleInputKeyup.bind(this)),
                    (this._handleInputKeydown = this._handleInputKeydown.bind(this)),
                    e.addEventListener("focus", this._handleInputFocus),
                    e.addEventListener("blur", this._handleInputBlur),
                    e.addEventListener("keyup", this._handleInputKeyup),
                    e.addEventListener("keydown", this._handleInputKeydown),
                    t && ((this._handleInputReset = this._handleInputReset.bind(this)), t.addEventListener("click", this._handleInputReset)));
            }),
            (s.prototype._removeInputEventListeners = function () {
                var e = this.nodes.input;
                e.removeEventListener("focus", this._handleInputFocus),
                    e.removeEventListener("blur", this._handleInputBlur),
                    e.removeEventListener("keyup", this._handleInputKeyup),
                    e.removeEventListener("keydown", this._handleInputKeydown);
            }),
            (s.prototype._addBodyEventListener = function () {
                (this._handleBodyMousedown = this._handleBodyMousedown.bind(this)), document.querySelector("body").addEventListener("mousedown", this._handleBodyMousedown);
            }),
            (s.prototype._removeBodyEventListener = function () {
                document.querySelector("body").removeEventListener("mousedown", this._handleBodyMousedown);
            }),
            (s.prototype._removeClearButtonEventListener = function () {
                var e = this.nodes.reset;
                e && e.removeEventListener("click", this._handleInputReset);
            }),
            (s.prototype._handleBodyMousedown = function (e) {
                if (this.isResultVisible && null !== this.nodes) {
                    if (e.target.isEqualNode(this.nodes.input) || this.nodes.input.contains(e.target) || e.target.isEqualNode(this.nodes.result) || this.nodes.result.contains(e.target)) this._resultNodeClicked = !0;
                    else if (o(this.callbacks.onBodyMousedown)) {
                        var t = this.callbacks.onBodyMousedown(this.nodes);
                        a(t) && t && this.close();
                    } else this.close();
                }
            }),
            (s.prototype._handleInputFocus = function (e) {
                if (o(this.callbacks.onInputFocus)) {
                    var t = this.callbacks.onInputFocus(this.nodes);
                    if (a(t) && !t) return !1;
                }
                return e.target.value.length > 0 && this._search(), !0;
            }),
            (s.prototype._handleInputBlur = function () {
                return (
                    setTimeout(
                        function () {
                            if (o(this.callbacks.onInputBlur)) {
                                var e = this.callbacks.onInputBlur(this.nodes);
                                if (a(e) && !e) return !1;
                            }
                            return !document.activeElement.isEqualNode(this.nodes.reset) && (this._resultNodeClicked ? ((this._resultNodeClicked = !1), !1) : void this.close());
                        }.bind(this)
                    ),
                    !0
                );
            }),
            (s.prototype._addAccessibilityAnnouncer = function () {
                (this._accessibilityAnnouncerDiv = window.document.createElement("div")),
                    this._accessibilityAnnouncerDiv.setAttribute("style", "position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;"),
                    this._accessibilityAnnouncerDiv.setAttribute("data-search-announcer", ""),
                    this._accessibilityAnnouncerDiv.setAttribute("aria-live", "polite"),
                    this._accessibilityAnnouncerDiv.setAttribute("aria-atomic", "true"),
                    this.nodes.result.parentElement.appendChild(this._accessibilityAnnouncerDiv);
            }),
            (s.prototype._removeAccessibilityAnnouncer = function () {
                this.nodes.result.parentElement.removeChild(this._accessibilityAnnouncerDiv);
            }),
            (s.prototype._updateAccessibilityAttributesAfterSelectingElement = function (e, t) {
                this.nodes.input.setAttribute("aria-activedescendant", t.id), e && e.removeAttribute("aria-selected"), t.setAttribute("aria-selected", !0);
            }),
            (s.prototype._clearAriaActiveDescendant = function () {
                this.nodes.input.setAttribute("aria-activedescendant", "");
            }),
            (s.prototype._announceNumberOfResultsFound = function (e) {
                var t = this._accessibilityAnnouncerDiv.innerHTML,
                    s = this.numberOfResultsTemplateFct(e);
                t === s && (s += "&nbsp;"), (this._accessibilityAnnouncerDiv.innerHTML = s);
            }),
            (s.prototype._announceLoadingState = function () {
                this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
            }),
            (s.prototype._handleInputKeyup = function (e) {
                if (o(this.callbacks.onInputKeyup)) {
                    var t = this.callbacks.onInputKeyup(this.nodes);
                    if (a(t) && !t) return !1;
                }
                if ((this._toggleClearButtonVisibility(), this.isResultVisible && null !== this.nodes)) {
                    if (38 === e.keyCode) return this._navigateOption(e, "UP"), !0;
                    if (40 === e.keyCode) return this._navigateOption(e, "DOWN"), !0;
                    if (13 === e.keyCode) return this._selectOption(), !0;
                    27 === e.keyCode && this.close();
                }
                return e.target.value.length <= 0 ? (this.close(), this._setKeyword("")) : e.target.value.length > 0 && this._search(), !0;
            }),
            (s.prototype._handleInputKeydown = function (e) {
                13 === e.keyCode && null !== this._getSelectedOption() && e.preventDefault(), (38 === e.keyCode || 40 === e.keyCode) && e.preventDefault();
            }),
            (s.prototype._handleInputReset = function (e) {
                if ((e.preventDefault(), o(this.callbacks.onInputReset))) {
                    var t = this.callbacks.onInputReset(this.nodes);
                    if (a(t) && !t) return !1;
                }
                return (this.nodes.input.value = ""), this.nodes.input.focus(), this._toggleClearButtonVisibility(), this.close(), !0;
            }),
            (s.prototype._navigateOption = function (e, t) {
                var s = this._getSelectedOption();
                if (s) {
                    if ("DOWN" === t) {
                        var r = s.nextElementSibling;
                        r && (s.classList.remove(this.classes.itemSelected), r.classList.add(this.classes.itemSelected), this._updateAccessibilityAttributesAfterSelectingElement(s, r));
                    } else {
                        var n = s.previousElementSibling;
                        n && (s.classList.remove(this.classes.itemSelected), n.classList.add(this.classes.itemSelected), this._updateAccessibilityAttributesAfterSelectingElement(s, n));
                    }
                } else {
                    var a = this.nodes.result.querySelector(this.selectors.searchResult);
                    a.classList.add(this.classes.itemSelected), this._updateAccessibilityAttributesAfterSelectingElement(null, a);
                }
            }),
            (s.prototype._getSelectedOption = function () {
                return this.nodes.result.querySelector("." + this.classes.itemSelected);
            }),
            (s.prototype._selectOption = function () {
                var e = this._getSelectedOption();
                e && e.querySelector("a, button").click();
            }),
            (s.prototype._search = function () {
                var e = this.nodes.input.value;
                this._searchKeyword !== e &&
                    (clearTimeout(this._latencyTimer),
                    (this._latencyTimer = setTimeout(
                        function () {
                            (this.results.isLoading = !0), this._announceLoadingState(), this.nodes.result.classList.add(this.classes.visibleVariant), (this.nodes.result.innerHTML = this.resultTemplateFct(this.results));
                        }.bind(this),
                        500
                    )),
                    this.predictiveSearch.query(e),
                    this._setKeyword(e));
            }),
            (s.prototype._handlePredictiveSearchSuccess = function (e) {
                clearTimeout(this._latencyTimer),
                    (this.results = e.resources.results),
                    (this.results.isLoading = !1),
                    (this.results.products = this.results.products.slice(0, this.numberOfResults)),
                    (this.results.canLoadMore = this.numberOfResults <= this.results.products.length),
                    (this.results.searchQuery = this.nodes.input.value),
                    this.results.products.length > 0 || this.results.searchQuery
                        ? ((this.nodes.result.innerHTML = this.resultTemplateFct(this.results)), this._announceNumberOfResultsFound(this.results), this.open())
                        : ((this.nodes.result.innerHTML = ""), this._closeOnNoResults());
            }),
            (s.prototype._handlePredictiveSearchError = function () {
                clearTimeout(this._latencyTimer), (this.nodes.result.innerHTML = ""), this._closeOnNoResults();
            }),
            (s.prototype._closeOnNoResults = function () {
                this.nodes && this.nodes.result.classList.remove(this.classes.visibleVariant), (this.isResultVisible = !1);
            }),
            (s.prototype._setKeyword = function (e) {
                this._searchKeyword = e;
            }),
            (s.prototype._toggleClearButtonVisibility = function () {
                this.nodes.reset && (this.nodes.input.value.length > 0 ? this.nodes.reset.classList.add(this.classes.clearButtonVisible) : this.nodes.reset.classList.remove(this.classes.clearButtonVisible));
            }),
            (s.prototype.open = function () {
                if (!this.isResultVisible) {
                    if (o(this.callbacks.onBeforeOpen)) {
                        var e = this.callbacks.onBeforeOpen(this.nodes);
                        if (a(e) && !e) return !1;
                    }
                    return this.nodes.result.classList.add(this.classes.visibleVariant), this.nodes.input.setAttribute("aria-expanded", !0), (this.isResultVisible = !0), !o(this.callbacks.onOpen) || this.callbacks.onOpen(this.nodes) || !0;
                }
            }),
            (s.prototype.close = function () {
                if (!this.isResultVisible) return !0;
                if (o(this.callbacks.onBeforeClose)) {
                    var e = this.callbacks.onBeforeClose(this.nodes);
                    if (a(e) && !e) return !1;
                }
                return (
                    this.nodes && this.nodes.result.classList.remove(this.classes.visibleVariant),
                    this.nodes.input.setAttribute("aria-expanded", !1),
                    this._clearAriaActiveDescendant(),
                    this._setKeyword(""),
                    o(this.callbacks.onClose) && this.callbacks.onClose(this.nodes),
                    (this.isResultVisible = !1),
                    (this.results = {}),
                    !0
                );
            }),
            (s.prototype.destroy = function () {
                if ((this.close(), o(this.callbacks.onBeforeDestroy))) {
                    var e,
                        t = this.callbacks.onBeforeDestroy(this.nodes);
                    if (a(t) && !t) return !1;
                }
                return (
                    this.nodes.result.classList.remove(this.classes.visibleVariant),
                    (e = this.nodes.input).removeAttribute("autocorrect", "off"),
                    e.removeAttribute("autocomplete", "off"),
                    e.removeAttribute("autocapitalize", "off"),
                    e.removeAttribute("spellcheck", "false"),
                    this._removeInputEventListeners(),
                    this._removeBodyEventListener(),
                    this._removeAccessibilityAnnouncer(),
                    this._removeClearButtonEventListener(),
                    o(this.callbacks.onDestroy) && this.callbacks.onDestroy(this.nodes),
                    !0
                );
            }),
            (s.prototype.clearAndClose = function () {
                (this.nodes.input.value = ""), this.close();
            }),
            s
        );
    })(Shopify.theme.PredictiveSearch)),
    (window.theme = window.theme || {}),
    (theme.TouchEvents = function e(t, s) {
        this.axis,
            (this.checkEvents = []),
            (this.eventHandlers = {}),
            (this.eventModel = {}),
            (this.events = [
                ["touchstart", "touchmove", "touchend", "touchcancel"],
                ["pointerdown", "pointermove", "pointerup", "pointercancel"],
                ["mousedown", "mousemove", "mouseup"],
            ]),
            this.eventType,
            (this.difference = {}),
            this.direction,
            (this.start = {}),
            (this.element = t),
            (this.options = Object.assign({}, { dragThreshold: 10, start: function () {}, move: function () {}, end: function () {} }, s)),
            (this.checkEvents = this._getCheckEvents()),
            (this.eventModel = this._getEventModel()),
            this._setupEventHandlers();
    }),
    (theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
        destroy: function () {
            this.element.removeEventListener("dragstart", this.eventHandlers.preventDefault),
                this.element.removeEventListener(this.events[this.eventModel][0], this.eventHandlers.touchStart),
                this.eventModel || this.element.removeEventListener(this.events[2][0], this.eventHandlers.touchStart),
                this.element.removeEventListener("click", this.eventHandlers.preventClick);
        },
        _setupEventHandlers: function () {
            (this.eventHandlers.preventDefault = this._preventDefault.bind(this)),
                (this.eventHandlers.preventClick = this._preventClick.bind(this)),
                (this.eventHandlers.touchStart = this._touchStart.bind(this)),
                (this.eventHandlers.touchMove = this._touchMove.bind(this)),
                (this.eventHandlers.touchEnd = this._touchEnd.bind(this)),
                this.element.addEventListener("dragstart", this.eventHandlers.preventDefault),
                this.element.addEventListener(this.events[this.eventModel][0], this.eventHandlers.touchStart),
                this.eventModel || this.element.addEventListener(this.events[2][0], this.eventHandlers.touchStart),
                this.element.addEventListener("click", this.eventHandlers.preventClick);
        },
        _touchStart: function (e) {
            (this.eventType = this.eventModel),
                "mousedown" !== e.type || this.eventModel || (this.eventType = 2),
                this.checkEvents[this.eventType](e) ||
                    (this.eventType && this._preventDefault(e),
                    document.addEventListener(this.events[this.eventType][1], this.eventHandlers.touchMove),
                    document.addEventListener(this.events[this.eventType][2], this.eventHandlers.touchEnd),
                    this.eventType < 2 && document.addEventListener(this.events[this.eventType][3], this.eventHandlers.touchEnd),
                    (this.start = { xPosition: this.eventType ? e.clientX : e.touches[0].clientX, yPosition: this.eventType ? e.clientY : e.touches[0].clientY, time: new Date().getTime() }),
                    Object.keys(this.difference).forEach(
                        function (e) {
                            delete this.difference[e];
                        }.bind(this)
                    ),
                    this.options.start(e));
        },
        _touchMove: function (e) {
            (this.difference = this._getDifference(e)),
                (document["on" + this.events[this.eventType][1]] = function (e) {
                    this._preventDefault(e);
                }.bind(this)),
                this.axis
                    ? "xPosition" === this.axis
                        ? (this.direction = this.difference.xPosition < 0 ? "left" : "right")
                        : "yPosition" === this.axis && (this.direction = this.difference.yPosition < 0 ? "up" : "down")
                    : this.options.dragThreshold < Math.abs(this.difference.xPosition)
                    ? (this.axis = "xPosition")
                    : this.options.dragThreshold < Math.abs(this.difference.yPosition)
                    ? (this.axis = "yPosition")
                    : (this.axis = !1),
                this.options.move(e, this.direction, this.difference);
        },
        _touchEnd: function (e) {
            document.removeEventListener(this.events[this.eventType][1], this.eventHandlers.touchMove),
                document.removeEventListener(this.events[this.eventType][2], this.eventHandlers.touchEnd),
                this.eventType < 2 && document.removeEventListener(this.events[this.eventType][3], this.eventHandlers.touchEnd),
                (document["on" + this.events[this.eventType][1]] = function () {
                    return !0;
                }),
                this.options.end(e, this.direction, this.difference),
                (this.axis = !1);
        },
        _getDifference: function (e) {
            return {
                xPosition: (this.eventType ? e.clientX : e.touches[0].clientX) - this.start.xPosition,
                yPosition: (this.eventType ? e.clientY : e.touches[0].clientY) - this.start.yPosition,
                time: new Date().getTime() - this.start.time,
            };
        },
        _getCheckEvents: function () {
            return [
                function (e) {
                    return (e.touches && e.touches.length > 1) || (e.scale && 1 !== e.scale);
                },
                function (e) {
                    return !e.isPrimary || (e.buttons && 1 !== e.buttons) || ("touch" !== e.pointerType && "pen" !== e.pointerType);
                },
                function (e) {
                    return e.buttons && 1 !== e.buttons;
                },
            ];
        },
        _getEventModel: function () {
            return window.navigator.pointerEnabled ? 1 : 0;
        },
        _preventDefault: function (e) {
            e.preventDefault ? e.preventDefault() : (e.returnValue = !1);
        },
        _preventClick: function (e) {
            Math.abs(this.difference.xPosition) > this.options.dragThreshold && this._preventDefault(e);
        },
    })),
    (theme.Drawers = (function () {
        function e(e, t, s) {
            var r = "js-drawer-open";
            if (
                ((this.nodes = { parents: [document.documentElement, document.body], page: document.getElementById("PageContainer") }),
                (this.eventHandlers = {}),
                (this.config = Object.assign({}, { selectors: { openVariant: "." + r + "-" + t, close: ".js-drawer-close" }, classes: { open: r, openVariant: r + "-" + t }, withPredictiveSearch: !1 }, s)),
                (this.position = t),
                (this.drawer = document.getElementById(e)),
                !this.drawer)
            )
                return !1;
            (this.drawerIsOpen = !1), this.init();
        }
        return (
            (e.prototype.init = function () {
                document.querySelector(this.config.selectors.openVariant).addEventListener("click", this.open.bind(this)), this.drawer.querySelector(this.config.selectors.close).addEventListener("click", this.close.bind(this));
            }),
            (e.prototype.open = function (e) {
                var t = !1;
                if ((e ? e.preventDefault() : (t = !0), e && e.stopPropagation && (e.stopPropagation(), (this.activeSource = e.currentTarget)), this.drawerIsOpen && !t)) return this.close();
                this.config.withPredictiveSearch || theme.Helpers.prepareTransition(this.drawer),
                    this.nodes.parents.forEach(
                        function (e) {
                            e.classList.add(this.config.classes.open, this.config.classes.openVariant);
                        }.bind(this)
                    ),
                    (this.drawerIsOpen = !0),
                    this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !t && this.config.onDrawerOpen(),
                    this.activeSource && this.activeSource.hasAttribute("aria-expanded") && this.activeSource.setAttribute("aria-expanded", "true");
                var s = { container: this.drawer };
                return this.config.elementToFocusOnOpen && (s.elementToFocus = this.config.elementToFocusOnOpen), slate.a11y.trapFocus(s), this.bindEvents(), this;
            }),
            (e.prototype.close = function () {
                this.drawerIsOpen &&
                    (document.activeElement.dispatchEvent(new CustomEvent("blur", { bubbles: !0, cancelable: !0 })),
                    this.config.withPredictiveSearch || theme.Helpers.prepareTransition(this.drawer),
                    this.nodes.parents.forEach(
                        function (e) {
                            e.classList.remove(this.config.classes.open, this.config.classes.openVariant);
                        }.bind(this)
                    ),
                    this.activeSource && this.activeSource.hasAttribute("aria-expanded") && this.activeSource.setAttribute("aria-expanded", "false"),
                    (this.drawerIsOpen = !1),
                    slate.a11y.removeTrapFocus({ container: this.drawer }),
                    this.unbindEvents(),
                    this.config.onDrawerClose && "function" == typeof this.config.onDrawerClose && this.config.onDrawerClose());
            }),
            (e.prototype.bindEvents = function () {
                (this.eventHandlers.drawerKeyupHandler = function (e) {
                    return 27 !== e.keyCode || (this.close(), !1);
                }.bind(this)),
                    (this.eventHandlers.drawerTouchmoveHandler = function () {
                        return !1;
                    }),
                    (this.eventHandlers.drawerClickHandler = function () {
                        return this.close(), !1;
                    }.bind(this)),
                    document.body.addEventListener("keyup", this.eventHandlers.drawerKeyupHandler),
                    this.nodes.page.addEventListener("touchmove", this.eventHandlers.drawerTouchmoveHandler),
                    this.nodes.page.addEventListener("click", this.eventHandlers.drawerClickHandler);
            }),
            (e.prototype.unbindEvents = function () {
                this.nodes.page.removeEventListener("touchmove", this.eventHandlers.drawerTouchmoveHandler),
                    this.nodes.page.removeEventListener("click", this.eventHandlers.drawerClickHandler),
                    document.body.removeEventListener("keyup", this.eventHandlers.drawerKeyupHandler);
            }),
            e
        );
    })()),
    (theme.Helpers = (function () {
        var e = !1,
            t = { preventScrolling: "prevent-scrolling" },
            s = window.pageYOffset;
        function r() {
            return e;
        }
        return {
            setTouch: function t() {
                e = !0;
            },
            isTouch: r,
            enableScrollLock: function e() {
                (s = window.pageYOffset), (document.body.style.top = "-" + s + "px"), document.body.classList.add(t.preventScrolling);
            },
            disableScrollLock: function e() {
                document.body.classList.remove(t.preventScrolling), document.body.style.removeProperty("top"), window.scrollTo(0, s);
            },
            debounce: function e(t, s, r) {
                var n;
                return function () {
                    var e = this,
                        a = arguments,
                        o = function () {
                            (n = null), r || t.apply(e, a);
                        },
                        c = r && !n;
                    clearTimeout(n), (n = setTimeout(o, s)), c && t.apply(e, a);
                };
            },
            getScript: function e(t, s) {
                return new Promise(function (e, r) {
                    var n = document.createElement("script"),
                        a = s || document.getElementsByTagName("script")[0];
                    function o(t, s) {
                        (s || !n.readyState || /loaded|complete/.test(n.readyState)) && ((n.onload = null), (n.onreadystatechange = null), (n = void 0), s ? r() : e());
                    }
                    (n.async = !0), (n.defer = !0), (n.onload = o), (n.onreadystatechange = o), (n.src = t), a.parentNode.insertBefore(n, a);
                });
            },
            prepareTransition: function e(t) {
                t.addEventListener(
                    "transitionend",
                    function (e) {
                        e.currentTarget.classList.remove("is-transitioning");
                    },
                    { once: !0 }
                );
                var s = 0;
                ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"].forEach(function (e) {
                    var r = getComputedStyle(t)[e];
                    r && (r.replace(/\D/g, ""), s || (s = parseFloat(r)));
                }),
                    0 !== s && (t.classList.add("is-transitioning"), t.offsetWidth);
            },
            serialize: /*!
             * Serialize all form data into a SearchParams string
             * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
             * @param  {Node}   form The form to serialize
             * @return {String}      The serialized form data
             */ function e(t) {
                var s = [];
                return (
                    Array.prototype.slice.call(t.elements).forEach(function (e) {
                        if (!(!e.name || e.disabled || ["file", "reset", "submit", "button"].indexOf(e.type) > -1)) {
                            if ("select-multiple" === e.type) {
                                Array.prototype.slice.call(e.options).forEach(function (t) {
                                    t.selected && s.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(t.value));
                                });
                                return;
                            }
                            (!(["checkbox", "radio"].indexOf(e.type) > -1) || e.checked) && s.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value));
                        }
                    }),
                    s.join("&")
                );
            },
            cookiesEnabled: function e() {
                var t = navigator.cookieEnabled;
                return t || ((document.cookie = "testcookie"), (t = -1 !== document.cookie.indexOf("testcookie"))), t;
            },
            promiseStylesheet: function e(t) {
                var s = t || theme.stylesheet;
                return (
                    void 0 === this.stylesheetPromise &&
                        (this.stylesheetPromise = new Promise(function (e) {
                            var t = document.querySelector('link[href="' + s + '"]');
                            t.loaded && e(),
                                t.addEventListener("load", function () {
                                    setTimeout(e, 0);
                                });
                        })),
                    this.stylesheetPromise
                );
            },
        };
    })()),
    (theme.LibraryLoader = (function () {
        var e = { link: "link", script: "script" },
            t = { requested: "requested", loaded: "loaded" },
            s = "https://cdn.shopify.com/shopifycloud/",
            r = {
                youtubeSdk: { tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: e.script },
                plyrShopifyStyles: { tagId: "plyr-shopify-styles", src: s + "shopify-plyr/v1.0/shopify-plyr.css", type: e.link },
                modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: s + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: e.link },
            };
        return {
            load: function s(n, a) {
                var o,
                    c = r[n];
                if (c && c.status !== t.requested) {
                    if (((a = a || function () {}), c.status === t.loaded)) {
                        a();
                        return;
                    }
                    switch (((c.status = t.requested), c.type)) {
                        case e.script:
                            o =
                                ((l = c),
                                (d = a),
                                (u = document.createElement("script")),
                                (u.src = l.src),
                                u.addEventListener("load", function () {
                                    (l.status = t.loaded), d();
                                }),
                                u);
                            break;
                        case e.link:
                            o =
                                ((h = c),
                                (p = a),
                                (m = document.createElement("link")),
                                (m.href = h.src),
                                (m.rel = "stylesheet"),
                                (m.type = "text/css"),
                                m.addEventListener("load", function () {
                                    (h.status = t.loaded), p();
                                }),
                                m);
                    }
                    (o.id = c.tagId), (c.element = o);
                    var l,
                        d,
                        u,
                        h,
                        p,
                        m,
                        v = document.getElementsByTagName(c.type)[0];
                    v.parentNode.insertBefore(o, v);
                }
            },
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.Header = (function () {
        var e = {
                body: "body",
                navigation: "#AccessibleNav",
                siteNavHasDropdown: "[data-has-dropdowns]",
                siteNavChildLinks: ".site-nav__child-link",
                siteNavActiveDropdown: ".site-nav--active-dropdown",
                siteNavHasCenteredDropdown: ".site-nav--has-centered-dropdown",
                siteNavCenteredDropdown: ".site-nav__dropdown--centered",
                siteNavLinkMain: ".site-nav__link--main",
                siteNavChildLink: ".site-nav__link--last",
                siteNavDropdown: ".site-nav__dropdown",
                siteHeader: ".site-header",
            },
            t = { activeClass: "site-nav--active-dropdown", childLinkClass: "site-nav__child-link", rightDropdownClass: "site-nav__dropdown--right", leftDropdownClass: "site-nav__dropdown--left" },
            s = {};
        function r(e) {
            e.stopImmediatePropagation();
        }
        function n() {
            s.activeDropdown &&
                (s.activeDropdown.querySelector(e.siteNavLinkMain).setAttribute("aria-expanded", "false"),
                s.activeDropdown.classList.remove(t.activeClass),
                (s.activeDropdown = document.querySelector(e.siteNavActiveDropdown)),
                window.removeEventListener("keyup", c),
                document.body.removeEventListener("click", n));
        }
        function a(r) {
            r.forEach(function (r) {
                var n,
                    a,
                    o,
                    c,
                    l = r.querySelector(e.siteNavDropdown);
                l &&
                    (((n = r), (a = n.getBoundingClientRect()), (o = n.ownerDocument.defaultView), a.left + o.pageXOffset > Math.floor(s.siteHeader.offsetWidth) / 2)
                        ? (l.classList.remove(t.leftDropdownClass), l.classList.add(t.rightDropdownClass))
                        : (l.classList.remove(t.rightDropdownClass), l.classList.add(t.leftDropdownClass)));
            });
        }
        function o() {
            document.querySelectorAll(e.siteNavHasCenteredDropdown).forEach(function (t) {
                var s = t.querySelector(e.siteNavCenteredDropdown),
                    r = t.offsetTop + 41;
                s.style.top = r + "px";
            });
        }
        function c(e) {
            27 === e.keyCode && n();
        }
        function l() {
            h();
        }
        function d(r) {
            var a,
                o = r.currentTarget;
            o.classList.contains(t.activeClass)
                ? n()
                : ((a = o).classList.add(t.activeClass),
                  s.activeDropdown && n(),
                  (s.activeDropdown = a),
                  a.querySelector(e.siteNavLinkMain).setAttribute("aria-expanded", "true"),
                  setTimeout(function () {
                      window.addEventListener("keyup", c), document.body.addEventListener("click", n);
                  }, 250));
        }
        function u() {
            setTimeout(function () {
                !document.activeElement.classList.contains(t.childLinkClass) && s.activeDropdown && n();
            });
        }
        var h = theme.Helpers.debounce(function () {
            a(document.querySelectorAll(e.siteNavHasDropdown)), o();
        }, 50);
        return {
            init: function t() {
                var c;
                (s = {
                    nav: (c = document.querySelector(e.navigation)),
                    topLevel: document.querySelectorAll(e.siteNavLinkMain),
                    parents: c.querySelectorAll(e.siteNavHasDropdown),
                    subMenuLinks: document.querySelectorAll(e.siteNavChildLinks),
                    activeDropdown: document.querySelector(e.siteNavActiveDropdown),
                    siteHeader: document.querySelector(e.siteHeader),
                    siteNavChildLink: document.querySelectorAll(e.siteNavChildLink),
                }),
                    a(document.querySelectorAll(e.siteNavHasDropdown)),
                    o(),
                    s.parents.forEach(function (e) {
                        e.addEventListener("click", d);
                    }),
                    s.siteNavChildLink.forEach(function (e) {
                        e.addEventListener("focusout", u);
                    }),
                    s.topLevel.forEach(function (e) {
                        e.addEventListener("focus", n);
                    }),
                    s.subMenuLinks.forEach(function (e) {
                        e.addEventListener("click", r);
                    }),
                    window.addEventListener("resize", l);
            },
            unload: function e() {
                s.topLevel.forEach(function (e) {
                    e.removeEventListener("focus", n);
                }),
                    s.subMenuLinks.forEach(function (e) {
                        e.removeEventListener("click", r);
                    }),
                    s.parents.forEach(function (e) {
                        e.removeEventListener("click", d);
                    }),
                    s.siteNavChildLink.forEach(function (e) {
                        e.removeEventListener("focusout", u);
                    }),
                    window.removeEventListener("resize", l),
                    window.removeEventListener("keyup", c),
                    document.body.removeEventListener("click", n);
            },
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.MobileNav = (function () {
        var e,
            t,
            s,
            r = {
                mobileNavOpenIcon: "mobile-nav--open",
                mobileNavCloseIcon: "mobile-nav--close",
                navLinkWrapper: "mobile-nav__item",
                navLink: "mobile-nav__link",
                subNavLink: "mobile-nav__sublist-link",
                return: "mobile-nav__return-btn",
                subNavActive: "is-active",
                subNavClosing: "is-closing",
                navOpen: "js-menu--is-open",
                subNavShowing: "sub-nav--is-open",
                thirdNavShowing: "third-nav--is-open",
                subNavToggleBtn: "js-toggle-submenu",
            },
            n = {},
            a = 1,
            o = "(min-width: " + theme.breakpoints.medium + "px)",
            c = window.matchMedia(o);
        function l() {
            c.matches && n.mobileNavContainer.classList.contains(r.navOpen) && h();
        }
        function d() {
            var e;
            n.mobileNavToggle.classList.contains(r.mobileNavCloseIcon)
                ? h()
                : ((e = n.siteHeader.offsetHeight),
                  theme.Helpers.prepareTransition(n.mobileNavContainer),
                  n.mobileNavContainer.classList.add(r.navOpen),
                  (n.mobileNavContainer.style.transform = "translateY(" + e + "px)"),
                  (n.pageContainer.style.transform = "translate3d(0, " + n.mobileNavContainer.scrollHeight + "px, 0)"),
                  slate.a11y.trapFocus({ container: n.sectionHeader, elementToFocus: n.mobileNavToggle }),
                  n.mobileNavToggle.classList.add(r.mobileNavCloseIcon),
                  n.mobileNavToggle.classList.remove(r.mobileNavOpenIcon),
                  n.mobileNavToggle.setAttribute("aria-expanded", !0),
                  window.addEventListener("keyup", u));
        }
        function u(e) {
            27 === e.which && h();
        }
        function h() {
            theme.Helpers.prepareTransition(n.mobileNavContainer),
                n.mobileNavContainer.classList.remove(r.navOpen),
                (n.mobileNavContainer.style.transform = "translateY(-100%)"),
                n.pageContainer.setAttribute("style", ""),
                slate.a11y.trapFocus({ container: document.querySelector("html"), elementToFocus: document.body }),
                n.mobileNavContainer.addEventListener("transitionend", p, { once: !0 }),
                n.mobileNavToggle.classList.add(r.mobileNavOpenIcon),
                n.mobileNavToggle.classList.remove(r.mobileNavCloseIcon),
                n.mobileNavToggle.setAttribute("aria-expanded", !1),
                n.mobileNavToggle.focus(),
                window.removeEventListener("keyup", u),
                window.scrollTo(0, 0);
        }
        function p() {
            slate.a11y.removeTrapFocus({ container: n.mobileNav });
        }
        function m(o) {
            if (!e) {
                var c,
                    l = o.currentTarget;
                ((e = !0), l.classList.contains(r.return))
                    ? (document.querySelectorAll("." + r.subNavToggleBtn + "[data-level='" + (a - 1) + "']").forEach(function (e) {
                          e.classList.remove(r.subNavActive);
                      }),
                      s && s.classList.remove(r.subNavActive))
                    : l.classList.add(r.subNavActive),
                    (s = l),
                    (function s(o) {
                        var c = o ? document.querySelector('.mobile-nav__dropdown[data-parent="' + o + '"]') : n.mobileNav;
                        (a = c.dataset.level ? Number(c.dataset.level) : 1), t && (theme.Helpers.prepareTransition(t), t.classList.add(r.subNavClosing)), (t = c);
                        var l = c.offsetHeight,
                            d = a > 2 ? r.thirdNavShowing : r.subNavShowing;
                        (n.mobileNavContainer.style.height = l + "px"),
                            n.mobileNavContainer.classList.remove(r.thirdNavShowing),
                            n.mobileNavContainer.classList.add(d),
                            o || n.mobileNavContainer.classList.remove(r.thirdNavShowing, r.subNavShowing);
                        var u = 1 === a ? n.sectionHeader : c;
                        function h() {
                            slate.a11y.trapFocus({ container: u }), n.mobileNavContainer.removeEventListener("transitionend", h), (e = !1);
                        }
                        n.mobileNavContainer.addEventListener("transitionend", h, { once: !0 }), (n.pageContainer.style.transform = "translateY(" + l + "px)"), t.classList.remove(r.subNavClosing);
                    })(l.getAttribute("data-target"));
            }
        }
        return {
            init: function e() {
                (n = {
                    pageContainer: document.querySelector("#PageContainer"),
                    siteHeader: document.querySelector(".site-header"),
                    mobileNavToggle: document.querySelector(".js-mobile-nav-toggle"),
                    mobileNavContainer: document.querySelector(".mobile-nav-wrapper"),
                    mobileNav: document.querySelector("#MobileNav"),
                    sectionHeader: document.querySelector("#shopify-section-header"),
                    subNavToggleBtns: document.querySelectorAll("." + r.subNavToggleBtn),
                }),
                    n.mobileNavToggle && n.mobileNavToggle.addEventListener("click", d),
                    n.subNavToggleBtns.forEach(function (e) {
                        e.addEventListener("click", m);
                    }),
                    c.addListener(l);
            },
            unload: function e() {
                c.removeListener(l);
            },
            closeMobileNav: h,
        };
    })()),
    (window.Modals = (function () {
        function e(e, t, s) {
            if (((this.modal = document.getElementById(e)), !this.modal)) return !1;
            (this.nodes = { parents: [document.querySelector("html"), document.body] }),
                (this.config = Object.assign({ close: ".js-modal-close", open: ".js-modal-open-" + t, openClass: "modal--is-active", closeModalOnClick: !1 }, s)),
                (this.modalIsOpen = !1),
                (this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal),
                (this.openElement = document.querySelector(this.config.open)),
                this.init();
        }
        return (
            (e.prototype.init = function () {
                this.openElement.addEventListener("click", this.open.bind(this)), this.modal.querySelector(this.config.close).addEventListener("click", this.closeModal.bind(this));
            }),
            (e.prototype.open = function (e) {
                var t = this,
                    s = !1;
                this.modalIsOpen ||
                    (e ? e.preventDefault() : (s = !0),
                    e && e.stopPropagation && e.stopPropagation(),
                    this.modalIsOpen && !s && this.closeModal(),
                    this.modal.classList.add(this.config.openClass),
                    this.nodes.parents.forEach(function (e) {
                        e.classList.add(t.config.openClass);
                    }),
                    (this.modalIsOpen = !0),
                    slate.a11y.trapFocus({ container: this.modal, elementToFocus: this.focusOnOpen }),
                    this.bindEvents());
            }),
            (e.prototype.closeModal = function () {
                if (this.modalIsOpen) {
                    document.activeElement.blur(), this.modal.classList.remove(this.config.openClass);
                    var e = this;
                    this.nodes.parents.forEach(function (t) {
                        t.classList.remove(e.config.openClass);
                    }),
                        (this.modalIsOpen = !1),
                        slate.a11y.removeTrapFocus({ container: this.modal }),
                        this.openElement.focus(),
                        this.unbindEvents();
                }
            }),
            (e.prototype.bindEvents = function () {
                (this.keyupHandler = this.keyupHandler.bind(this)), (this.clickHandler = this.clickHandler.bind(this)), document.body.addEventListener("keyup", this.keyupHandler), document.body.addEventListener("click", this.clickHandler);
            }),
            (e.prototype.unbindEvents = function () {
                document.body.removeEventListener("keyup", this.keyupHandler), document.body.removeEventListener("click", this.clickHandler);
            }),
            (e.prototype.keyupHandler = function (e) {
                27 === e.keyCode && this.closeModal();
            }),
            (e.prototype.clickHandler = function (e) {
                this.config.closeModalOnClick && !this.modal.contains(e.target) && this.closeModal();
            }),
            e
        );
    })()),
    (function () {
        var e = document.querySelector(".return-link");
        function t(e) {
            var t = document.createElement("a");
            return (t.ref = e), t.hostname;
        }
        document.referrer &&
            e &&
            window.history.length &&
            e.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    var s = t(document.referrer);
                    return t(window.location.href) === s && history.back(), !1;
                },
                { once: !0 }
            );
    })(),
    (theme.Slideshow = (function () {
        var e = {
                button: "[data-slider-button]",
                indicator: "[data-slider-indicator]",
                indicators: "[data-slider-indicators]",
                pause: "[data-slider-pause]",
                slider: "[data-slider]",
                sliderItem: "[data-slider-item]",
                sliderItemLink: "[data-slider-item-link]",
                sliderTrack: "[data-slider-track]",
                sliderContainer: "[data-slider-container]",
            },
            t = { isPaused: "slideshow__pause--is-paused", indicator: "slider-indicators__item", indicatorActive: "slick-active", sliderInitialized: "slick-initialized", slideActive: "slideshow__slide--active", slideClone: "slick-cloned" },
            s = { buttonNext: "data-slider-button-next" };
        function r(s, r) {
            (this.container = s),
                (this.slider = this.container.querySelector(e.slider)),
                this.slider &&
                    ((this.eventHandlers = {}),
                    (this.lastSlide = 0),
                    (this.slideIndex = 0),
                    (this.sliderContainer = null),
                    (this.slides = []),
                    (this.options = Object.assign({}, { autoplay: !1, canUseKeyboardArrows: !0, canUseTouchEvents: !1, slideActiveClass: t.slideActive, slideInterval: 0, slidesToShow: 0, slidesToScroll: 1, type: "fade" }, r)),
                    (this.sliderContainer = this.slider.querySelector(e.sliderContainer)),
                    (this.adaptHeight = "true" === this.sliderContainer.getAttribute("data-adapt-height")),
                    (this.slides = Array.from(this.sliderContainer.querySelectorAll(e.sliderItem))),
                    (this.lastSlide = this.slides.length - 1),
                    (this.buttons = this.container.querySelectorAll(e.button)),
                    (this.pause = this.container.querySelector(e.pause)),
                    (this.indicators = this.container.querySelectorAll(e.indicators)),
                    this.slides.length <= 1 ||
                        ((this.timeout = 250),
                        this.options.autoplay && this.startAutoplay(),
                        this.adaptHeight && this.setSlideshowHeight(),
                        "slide" === this.options.type
                            ? ((this.isFirstSlide = !1),
                              (this.isLastSlide = !1),
                              (this.sliderItemWidthTotal = 0),
                              (this.sliderTrack = this.slider.querySelector(e.sliderTrack)),
                              (this.sliderItemWidthTotal = 0),
                              theme.Helpers.promiseStylesheet().then(
                                  function () {
                                      this._setupSlideType();
                                  }.bind(this)
                              ))
                            : this.setupSlider(0),
                        this._setupEventHandlers()));
        }
        return (
            (r.prototype = Object.assign({}, r.prototype, {
                previousSlide: function () {
                    this._move();
                },
                nextSlide: function () {
                    this._move("next");
                },
                setSlide: function (e) {
                    this._setPosition(Number(e));
                },
                startAutoplay: function () {
                    (this.isAutoPlaying = !0),
                        window.clearTimeout(this.autoTimeOut),
                        (this.autoTimeOut = window.setTimeout(
                            function () {
                                var e = this._getNextSlideIndex("next");
                                this._setPosition(e);
                            }.bind(this),
                            this.options.slideInterval
                        ));
                },
                stopAutoplay: function () {
                    (this.isAutoPlaying = !1), window.clearTimeout(this.autoTimeOut);
                },
                setupSlider: function (e) {
                    (this.slideIndex = e), this.indicators.length && this._setActiveIndicator(e), this._setupActiveSlide(e);
                },
                destroy: function () {
                    this.adaptHeight && window.removeEventListener("resize", this.eventHandlers.debounceResize),
                        this.container.removeEventListener("focus", this.eventHandlers.focus, !0),
                        this.slider.removeEventListener("focusin", this.eventHandlers.focusIn, !0),
                        this.slider.removeEventListener("focusout", this.eventHandlers.focusOut, !0),
                        this.container.removeEventListener("blur", this.eventHandlers.blur, !0),
                        this.buttons &&
                            this.buttons.forEach(
                                function (e) {
                                    e.removeEventListener("click", this.eventHandlers.clickButton);
                                }.bind(this)
                            ),
                        this.indicators.forEach(function (e) {
                            e.childNodes.forEach(function (e) {
                                e.firstElementChild.removeEventListener("click", this.eventHandlers.onClickIndicator), e.firstElementChild.removeEventListener("keydown", this.eventHandlers.onKeydownIndicator);
                            }, this);
                        }, this),
                        "slide" === this.options.type &&
                            (window.removeEventListener("resize", this.eventHandlers.debounceResizeSlideIn), this.touchEvents && this.options.canUseTouchEvents && (this.touchEvents.destroy(), (this.touchEvents = null)));
                },
                _setupEventHandlers: function () {
                    (this.eventHandlers.focus = this._onFocus.bind(this)),
                        (this.eventHandlers.focusIn = this._onFocusIn.bind(this)),
                        (this.eventHandlers.focusOut = this._onFocusOut.bind(this)),
                        (this.eventHandlers.blur = this._onBlur.bind(this)),
                        (this.eventHandlers.keyUp = this._onKeyUp.bind(this)),
                        (this.eventHandlers.clickButton = this._onClickButton.bind(this)),
                        (this.eventHandlers.onClickIndicator = this._onClickIndicator.bind(this)),
                        (this.eventHandlers.onKeydownIndicator = this._onKeydownIndicator.bind(this)),
                        (this.eventHandlers.onClickPause = this._onClickPause.bind(this)),
                        this.adaptHeight &&
                            ((this.eventHandlers.debounceResize = theme.Helpers.debounce(
                                function () {
                                    this.setSlideshowHeight();
                                }.bind(this),
                                50
                            )),
                            window.addEventListener("resize", this.eventHandlers.debounceResize)),
                        this.container.addEventListener("focus", this.eventHandlers.focus, !0),
                        this.slider.addEventListener("focusin", this.eventHandlers.focusIn, !0),
                        this.slider.addEventListener("focusout", this.eventHandlers.focusOut, !0),
                        this.container.addEventListener("blur", this.eventHandlers.blur, !0),
                        this.buttons &&
                            this.buttons.forEach(
                                function (e) {
                                    e.addEventListener("click", this.eventHandlers.clickButton);
                                }.bind(this)
                            ),
                        this.pause && this.pause.addEventListener("click", this.eventHandlers.onClickPause),
                        this.indicators.forEach(function (e) {
                            e.childNodes.forEach(function (e) {
                                e.firstElementChild.addEventListener("click", this.eventHandlers.onClickIndicator), e.firstElementChild.addEventListener("keydown", this.eventHandlers.onKeydownIndicator);
                            }, this);
                        }, this),
                        "slide" === this.options.type &&
                            ((this.eventHandlers.debounceResizeSlideIn = theme.Helpers.debounce(
                                function () {
                                    (this.sliderItemWidthTotal = 0), this._setupSlideType(!0);
                                }.bind(this),
                                50
                            )),
                            window.addEventListener("resize", this.eventHandlers.debounceResizeSlideIn),
                            this.options.canUseTouchEvents && this.options.slidesToScroll < this.slides.length && this._setupTouchEvents());
                },
                _setupTouchEvents: function () {
                    this.touchEvents = new theme.TouchEvents(this.sliderTrack, {
                        start: function () {
                            this._onTouchStart();
                        }.bind(this),
                        move: function (e, t, s) {
                            this._onTouchMove(e, t, s);
                        }.bind(this),
                        end: function (e, t, s) {
                            this._onTouchEnd(e, t, s);
                        }.bind(this),
                    });
                },
                _setupSlideType: function (s) {
                    (this.sliderItemWidth = Math.floor(this.sliderContainer.offsetWidth / this.options.slidesToShow)),
                        (this.sliderTranslateXMove = this.sliderItemWidth * this.options.slidesToScroll),
                        s || this.sliderContainer.classList.add(t.sliderInitialized),
                        this.slides.forEach(function (t, s) {
                            var r = t.querySelector(e.sliderItemLink);
                            (t.style.width = this.sliderItemWidth + "px"),
                                t.setAttribute("aria-hidden", !0),
                                t.setAttribute("tabindex", -1),
                                (this.sliderItemWidthTotal = this.sliderItemWidthTotal + t.offsetWidth),
                                r && r.setAttribute("tabindex", -1),
                                s < this.options.slidesToShow && (t.setAttribute("aria-hidden", !1), t.classList.add(this.options.slideActiveClass), r && r.setAttribute("tabindex", 0));
                        }, this),
                        (this.sliderTrack.style.width = Math.floor(this.sliderItemWidthTotal) + "px"),
                        (this.sliderTrack.style.transform = "translateX(-0px)"),
                        this.buttons.length && (this.buttons[0].setAttribute("aria-disabled", !0), this.buttons[1].removeAttribute("aria-disabled")),
                        this.indicators.length && this._setActiveIndicator(0);
                },
                _onTouchStart: function () {
                    this.touchStartPosition = this._getTranslateXPosition();
                },
                _onTouchMove: function (e, t, s) {
                    if (Shopify.designMode && (e.clientX <= 80 || e.clientX >= window.innerWidth - 80)) {
                        e.target.dispatchEvent(new MouseEvent("mouseup", { bubbles: !0, cancelable: !0 }));
                        return;
                    }
                    ("left" === t || "right" === t) && ((this.touchMovePosition = this.touchStartPosition + s.xPosition), (this.sliderTrack.style.transform = "translateX(" + this.touchMovePosition + "px"));
                },
                _onTouchEnd: function (e, t, s) {
                    var r = 0;
                    0 !== Object.keys(s).length &&
                        ("left" === t
                            ? (r = this._isNextTranslateXLast(this.touchStartPosition) ? this.touchStartPosition : this.touchStartPosition - this.sliderTranslateXMove)
                            : ((r = this.touchStartPosition + this.sliderTranslateXMove), this._isNextTranslateXFirst(this.touchStartPosition) && (r = 0)),
                        (this.slideIndex = this._getNextSlideIndex("left" === t ? "next" : "")),
                        (this.sliderTrack.style.transition = "transform 500ms ease 0s"),
                        (this.sliderTrack.style.transform = "translateX(" + r + "px"),
                        window.setTimeout(
                            function () {
                                this.sliderTrack.style.transition = "";
                            }.bind(this),
                            500
                        ),
                        this._verifyFirstLastSlideTranslateX(r),
                        this._postTransitionEnd());
                },
                _onClickButton: function (e) {
                    if (!(e.detail > 1)) {
                        var t = e.currentTarget,
                            r = t.hasAttribute(s.buttonNext);
                        ("slide" !== this.options.type || "true" !== t.getAttribute("aria-disabled")) && (this.options.autoplay && this.isAutoPlaying && this.stopAutoplay(), r ? this.nextSlide() : this.previousSlide());
                    }
                },
                _onClickIndicator: function (e) {
                    e.preventDefault(),
                        e.target.classList.contains(t.indicatorActive) ||
                            (this.options.autoplay && this.isAutoPlaying && this.stopAutoplay(), (this.slideIndex = Number(e.target.dataset.slideNumber)), this.goToSlideByIndex(this.slideIndex));
                },
                goToSlideByIndex: function (e) {
                    if ((this._setPosition(e), "slide" === this.options.type && this.sliderTrack)) {
                        this.sliderTrack.style.transition = "transform 500ms ease 0s";
                        var t = e * this.slides[0].offsetWidth;
                        (this.sliderTrack.style.transform = "translateX(-" + t + "px)"),
                            this.options.slidesToShow > 1 && (this._verifyFirstLastSlideTranslateX(t), this.buttons.length && this._disableArrows(), this._setupMultipleActiveSlide(e, e + (this.options.slidesToShow - 1)));
                    }
                },
                _onKeydownIndicator: function (e) {
                    e.keyCode === slate.utils.keyboardKeys.ENTER && (this._onClickIndicator(e), this.slider.focus());
                },
                _onClickPause: function (e) {
                    e.currentTarget.classList.contains(t.isPaused) ? (e.currentTarget.classList.remove(t.isPaused), this.startAutoplay()) : (e.currentTarget.classList.add(t.isPaused), this.stopAutoplay());
                },
                _onFocus: function () {
                    this.container.addEventListener("keyup", this.eventHandlers.keyUp);
                },
                _onFocusIn: function () {
                    this.slider.hasAttribute("aria-live") || (this.options.autoplay && this.isAutoPlaying && this.stopAutoplay(), this.slider.setAttribute("aria-live", "polite"));
                },
                _onBlur: function () {
                    this.container.removeEventListener("keyup", this.eventHandlers.keyUp);
                },
                _onFocusOut: function () {
                    this.slider.removeAttribute("aria-live"),
                        setTimeout(
                            function () {
                                document.activeElement.closest("#" + this.slider.getAttribute("id")) || !this.options.autoplay || this.isAutoPlaying || this.pause.classList.contains(t.isPaused) || this.startAutoplay();
                            }.bind(this),
                            this.timeout
                        );
                },
                _onKeyUp: function (e) {
                    switch (e.keyCode) {
                        case slate.utils.keyboardKeys.LEFTARROW:
                            if (!this.options.canUseKeyboardArrows || ("slide" === this.options.type && this.isFirstSlide)) return;
                            this.previousSlide();
                            break;
                        case slate.utils.keyboardKeys.RIGHTARROW:
                            if (!this.options.canUseKeyboardArrows || ("slide" === this.options.type && this.isLastSlide)) return;
                            this.nextSlide();
                            break;
                        case slate.utils.keyboardKeys.ESCAPE:
                            this.slider.blur();
                    }
                },
                _move: function (e) {
                    if ("slide" === this.options.type) (this.slideIndex = this._getNextSlideIndex(e)), this._moveSlideshow(e);
                    else {
                        var t = this._getNextSlideIndex(e);
                        this._setPosition(t);
                    }
                },
                _moveSlideshow: function (e) {
                    this.direction = e;
                    var t = 0,
                        s = this._getTranslateXPosition(),
                        r = this._getActiveSlidesIndex(),
                        n = Math.min.apply(Math, r),
                        a = Math.max.apply(Math, r);
                    (this.nextMinIndex = "next" === e ? n + this.options.slidesToShow : n - this.options.slidesToShow),
                        (this.nextMaxIndex = "next" === e ? a + this.options.slidesToShow : n - 1),
                        (this.sliderTrack.style.transition = "transform 500ms ease 0s"),
                        "next" === e
                            ? ((t = s - this.sliderTranslateXMove), (this.sliderTrack.style.transform = "translateX(" + t + "px)"))
                            : ((t = s + this.sliderTranslateXMove), (this.sliderTrack.style.transform = "translateX(" + t + "px)")),
                        this._verifyFirstLastSlideTranslateX(t),
                        this._postTransitionEnd(),
                        this._setupMultipleActiveSlide(this.nextMinIndex, this.nextMaxIndex);
                },
                _setPosition: function (e) {
                    (this.slideIndex = e),
                        this.indicators.length && this._setActiveIndicator(e),
                        this._setupActiveSlide(e),
                        this.options.autoplay && this.isAutoPlaying && this.startAutoplay(),
                        this.container.dispatchEvent(new CustomEvent("slider_slide_changed", { detail: e }));
                },
                _setupActiveSlide: function (e) {
                    this.slides.forEach(function (e) {
                        e.setAttribute("aria-hidden", !0), e.classList.remove(this.options.slideActiveClass);
                    }, this),
                        this.slides[e].setAttribute("aria-hidden", !1),
                        this.slides[e].classList.add(this.options.slideActiveClass);
                },
                _setupMultipleActiveSlide: function (t, s) {
                    this.slides.forEach(function (r) {
                        var n = Number(r.getAttribute("data-slider-slide-index")),
                            a = r.querySelector(e.sliderItemLink);
                        r.setAttribute("aria-hidden", !0),
                            r.classList.remove(this.options.slideActiveClass),
                            a && a.setAttribute("tabindex", -1),
                            n >= t && n <= s && (r.setAttribute("aria-hidden", !1), r.classList.add(this.options.slideActiveClass), a && a.setAttribute("tabindex", 0));
                    }, this);
                },
                _setActiveIndicator: function (e) {
                    this.indicators.forEach(function (s) {
                        var r = s.querySelector("." + t.indicatorActive),
                            n = s.childNodes[e];
                        r && (r.setAttribute("aria-selected", !1), r.classList.remove(t.indicatorActive), r.firstElementChild.removeAttribute("aria-current")),
                            n.classList.add(t.indicatorActive),
                            n.setAttribute("aria-selected", !0),
                            n.firstElementChild.setAttribute("aria-current", !0);
                    }, this);
                },
                setSlideshowHeight: function () {
                    var e = this.sliderContainer.getAttribute("data-min-aspect-ratio");
                    this.sliderContainer.style.height = document.documentElement.offsetWidth / e + "px";
                },
                _getNextSlideIndex: function (e) {
                    if ("next" === e) {
                        if (this.slideIndex === this.lastSlide) return "slide" === this.options.type ? this.lastSlide : 0;
                    } else if (!this.slideIndex) return "slide" === this.options.type ? 0 : this.lastSlide;
                    return this.slideIndex + ("next" === e ? 1 : -1);
                },
                _getActiveSlidesIndex: function () {
                    return this.slides
                        .filter(function (e) {
                            if (e.classList.contains(this.options.slideActiveClass)) return e;
                        }, this)
                        .map(function (e) {
                            return Number(e.getAttribute("data-slider-slide-index"));
                        });
                },
                _disableArrows: function () {
                    if (0 !== this.buttons.length) {
                        var e = this.buttons[0],
                            t = this.buttons[1];
                        this.isFirstSlide ? e.setAttribute("aria-disabled", !0) : e.removeAttribute("aria-disabled"), this.isLastSlide ? t.setAttribute("aria-disabled", !0) : t.removeAttribute("aria-disabled");
                    }
                },
                _verifyFirstLastSlideTranslateX: function (e) {
                    this._isNextTranslateXFirst(e) ? (this.isFirstSlide = !0) : (this.isFirstSlide = !1), this._isNextTranslateXLast(e) ? (this.isLastSlide = !0) : (this.isLastSlide = !1);
                },
                _getTranslateXPosition: function () {
                    return Number(this.sliderTrack.style.transform.match(/(-?[0-9]+)/g)[0]);
                },
                _isNextTranslateXFirst: function (e) {
                    return 0 === e;
                },
                _isNextTranslateXLast: function (e) {
                    return Math.abs(e) + this.sliderTranslateXMove >= this.sliderItemWidthTotal;
                },
                _postTransitionEnd: function () {
                    this.buttons.length && this._disableArrows(), this.indicators.length && this._setActiveIndicator(this.slideIndex);
                },
            })),
            r
        );
    })()),
    (theme.Video = (function () {
        var e = !1,
            t = !1,
            s = !1,
            r = !1,
            n = {},
            a = [],
            o = {
                ratio: 16 / 9,
                scrollAnimationDuration: 400,
                playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
                events: {
                    onReady: function e(t) {
                        t.target.setPlaybackQuality("hd1080");
                        var s,
                            r,
                            n,
                            a,
                            o,
                            d,
                            u,
                            p,
                            v = g(t),
                            f = t.target.getVideoData().title;
                        m(),
                            document.getElementById(v.id).setAttribute("tabindex", "-1"),
                            L(),
                            (s = v.videoWrapper),
                            (r = f),
                            (n = s.querySelectorAll(l.playVideoBtn)),
                            (a = s.querySelector(l.closeVideoBtn)),
                            (o = s.querySelector(l.pauseVideoBtn)),
                            (d = a.querySelector(l.fallbackText)),
                            (u = o.querySelector(l.pauseVideoStop).querySelector(l.fallbackText)),
                            (p = o.querySelector(l.pauseVideoResume).querySelector(l.fallbackText)),
                            n.forEach(function (e) {
                                var t = e.querySelector(l.fallbackText);
                                t.textContent = t.textContent.replace("[video_title]", r);
                            }),
                            (d.textContent = d.textContent.replace("[video_title]", r)),
                            (u.textContent = u.textContent.replace("[video_title]", r)),
                            (p.textContent = p.textContent.replace("[video_title]", r)),
                            "background" === v.type && (t.target.mute(), h(v.id)),
                            v.videoWrapper.classList.add(c.loaded);
                    },
                    onStateChange: function t(s) {
                        var r = g(s);
                        switch (("background" !== r.status || C() || e || (s.data !== YT.PlayerState.PLAYING && s.data !== YT.PlayerState.BUFFERING) || (p(!0), (e = !0), r.videoWrapper.classList.remove(c.loading)), s.data)) {
                            case YT.PlayerState.ENDED:
                                (function e(t) {
                                    switch (t.type) {
                                        case "background":
                                            a[t.id].seekTo(0);
                                            break;
                                        case "image_with_play":
                                            y(t.id), b(t.id, !1);
                                    }
                                })(r);
                                break;
                            case YT.PlayerState.PAUSED:
                                setTimeout(function () {
                                    s.target.getPlayerState() === YT.PlayerState.PAUSED && f(r);
                                }, 200);
                        }
                    },
                },
            },
            c = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                backgroundVideoWrapper: "video-background-wrapper",
                videoWithImage: "video--image_with_play",
                backgroundVideo: "video--background",
                userPaused: "is-paused",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay",
                wrapperMinHeight: "video-section-wrapper--min-height",
            },
            l = {
                section: ".video-section",
                videoWrapper: ".video-section-wrapper",
                playVideoBtn: ".video-control__play",
                closeVideoBtn: ".video-control__close-wrapper",
                pauseVideoBtn: ".video__pause",
                pauseVideoStop: ".video__pause-stop",
                pauseVideoResume: ".video__pause-resume",
                fallbackText: ".icon__fallback-text",
            };
        function d(e) {
            (t || s) && e && "function" == typeof a[e].playVideo && h(e);
        }
        function u(e) {
            a[e] && "function" == typeof a[e].pauseVideo && a[e].pauseVideo();
        }
        function h(t, r) {
            var o = n[t],
                l = a[t],
                d = o.videoWrapper;
            if (s) v(o);
            else if (r || e) {
                d.classList.remove(c.loading), v(o), l.playVideo();
                return;
            } else l.playVideo();
        }
        function p(t) {
            var r = t ? c.supportsAutoplay : c.supportsNoAutoplay;
            document.documentElement.classList.remove(c.supportsAutoplay, c.supportsNoAutoplay), document.documentElement.classList.add(r), t || (s = !0), (e = !0);
        }
        function m() {
            !t && (C() && (s = !0), s && p(!1), (t = !0));
        }
        function v(e) {
            var t = e.videoWrapper,
                s = t.querySelector(l.pauseVideoBtn);
            t.classList.remove(c.loading),
                s.classList.contains(c.userPaused) && s.classList.remove(c.userPaused),
                "background" !== e.status &&
                    (document.getElementById(e.id).setAttribute("tabindex", "0"),
                    "image_with_play" === e.type && (t.classList.remove(c.paused), t.classList.add(c.playing)),
                    setTimeout(function () {
                        t.querySelector(l.closeVideoBtn).focus();
                    }, o.scrollAnimationDuration));
        }
        function f(e) {
            var t = e.videoWrapper;
            "image_with_play" === e.type && ("closed" === e.status ? t.classList.remove(c.paused) : t.classList.add(c.paused)), t.classList.remove(c.playing);
        }
        function y(e) {
            var t,
                s,
                r = n[e],
                o = r.videoWrapper;
            switch ((document.getElementById(r.id).setAttribute("tabindex", "-1"), (r.status = "closed"), r.type)) {
                case "image_with_play":
                    a[e].stopVideo(), f(r);
                    break;
                case "background":
                    a[e].mute(),
                        (t = e),
                        (s = document.getElementById(t)).classList.remove(c.videoWithImage),
                        s.classList.add(c.backgroundVideo),
                        n[t].videoWrapper.classList.add(c.backgroundVideoWrapper),
                        (n[t].status = "background"),
                        E(s);
            }
            o.classList.remove(c.paused, c.playing);
        }
        function g(e) {
            return n[e.target.getIframe().id];
        }
        function b(e, t) {
            var s = n[e],
                r = s.videoWrapper.getBoundingClientRect().top + window.pageYOffset,
                a = s.videoWrapper.querySelector(l.playVideoBtn),
                d = 0,
                u = 0;
            if ((C() && s.videoWrapper.parentElement.classList.toggle("page-width", !t), t)) {
                if (
                    ((u = C() ? window.innerWidth / o.ratio : s.videoWrapper.offsetWidth / o.ratio),
                    (d = (window.innerHeight - u) / 2),
                    (s.videoWrapper.style.height = s.videoWrapper.getBoundingClientRect().height + "px"),
                    s.videoWrapper.classList.remove(c.wrapperMinHeight),
                    (s.videoWrapper.style.height = u + "px"),
                    !(C() && Shopify.designMode))
                ) {
                    var h = document.documentElement.style.scrollBehavior;
                    (document.documentElement.style.scrollBehavior = "smooth"), window.scrollTo({ top: r - d }), (document.documentElement.style.scrollBehavior = h);
                }
            } else {
                (u = C() ? s.videoWrapper.dataset.mobileHeight : s.videoWrapper.dataset.desktopHeight),
                    (s.videoWrapper.style.height = u + "px"),
                    setTimeout(function () {
                        s.videoWrapper.classList.add(c.wrapperMinHeight);
                    }, 600);
                var p = window.scrollX,
                    m = window.scrollY;
                a.focus(), window.scrollTo(p, m);
            }
        }
        var S = function (e) {
            var t = document.activeElement.dataset.controls;
            e.keyCode === slate.utils.keyboardKeys.ESCAPE && t && (y(t), b(t, !1));
        };
        function L() {
            document.querySelectorAll("." + c.backgroundVideo).forEach(function (e) {
                E(e);
            });
        }
        function E(e) {
            if (r) {
                if (C()) e.style.cssText = null;
                else {
                    var t = e.closest(l.videoWrapper),
                        s = t.clientWidth,
                        n = e.clientWidth,
                        a = t.dataset.desktopHeight;
                    if (s / o.ratio < a) {
                        var d = "width: " + (n = Math.ceil(a * o.ratio)) + "px; height: " + a + "px; left: " + (s - n) / 2 + "px; top: 0;";
                        e.style.cssText = d;
                    } else {
                        a = Math.ceil(s / o.ratio);
                        var u = "width: " + s + "px; height: " + a + "px; top: " + (a - a) / 2 + "px; left: 0;";
                        e.style.cssText = u;
                    }
                    theme.Helpers.prepareTransition(e), t.classList.add(c.loaded);
                }
            }
        }
        function C() {
            return window.innerWidth < theme.breakpoints.medium;
        }
        var T = theme.Helpers.debounce(function () {
                if (r) {
                    var e,
                        t = window.innerHeight === screen.height;
                    if ((L(), C())) {
                        for (e in n) n.hasOwnProperty(e) && (n[e].videoWrapper.classList.contains(c.playing) && !t && (u(e), f(n[e])), (n[e].videoWrapper.style.height = document.documentElement.clientWidth / o.ratio + "px"));
                        p(!1);
                    } else for (e in (p(!0), n)) !n[e].videoWrapper.querySelectorAll("." + c.videoWithImage).length && (a[e].playVideo(), v(n[e]));
                }
            }, 200),
            A = theme.Helpers.debounce(function () {
                if (r) {
                    for (var e in n)
                        if (n.hasOwnProperty(e)) {
                            var t = n[e].videoWrapper,
                                s =
                                    t.getBoundingClientRect().top + window.pageYOffset + 0.75 * t.offsetHeight < window.pageYOffset ||
                                    t.getBoundingClientRect().top + window.pageYOffset + 0.25 * t.offsetHeight > window.pageYOffset + window.innerHeight;
                            if (t.classList.contains(c.playing)) {
                                if (!s) return;
                                y(e), b(e, !1);
                            }
                        }
                }
            }, 50);
        function P() {
            var e = document.querySelectorAll(l.playVideoBtn),
                t = document.querySelectorAll(l.closeVideoBtn),
                s = document.querySelectorAll(l.pauseVideoBtn);
            e.forEach(function (e) {
                e.addEventListener("click", function (e) {
                    !(function e(t) {
                        var s,
                            r,
                            o = n[t];
                        switch ((o.videoWrapper.classList.add(c.loading), (o.videoWrapper.style.height = o.videoWrapper.offsetHeight + "px"), (o.status = "open"), o.type)) {
                            case "image_with_play":
                                h(t, !0);
                                break;
                            case "background":
                                (s = t),
                                    (r = document.getElementById(s)).classList.remove(c.backgroundVideo),
                                    r.classList.add(c.videoWithImage),
                                    setTimeout(function () {
                                        document.getElementById(s).style.cssText = null;
                                    }, 600),
                                    n[s].videoWrapper.classList.remove(c.backgroundVideoWrapper),
                                    n[s].videoWrapper.classList.add(c.playing),
                                    (n[s].status = "open"),
                                    a[t].unMute(),
                                    h(t, !0);
                        }
                        b(t, !0), document.addEventListener("keydown", S);
                    })(e.currentTarget.dataset.controls);
                });
            }),
                t.forEach(function (e) {
                    e.addEventListener("click", function (e) {
                        var t = e.currentTarget.dataset.controls;
                        e.currentTarget.blur(), y(t), b(t, !1);
                    });
                }),
                s.forEach(function (e) {
                    e.addEventListener("click", function (e) {
                        var t, s, r;
                        (r = (s = n[(t = e.currentTarget.dataset.controls)].videoWrapper.querySelector(l.pauseVideoBtn)).classList.contains(c.userPaused)) ? (s.classList.remove(c.userPaused), d(t)) : (s.classList.add(c.userPaused), u(t)),
                            s.setAttribute("aria-pressed", !r);
                    });
                }),
                window.addEventListener("resize", T),
                window.addEventListener("scroll", A);
        }
        function I(e) {
            var t = Object.assign(o, n[e]);
            (t.playerVars.controls = t.controls), (a[e] = new YT.Player(e, t));
        }
        return {
            init: function e(t) {
                if (t) {
                    if (
                        ((n[t.id] = {
                            id: t.id,
                            videoId: t.dataset.id,
                            type: t.dataset.type,
                            status: "image_with_play" === t.dataset.type ? "closed" : "background",
                            video: t,
                            videoWrapper: t.closest(l.videoWrapper),
                            section: t.closest(l.section),
                            controls: "background" === t.dataset.type ? 0 : 1,
                        }),
                        !r)
                    ) {
                        var s = document.createElement("script");
                        s.src = "https://www.youtube.com/iframe_api";
                        var a = document.getElementsByTagName("script")[0];
                        a.parentNode.insertBefore(s, a);
                    }
                    m();
                }
            },
            editorLoadVideo: function e(t) {
                r && (I(t), P());
            },
            loadVideos: function e() {
                for (var t in n) n.hasOwnProperty(t) && I(t);
                P(), (r = !0);
            },
            playVideo: d,
            pauseVideo: u,
            removeEvents: function e() {
                document.removeEventListener("keydown", S), window.removeEventListener("resize", T), window.removeEventListener("scroll", A);
            },
        };
    })()),
    (theme.ProductVideo = (function () {
        var e = {},
            t = { html5: "html5", youtube: "youtube" },
            s = { productMediaWrapper: "[data-product-single-media-wrapper]" },
            r = { enableVideoLooping: "enable-video-looping", videoId: "video-id" };
        function n(s) {
            if (s) {
                (function s() {
                    for (var r in e)
                        if (e.hasOwnProperty(r)) {
                            var n = e[r];
                            if (n.nativeVideo) continue;
                            n.host === t.html5 && (n.element.setAttribute("controls", "controls"), (n.nativeVideo = !0));
                        }
                })();
                return;
            }
            o(t.html5);
        }
        function a() {
            window.YT.Player && o(t.youtube);
        }
        function o(t) {
            for (var s in e)
                if (e.hasOwnProperty(s)) {
                    var r = e[s];
                    r.host === t && r.ready();
                }
        }
        return {
            init: function o(c, l) {
                if (c) {
                    var d = c.querySelector("iframe, video");
                    if (d) {
                        var u,
                            h = c.getAttribute("data-media-id");
                        e[h] = {
                            mediaId: h,
                            sectionId: l,
                            host: ((u = d), "VIDEO" === u.tagName ? t.html5 : "IFRAME" === u.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(u.src) ? t.youtube : null),
                            container: c,
                            element: d,
                            ready: function () {
                                (function e(n) {
                                    if (!n.player) {
                                        var a = n.container.closest(s.productMediaWrapper),
                                            o = a.getAttribute("data-" + r.enableVideoLooping);
                                        switch (n.host) {
                                            case t.html5:
                                                n.player = new Shopify.Plyr(n.element, { loop: { active: o } });
                                                break;
                                            case t.youtube:
                                                var c = a.getAttribute("data-" + r.videoId);
                                                n.player = new YT.Player(n.element, {
                                                    videoId: c,
                                                    events: {
                                                        onStateChange: function (e) {
                                                            0 === e.data && o && e.target.seekTo(0);
                                                        },
                                                    },
                                                });
                                        }
                                        var l = function () {
                                            n.player && (n.host === t.html5 && n.player.pause(), n.host === t.youtube && n.player.pauseVideo && n.player.pauseVideo());
                                        };
                                        a.addEventListener("mediaHidden", l),
                                            a.addEventListener("xrLaunch", l),
                                            a.addEventListener("mediaVisible", function () {
                                                !theme.Helpers.isTouch() && n.player && (n.host === t.html5 && n.player.play(), n.host === t.youtube && n.player.playVideo && n.player.playVideo());
                                            });
                                    }
                                })(this);
                            },
                        };
                        var p = e[h];
                        switch (p.host) {
                            case t.html5:
                                window.Shopify.loadFeatures([{ name: "video-ui", version: "1.0", onLoad: n }]), theme.LibraryLoader.load("plyrShopifyStyles");
                                break;
                            case t.youtube:
                                theme.LibraryLoader.load("youtubeSdk", a);
                        }
                    }
                }
            },
            hosts: t,
            loadVideos: o,
            removeSectionVideos: function t(s) {
                for (var r in e)
                    if (e.hasOwnProperty(r)) {
                        var n = e[r];
                        n.sectionId === s && (n.player && n.player.destroy(), delete e[r]);
                    }
            },
        };
    })()),
    (theme.ProductModel = (function () {
        var e = {},
            t = {},
            s = {},
            r = { mediaGroup: "[data-product-single-media-group]", xrButton: "[data-shopify-xr]" };
        function n(e) {
            if (!e) {
                for (var s in t)
                    if (t.hasOwnProperty(s)) {
                        var r = t[s];
                        r.modelViewerUi || (r.modelViewerUi = new Shopify.ModelViewerUI(r.element)), a(r);
                    }
            }
        }
        function a(e) {
            var t = s[e.sectionId];
            e.container.addEventListener("mediaVisible", function () {
                t.element.setAttribute("data-shopify-model3d-id", e.modelId), theme.Helpers.isTouch() || e.modelViewerUi.play();
            }),
                e.container.addEventListener("mediaHidden", function () {
                    t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
                }),
                e.container.addEventListener("xrLaunch", function () {
                    e.modelViewerUi.pause();
                });
        }
        return {
            init: function a(o, c) {
                (e[c] = { loaded: !1 }),
                    o.forEach(function (e, n) {
                        var a = e.getAttribute("data-media-id"),
                            o = e.querySelector("model-viewer"),
                            l = o.getAttribute("data-model-id");
                        if (0 === n) {
                            var d = e.closest(r.mediaGroup).querySelector(r.xrButton);
                            s[c] = { element: d, defaultId: l };
                        }
                        t[a] = { modelId: l, sectionId: c, container: e, element: o };
                    }),
                    window.Shopify.loadFeatures([
                        {
                            name: "shopify-xr",
                            version: "1.0",
                            onLoad: function t(s) {
                                if (!s) {
                                    if (!window.ShopifyXR) {
                                        document.addEventListener("shopify_xr_initialized", function () {
                                            t();
                                        });
                                        return;
                                    }
                                    for (var r in e)
                                        if (e.hasOwnProperty(r)) {
                                            var n = e[r];
                                            if (n.loaded) continue;
                                            var a = document.querySelector("#ModelJson-" + r);
                                            window.ShopifyXR.addModels(JSON.parse(a.innerHTML)), (n.loaded = !0);
                                        }
                                    window.ShopifyXR.setupXRElements();
                                }
                            },
                        },
                        { name: "model-viewer-ui", version: "1.0", onLoad: n },
                    ]),
                    theme.LibraryLoader.load("modelViewerUiStyles");
            },
            removeSectionModels: function s(r) {
                for (var n in t) t.hasOwnProperty(n) && t[n].sectionId === r && (t[n].modelViewerUi.destroy(), delete t[n]);
                delete e[r];
            },
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.FormStatus = (function () {
        var e = { statusMessage: "[data-form-status]" };
        return {
            init: function t() {
                document.querySelectorAll(e.statusMessage).forEach(function (e) {
                    e.setAttribute("tabindex", -1),
                        e.focus(),
                        e.addEventListener(
                            "blur",
                            function (e) {
                                e.target.removeAttribute("tabindex");
                            },
                            { once: !0 }
                        );
                });
            },
        };
    })()),
    (theme.Hero = (function () {
        var e = { indexSectionFlush: "index-section--flush" },
            t = { heroFixedWidthContent: ".hero-fixed-width__content", heroFixedWidthImage: ".hero-fixed-width__image" };
        return function s(r, n) {
            var a = document.querySelector(r).getAttribute("data-layout"),
                o = document.querySelector("#shopify-section-" + n),
                c = o.querySelector(t.heroFixedWidthContent),
                l = o.querySelector(t.heroFixedWidthImage);
            function d() {
                var e, t;
                c && (e = c.offsetHeight + 50), l && (t = l.offsetHeight), e > t && (l.style.minHeight = e + "px");
            }
            "fixed_width" === a &&
                (o.classList.remove(e.indexSectionFlush),
                d(),
                window.addEventListener("resize", function () {
                    theme.Helpers.debounce(function () {
                        d();
                    }, 50);
                }));
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.SearchResultsTemplate = (function () {
        function e() {
            return [theme.settings.predictiveSearchShowPrice, theme.settings.predictiveSearchShowVendor].reduce(function (e, t) {
                return e + (t ? 1 : 0);
            }, 0);
        }
        return function (t) {
            var s,
                r,
                n,
                a,
                o,
                c,
                l,
                d,
                u,
                h,
                p,
                m,
                v,
                f,
                y,
                g,
                b = t.products || [],
                S = t.collections || [],
                L = t.isLoading,
                E = t.searchQuery || "";
            if (L && 0 === b.length)
                return [
                    '<div class="predictive-search">',
                    '<div class="predictive-search-loading">',
                    '<span class="visually-hidden">' + theme.strings.loading + "</span>",
                    '<span class="predictive-search-loading__icon">',
                    '<span class="icon-predictive-search-spinner"></span>',
                    "</span>",
                    "</div>",
                    "</div>",
                ].join("");
            return (
                (v = b),
                (f = L),
                (y = E),
                [
                    "<div>",
                    '<div class="predictive-search collection">',
                    ((s = g = S),
                    (r = f),
                    0 === s.length
                        ? ""
                        : [
                              '<div class="predictive-search-title">',
                              '<h3 id="predictive-search" class="predictive-search-title__content">Categories</h3>',
                              '<span class="predictive-search-title__loading-spinner">' + (r ? '<span class= "icon-predictive-search-spinner" ></span >' : "") + "</span>",
                              "</div>",
                          ].join("")),
                    ((n = g),
                    (a = y),
                    (o = n.length),
                    [
                        '<ul id="predictive-search-results-collection" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
                        n
                            .map(function (e, t) {
                                var s, r, n, a, c;
                                return (
                                    (r = ((s = e), { url: s.url, image: s.featured_image, title: s.title, handle: s.handle })),
                                    (n = t),
                                    (a = o),
                                    [
                                        '<li id="search-result-' + n + '" class="predictive-search-item" role="option" data-search-result>',
                                        '<a class="predictive-search-item__link" href="' + r.url + '" tabindex="-1">',
                                        '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
                                        null === (c = r).image.url
                                            ? '<img class="predictive-search-item__image lazyload" src="https://eu.ui-avatars.com/api/?size=250&name=' +
                                              c.title +
                                              '" data-src="https://eu.ui-avatars.com/api/?size=250&name=' +
                                              c.title +
                                              '" data-image alt="' +
                                              c.image.alt +
                                              '" />'
                                            : '<img class="predictive-search-item__image lazyload" src="' + c.image.url + '" data-src="' + c.image.url + '" data-image alt="' + c.image.alt + '" />',
                                        "</div>",
                                        '<span class="predictive-search-item__title-text">' + r.title + "</span>",
                                        "</a>",
                                        "</li>",
                                    ].join("")
                                );
                            })
                            .join(""),
                        "</ul>",
                    ].join("")),
                    "</div>",
                    '<div class="predictive-search">',
                    ((c = v),
                    (l = f),
                    0 === c.length
                        ? ""
                        : [
                              '<div class="predictive-search-title">',
                              '<h3 id="predictive-search" class="predictive-search-title__content">' + theme.strings.products + "</h3>",
                              '<span class="predictive-search-title__loading-spinner">' + (l ? '<span class= "icon-predictive-search-spinner" ></span >' : "") + "</span>",
                              "</div>",
                          ].join("")),
                    ((d = v),
                    (u = y),
                    (h = d.length),
                    [
                        '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
                        d
                            .map(function (t, s) {
                                var r, n, a, o, c, l, d, u, p, m, v, f, y, g, b;
                                return (
                                    (u =
                                        ((r = t),
                                        {
                                            url: (r.variants.length > 0 ? r.variants[0] : r).url,
                                            image:
                                                ((n = r),
                                                n.variants.length > 0 && null !== n.variants[0].image ? (o = n.variants[0].featured_image) : n.image ? (o = n.featured_image) : (a = null),
                                                null !== a && (a = { url: theme.Images.getSizedImageUrl(o.url, "100x"), alt: o.alt }),
                                                a),
                                            title: r.title,
                                            vendor: r.vendor || "",
                                            price: theme.Currency.formatMoney(r.price_min, theme.moneyFormat),
                                            compareAtPrice: theme.Currency.formatMoney(r.compare_at_price_min, theme.moneyFormat),
                                            available: r.available,
                                            isOnSale: ((c = r), null !== c.compare_at_price_min && parseInt(c.compare_at_price_min, 10) > parseInt(c.price_min, 10)),
                                            isPriceVaries: ((l = r), l.price_max !== l.price_min),
                                            isCompareVaries: ((d = r), d.compare_at_price_max !== d.compare_at_price_min),
                                        })),
                                    (p = s),
                                    (m = h),
                                    [
                                        '<li id="search-result-' + p + '" class="predictive-search-item" role="option" data-search-result>',
                                        '<a class="predictive-search-item__link" href="' + u.url + '" tabindex="-1">',
                                        '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
                                        ((v = u), null === v.image ? "" : '<img class="predictive-search-item__image lazyload" src="' + v.image.url + '" data-src="' + v.image.url + '" data-image alt="' + v.image.alt + '" />'),
                                        "</div>",
                                        '<div class="predictive-search__column predictive-search__column--content ' + (e() ? "" : "predictive-search__column--center") + '">',
                                        '<span class="predictive-search-item__title">',
                                        '<span class="predictive-search-item__title-text">' + u.title + "</span>",
                                        "</span>" +
                                            (e()
                                                ? ((f = u),
                                                  [
                                                      '<dl class="predictive-search-item__details price' +
                                                          (f.isOnSale ? " price--on-sale" : "") +
                                                          (f.available ? "" : " price--sold-out") +
                                                          (!f.isPriceVaries && f.isCompareVaries ? " price--compare-price-hidden" : "") +
                                                          '">',
                                                      '<div class="predictive-search-item__detail">',
                                                      ((y = f),
                                                      theme.settings.predictiveSearchShowVendor && "" !== y.vendor
                                                          ? ["<dt>", '<span class="visually-hidden">' + theme.strings.vendor + "</span>", "</dt>", '<dd class="predictive-search-item__vendor">' + y.vendor + "</dd>"].join("")
                                                          : ""),
                                                      "</div>",
                                                      '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
                                                          (function e(t) {
                                                              if (!theme.settings.predictiveSearchShowPrice) return "";
                                                              var s,
                                                                  r,
                                                                  n,
                                                                  a =
                                                                      '<div class="price__regular">' +
                                                                      ((s = t),
                                                                      [
                                                                          "<dt>",
                                                                          '<span class="visually-hidden">' + theme.strings.regularPrice + "</span>",
                                                                          "</dt>",
                                                                          "<dd>",
                                                                          '<span class="predictive-search-item__price">' + (s.isPriceVaries ? theme.strings.fromLowestPrice.replace("[price]", s.price) : s.price) + "</span>",
                                                                          "</dd>",
                                                                      ].join("")) +
                                                                      "</div>",
                                                                  o =
                                                                      '<div class="price__sale">' +
                                                                      ((r = t),
                                                                      [
                                                                          "<dt>",
                                                                          '<span class="visually-hidden">' + theme.strings.salePrice + "</span>",
                                                                          "</dt>",
                                                                          "<dd>",
                                                                          '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
                                                                              (r.isPriceVaries ? theme.strings.fromLowestPrice.replace("[price]", r.price) : r.price) +
                                                                              "</span>",
                                                                          "</dd>",
                                                                          '<div class="price__compare">' +
                                                                              ((n = r),
                                                                              [
                                                                                  "<dt>",
                                                                                  '<span class="visually-hidden">' + theme.strings.regularPrice + "</span> ",
                                                                                  "</dt>",
                                                                                  "<dd>",
                                                                                  '<span class="predictive-search-item__price predictive-search-item__price--compare">' + n.compareAtPrice + "</span>",
                                                                                  "</dd>",
                                                                              ].join("")) +
                                                                              "</div>",
                                                                      ].join("")) +
                                                                      "</div>";
                                                              return '<span class="visually-hidden">, </span><div class="price__pricing-group">' + (t.isOnSale ? o : a) + "</div>";
                                                          })(f),
                                                      "</div>",
                                                      "</dl>",
                                                  ].join(""))
                                                : ""),
                                        '<span class="visually-hidden">, </span>',
                                        '<span class="visually-hidden">' + ((g = p + 1), (b = m), theme.strings.number_of_results.replace("[result_number]", g).replace("[results_count]", b)) + "</span>",
                                        "</div>",
                                        "</a>",
                                        "</li>",
                                    ].join("")
                                );
                            })
                            .join(""),
                        "</ul>",
                    ].join("")),
                    "</div>",
                    "</div>",
                    '<div class="predictive-search-view-all">',
                    ((p = y),
                    [
                        '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
                        theme.strings.searchFor +
                            '<span class="predictive-search-view-all__query"> &ldquo;' +
                            ((m = p), m.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")) +
                            "&rdquo;</span>",
                        "</button>",
                    ].join("")),
                    "</div>",
                ].join("")
            );
        };
    })()),
    (window.theme = window.theme || {}),
    (function () {
        var e, t, s, r;
        function n(e) {
            return 1 === e.products.length ? theme.strings.one_result_found : theme.strings.number_of_results_found.replace("[results_count]", e.products.length);
        }
        function a() {
            return theme.strings.loading;
        }
        function o(e, t) {
            t.addEventListener("click", c.bind(this, e));
        }
        function c(e, t) {
            0 === e.value.trim().length && (void 0 !== t && t.preventDefault(), e.focus());
        }
        (window.theme.SearchPage =
            ((t = {
                searchReset: "[data-search-page-predictive-search-clear]",
                searchInput: "[data-search-page-predictive-search-input]",
                searchSubmit: "[data-search-page-predictive-search-submit]",
                searchResults: '[data-predictive-search-mount="default"]',
            }),
            {
                init: function s(r) {
                    var c = document.querySelector(t.searchInput),
                        l = document.querySelector(t.searchSubmit),
                        d = c.dataset.baseUrl;
                    (e = new window.Shopify.theme.PredictiveSearchComponent({
                        selectors: { input: t.searchInput, reset: t.searchReset, result: t.searchResults },
                        searchUrl: d,
                        resultTemplateFct: window.theme.SearchResultsTemplate,
                        numberOfResultsTemplateFct: n,
                        loadingResultsMessageTemplateFct: a,
                        onOpen: function (e) {
                            if (!r.isTabletAndUp) {
                                var t,
                                    s = c.getBoundingClientRect(),
                                    n = document.body.offsetHeight - s.bottom - 50;
                                e.result.style.maxHeight = n + "px";
                            }
                        },
                        onBeforeDestroy: function (e) {
                            e.result.style.maxHeight = "";
                        },
                    })),
                        o(c, l);
                },
                unload: function t() {
                    e && (e.destroy(), (e = null));
                },
            })),
            (window.theme.SearchHeader =
                ((r = { searchInput: "[data-predictive-search-drawer-input]", searchResults: '[data-predictive-search-mount="drawer"]', searchFormContainer: "[data-search-form-container]", searchSubmit: "[data-search-form-submit]" }),
                {
                    init: function e(t) {
                        var c = document.querySelector(r.searchInput),
                            l = document.querySelector(r.searchSubmit),
                            d = c.dataset.baseUrl;
                        (s = new window.Shopify.theme.PredictiveSearchComponent({
                            selectors: { input: r.searchInput, result: r.searchResults },
                            searchUrl: d,
                            resultTemplateFct: window.theme.SearchResultsTemplate,
                            numberOfResultsTemplateFct: n,
                            numberOfResults: t.numberOfResults,
                            loadingResultsMessageTemplateFct: a,
                            onInputBlur: function () {
                                return !1;
                            },
                            onOpen: function (e) {
                                var s = c.getBoundingClientRect(),
                                    r = window.innerHeight - s.bottom - (t.isTabletAndUp ? 20 : 0);
                                (e.result.style.top = t.isTabletAndUp ? "" : s.bottom + "px"), (e.result.style.maxHeight = r + "px");
                            },
                            onClose: function (e) {
                                e.result.style.maxHeight = "";
                            },
                            onBeforeDestroy: function (e) {
                                e.result.style.top = "";
                            },
                        })),
                            o(c, l);
                    },
                    unload: function e() {
                        s && (s.destroy(), (s = null));
                    },
                    clearAndClose: function e() {
                        s && s.clearAndClose();
                    },
                })),
            (window.theme.Search = (function () {
                var e = { searchTemplate: "template-search" },
                    t = { siteHeader: ".site-header" },
                    s = { mobile: window.matchMedia("(max-width: 749px)"), tabletAndUp: window.matchMedia("(min-width: 750px)") };
                function r() {
                    theme.SearchDrawer.close(),
                        theme.SearchHeader.unload(),
                        theme.SearchPage.unload(),
                        s.mobile.matches
                            ? (theme.SearchHeader.init({ numberOfResults: 4, isTabletAndUp: !1 }), n() && theme.SearchPage.init({ isTabletAndUp: !1 }))
                            : (theme.SearchHeader.init({ numberOfResults: 4, isTabletAndUp: !0 }), n() && theme.SearchPage.init({ isTabletAndUp: !0 }));
                }
                function n() {
                    return document.body.classList.contains(e.searchTemplate);
                }
                return {
                    init: function e() {
                        if (document.querySelector(t.siteHeader))
                            JSON.parse(document.getElementById("shopify-features").textContent).predictiveSearch &&
                                window.theme.settings.predictiveSearchEnabled &&
                                (Object.keys(s).forEach(function (e) {
                                    s[e].addListener(r);
                                }),
                                r());
                    },
                    unload: function e() {
                        theme.SearchHeader.unload(), theme.SearchPage.unload();
                    },
                };
            })());
    })(),
    (window.theme = window.theme || {}),
    (theme.SearchDrawer = (function () {
        var e,
            t = {
                headerSection: "[data-header-section]",
                drawer: "[data-predictive-search-drawer]",
                drawerOpenButton: "[data-predictive-search-open-drawer]",
                headerSearchInput: "[data-predictive-search-drawer-input]",
                predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]',
            };
        return {
            init: function s() {
                var r;
                (r = document.querySelector(t.drawerOpenButton)) && (r.setAttribute("aria-controls", "SearchDrawer"), r.setAttribute("aria-expanded", "false"), r.setAttribute("aria-controls", "dialog")),
                    (e = new theme.Drawers("SearchDrawer", "top", {
                        onDrawerOpen: function () {
                            document.querySelector(t.drawer), document.querySelector(t.headerSection).offsetHeight, theme.MobileNav.closeMobileNav(), theme.Helpers.enableScrollLock();
                        },
                        onDrawerClose: function () {
                            theme.SearchHeader.clearAndClose();
                            var e = document.querySelector(t.drawerOpenButton);
                            e && e.focus(), theme.Helpers.disableScrollLock();
                        },
                        withPredictiveSearch: !0,
                        elementToFocusOnOpen: document.querySelector(t.headerSearchInput),
                    }));
            },
            close: function t() {
                try {
                    e.close();
                } catch (s) {
                    console.log(s);
                }
            },
        };
    })()),
    (theme.Disclosure = (function () {
        var e = { disclosureForm: "[data-disclosure-form]", disclosureList: "[data-disclosure-list]", disclosureToggle: "[data-disclosure-toggle]", disclosureInput: "[data-disclosure-input]", disclosureOptions: "[data-disclosure-option]" },
            t = { listVisible: "disclosure-list--visible" };
        function s(e) {
            (this.container = e), this._cacheSelectors(), this._setupListeners();
        }
        return (
            (s.prototype = Object.assign({}, s.prototype, {
                _cacheSelectors: function () {
                    this.cache = {
                        disclosureForm: this.container.closest(e.disclosureForm),
                        disclosureList: this.container.querySelector(e.disclosureList),
                        disclosureToggle: this.container.querySelector(e.disclosureToggle),
                        disclosureInput: this.container.querySelector(e.disclosureInput),
                        disclosureOptions: this.container.querySelectorAll(e.disclosureOptions),
                    };
                },
                _setupListeners: function () {
                    (this.eventHandlers = this._setupEventHandlers()),
                        this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (e) {
                            e.addEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                },
                _setupEventHandlers: function () {
                    return {
                        connectOptions: this._connectOptions.bind(this),
                        toggleList: this._toggleList.bind(this),
                        onBodyClick: this._onBodyClick.bind(this),
                        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                    };
                },
                _connectOptions: function (e) {
                    e.preventDefault(), this._submitForm(e.currentTarget.dataset.value);
                },
                _onDisclosureToggleFocusOut: function (e) {
                    !1 === this.container.contains(e.relatedTarget) && this._hideList();
                },
                _onDisclosureListFocusOut: function (e) {
                    var s = e.currentTarget.contains(e.relatedTarget);
                    this.cache.disclosureList.classList.contains(t.listVisible) && !s && this._hideList();
                },
                _onDisclosureKeyUp: function (e) {
                    e.which === slate.utils.keyboardKeys.ESCAPE && (this._hideList(), this.cache.disclosureToggle.focus());
                },
                _onBodyClick: function (e) {
                    var s = this.container.contains(e.target);
                    this.cache.disclosureList.classList.contains(t.listVisible) && !s && this._hideList();
                },
                _submitForm: function (e) {
                    (this.cache.disclosureInput.value = e), this.cache.disclosureForm.submit();
                },
                _hideList: function () {
                    this.cache.disclosureList.classList.remove(t.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                },
                _toggleList: function () {
                    var e = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                    this.cache.disclosureList.classList.toggle(t.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
                },
                destroy: function () {
                    this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (e) {
                            e.removeEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                },
            })),
            s
        );
    })()),
    (theme.Zoom = (function () {
        var e = { imageZoom: "[data-image-zoom]" },
            t = { zoomImg: "zoomImg" },
            s = { imageZoomTarget: "data-image-zoom-target" };
        function r(e) {
            (this.container = e), (this.cache = {}), (this.url = e.dataset.zoom), this._cacheSelectors(), this.cache.sourceImage && this._duplicateImage();
        }
        return (
            (r.prototype = Object.assign({}, r.prototype, {
                _cacheSelectors: function () {
                    this.cache = { sourceImage: this.container.querySelector(e.imageZoom) };
                },
                _init: function () {
                    var e = this.cache.targetImage.width,
                        t = this.cache.targetImage.height;
                    this.cache.sourceImage === this.cache.targetImage ? ((this.sourceWidth = e), (this.sourceHeight = t)) : ((this.sourceWidth = this.cache.sourceImage.width), (this.sourceHeight = this.cache.sourceImage.height)),
                        (this.xRatio = (this.cache.sourceImage.width - e) / this.sourceWidth),
                        (this.yRatio = (this.cache.sourceImage.height - t) / this.sourceHeight);
                },
                _start: function (e) {
                    this._init(), this._move(e);
                },
                _stop: function () {
                    this.cache.targetImage.style.opacity = 0;
                },
                _setTopLeftMaxValues: function (e, t) {
                    return { left: Math.max(Math.min(t, this.sourceWidth), 0), top: Math.max(Math.min(e, this.sourceHeight), 0) };
                },
                _move: function (e) {
                    var t = e.pageX - (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX),
                        s = e.pageY - (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY),
                        r = this._setTopLeftMaxValues(s, t);
                    (s = r.top), (t = r.left), (this.cache.targetImage.style.left = -(-(t * this.xRatio)) + "px"), (this.cache.targetImage.style.top = -(-(s * this.yRatio)) + "px"), (this.cache.targetImage.style.opacity = 1);
                },
                _duplicateImage: function () {
                    this._loadImage()
                        .then(
                            function (e) {
                                (this.cache.targetImage = e),
                                    (e.style.width = e.width + "px"),
                                    (e.style.height = e.height + "px"),
                                    (e.style.position = "absolute"),
                                    (e.style.maxWidth = "none"),
                                    (e.style.maxHeight = "none"),
                                    (e.style.opacity = 0),
                                    (e.style.border = "none"),
                                    (e.style.left = 0),
                                    (e.style.top = 0),
                                    this.container.appendChild(e),
                                    this._init(),
                                    (this._start = this._start.bind(this)),
                                    (this._stop = this._stop.bind(this)),
                                    (this._move = this._move.bind(this)),
                                    this.container.addEventListener("mouseenter", this._start),
                                    this.container.addEventListener("mouseleave", this._stop),
                                    this.container.addEventListener("mousemove", this._move),
                                    (this.container.style.position = "relative"),
                                    (this.container.style.overflow = "hidden");
                            }.bind(this)
                        )
                        .catch(function (e) {
                            console.warn("Error fetching image", e);
                        });
                },
                _loadImage: function () {
                    return new Promise(
                        function (e, r) {
                            var n = new Image();
                            n.setAttribute("role", "presentation"),
                                n.setAttribute(s.imageZoomTarget, !0),
                                n.classList.add(t.zoomImg),
                                (n.src = this.url),
                                n.addEventListener("load", function () {
                                    e(n);
                                }),
                                n.addEventListener("error", function (e) {
                                    r(e);
                                });
                        }.bind(this)
                    );
                },
                unload: function () {
                    var e = this.container.querySelector("[" + s.imageZoomTarget + "]");
                    e && e.remove(), this.container.removeEventListener("mouseenter", this._start), this.container.removeEventListener("mouseleave", this._stop), this.container.removeEventListener("mousemove", this._move);
                },
            })),
            r
        );
    })()),
    (function () {
        var e = document.querySelectorAll("[data-blog-tag-filter]");
        e.length &&
            (slate.utils.resizeSelects(e),
            e.forEach(function (e) {
                e.addEventListener("change", function (e) {
                    location.href = e.target.value;
                });
            }));
    })(),
    (window.theme = theme || {}),
    (theme.customerTemplates = (function () {
        var e = { RecoverHeading: "#RecoverHeading", RecoverEmail: "#RecoverEmail", LoginHeading: "#LoginHeading" };
        function t() {
            document.getElementById("RecoverPasswordForm").classList.remove("hide"), document.getElementById("CustomerLoginForm").classList.add("hide"), "true" === this.recoverEmail.getAttribute("aria-invalid") && this.recoverEmail.focus();
        }
        return {
            init: function () {
                var s, r;
                (function s() {
                    (this.recoverHeading = document.querySelector(e.RecoverHeading)), (this.recoverEmail = document.querySelector(e.RecoverEmail)), (this.loginHeading = document.querySelector(e.LoginHeading));
                    var r = document.getElementById("RecoverPassword"),
                        n = document.getElementById("HideRecoverPasswordLink");
                    r &&
                        r.addEventListener(
                            "click",
                            function (e) {
                                e.preventDefault(), t(), this.recoverHeading.setAttribute("tabindex", "-1"), this.recoverHeading.focus();
                            }.bind(this)
                        ),
                        n &&
                            n.addEventListener(
                                "click",
                                function (e) {
                                    e.preventDefault(),
                                        document.getElementById("RecoverPasswordForm").classList.add("hide"),
                                        document.getElementById("CustomerLoginForm").classList.remove("hide"),
                                        this.loginHeading.setAttribute("tabindex", "-1"),
                                        this.loginHeading.focus();
                                }.bind(this)
                            ),
                        this.recoverHeading &&
                            this.recoverHeading.addEventListener("blur", function (e) {
                                e.target.removeAttribute("tabindex");
                            }),
                        this.loginHeading &&
                            this.loginHeading.addEventListener("blur", function (e) {
                                e.target.removeAttribute("tabindex");
                            });
                })(),
                    (function e() {
                        "#recover" === window.location.hash && t.bind(this)();
                    })(),
                    (function e() {
                        if (document.querySelector(".reset-password-success")) {
                            var t = document.getElementById("ResetSuccess");
                            t.classList.remove("hide"), t.focus();
                        }
                    })(),
                    (s = document.getElementById("AddressNewForm")),
                    (r = document.getElementById("AddressNewButton")),
                    s &&
                        (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                        document.querySelectorAll(".address-country-option").forEach(function (e) {
                            var t = e.dataset.formId;
                            new Shopify.CountryProvinceSelector("AddressCountry_" + t, "AddressProvince_" + t, { hideElement: "AddressProvinceContainer_" + t });
                        }),
                        document.querySelectorAll(".address-new-toggle").forEach(function (e) {
                            e.addEventListener("click", function () {
                                var e = "true" === r.getAttribute("aria-expanded");
                                s.classList.toggle("hide"), r.setAttribute("aria-expanded", !e), r.focus();
                            });
                        }),
                        document.querySelectorAll(".address-edit-toggle").forEach(function (e) {
                            e.addEventListener("click", function (e) {
                                var t = e.target.dataset.formId,
                                    s = document.getElementById("EditFormButton_" + t),
                                    r = document.getElementById("EditAddress_" + t),
                                    n = "true" === s.getAttribute("aria-expanded");
                                r.classList.toggle("hide"), s.setAttribute("aria-expanded", !n), s.focus();
                            });
                        }),
                        document.querySelectorAll(".address-delete").forEach(function (e) {
                            e.addEventListener("click", function (e) {
                                var t = e.target.dataset.target;
                                confirm(e.target.dataset.confirmMessage || "Are you sure you wish to delete this address?") && Shopify.postLink(t, { parameters: { _method: "delete" } });
                            });
                        }));
            },
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.Cart = (function () {
        var e = {
                cartCount: "[data-cart-count]",
                cartCountBubble: "[data-cart-count-bubble]",
                cartDiscount: "[data-cart-discount]",
                cartDiscountTitle: "[data-cart-discount-title]",
                cartDiscountAmount: "[data-cart-discount-amount]",
                cartDiscountWrapper: "[data-cart-discount-wrapper]",
                cartErrorMessage: "[data-cart-error-message]",
                cartErrorMessageWrapper: "[data-cart-error-message-wrapper]",
                cartItem: "[data-cart-item]",
                cartItemDetails: "[data-cart-item-details]",
                cartItemDiscount: "[data-cart-item-discount]",
                cartItemDiscountedPriceGroup: "[data-cart-item-discounted-price-group]",
                cartItemDiscountTitle: "[data-cart-item-discount-title]",
                cartItemDiscountAmount: "[data-cart-item-discount-amount]",
                cartItemDiscountList: "[data-cart-item-discount-list]",
                cartItemFinalPrice: "[data-cart-item-final-price]",
                cartItemImage: "[data-cart-item-image]",
                cartItemLinePrice: "[data-cart-item-line-price]",
                cartItemOriginalPrice: "[data-cart-item-original-price]",
                cartItemPrice: "[data-cart-item-price]",
                cartItemPriceList: "[data-cart-item-price-list]",
                cartItemProperty: "[data-cart-item-property]",
                cartItemPropertyName: "[data-cart-item-property-name]",
                cartItemPropertyValue: "[data-cart-item-property-value]",
                cartItemRegularPriceGroup: "[data-cart-item-regular-price-group]",
                cartItemRegularPrice: "[data-cart-item-regular-price]",
                cartItemTitle: "[data-cart-item-title]",
                cartItemOption: "[data-cart-item-option]",
                cartItemSellingPlanName: "[data-cart-item-selling-plan-name]",
                cartLineItems: "[data-cart-line-items]",
                cartNote: "[data-cart-notes]",
                cartQuantityErrorMessage: "[data-cart-quantity-error-message]",
                cartQuantityErrorMessageWrapper: "[data-cart-quantity-error-message-wrapper]",
                cartRemove: "[data-cart-remove]",
                cartStatus: "[data-cart-status]",
                cartSubtotal: "[data-cart-subtotal]",
                cartTableCell: "[data-cart-table-cell]",
                cartWrapper: "[data-cart-wrapper]",
                emptyPageContent: "[data-empty-page-content]",
                quantityInput: "[data-quantity-input]",
                quantityInputMobile: "[data-quantity-input-mobile]",
                quantityInputDesktop: "[data-quantity-input-desktop]",
                quantityLabelMobile: "[data-quantity-label-mobile]",
                quantityLabelDesktop: "[data-quantity-label-desktop]",
                inputQty: "[data-quantity-input]",
                thumbnails: ".cart__image",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]",
                unitPriceGroup: "[data-unit-price-group]",
            },
            t = { cartNoCookies: "cart--no-cookies", cartRemovedProduct: "cart__removed-product", thumbnails: "cart__image", hide: "hide", inputError: "input--error" },
            s = {
                cartItemIndex: "data-cart-item-index",
                cartItemKey: "data-cart-item-key",
                cartItemQuantity: "data-cart-item-quantity",
                cartItemTitle: "data-cart-item-title",
                cartItemUrl: "data-cart-item-url",
                quantityItem: "data-quantity-item",
            },
            r = "(min-width: " + theme.breakpoints.medium + "px)";
        function n(s) {
            (this.container = s),
                (this.thumbnails = this.container.querySelectorAll(e.thumbnails)),
                (this.quantityInputs = this.container.querySelectorAll(e.inputQty)),
                (this.ajaxEnabled = "true" === this.container.getAttribute("data-ajax-enabled")),
                (this._handleInputQty = theme.Helpers.debounce(this._handleInputQty.bind(this), 500)),
                (this.setQuantityFormControllers = this.setQuantityFormControllers.bind(this)),
                (this._onNoteChange = this._onNoteChange.bind(this)),
                (this._onRemoveItem = this._onRemoveItem.bind(this)),
                theme.Helpers.cookiesEnabled() || this.container.classList.add(t.cartNoCookies),
                this.thumbnails.forEach(function (e) {
                    e.style.cursor = "pointer";
                }),
                this.container.addEventListener("click", this._handleThumbnailClick),
                this.container.addEventListener("change", this._handleInputQty),
                (this.mql = window.matchMedia(r)),
                this.mql.addListener(this.setQuantityFormControllers),
                this.setQuantityFormControllers(),
                this.ajaxEnabled && (this.container.addEventListener("click", this._onRemoveItem), this.container.addEventListener("change", this._onNoteChange), this._setupCartTemplates());
        }
        return (
            (n.prototype = Object.assign({}, n.prototype, {
                _setupCartTemplates: function () {
                    this.container.querySelector(e.cartItem) &&
                        ((this.itemTemplate = this.container.querySelector(e.cartItem).cloneNode(!0)),
                        (this.itemDiscountTemplate = this.itemTemplate.querySelector(e.cartItemDiscount).cloneNode(!0)),
                        (this.cartDiscountTemplate = this.container.querySelector(e.cartDiscount).cloneNode(!0)),
                        (this.itemPriceListTemplate = this.itemTemplate.querySelector(e.cartItemPriceList).cloneNode(!0)),
                        (this.itemOptionTemplate = this.itemTemplate.querySelector(e.cartItemOption).cloneNode(!0)),
                        (this.itemPropertyTemplate = this.itemTemplate.querySelector(e.cartItemProperty).cloneNode(!0)),
                        (this.itemSellingPlanNameTemplate = this.itemTemplate.querySelector(e.cartItemSellingPlanName).cloneNode(!0)));
                },
                _handleInputQty: function (t) {
                    if (t.target.hasAttribute("data-quantity-input")) {
                        var s = t.target,
                            r = s.closest(e.cartItem),
                            n = Number(s.getAttribute("data-quantity-item")),
                            a = this.container.querySelectorAll("[data-quantity-item='" + n + "']"),
                            o = parseInt(s.value),
                            c = !(o < 0 || isNaN(o));
                        if (
                            (a.forEach(function (e) {
                                e.value = o;
                            }),
                            this._hideCartError(),
                            this._hideQuantityErrorMessage(),
                            !c)
                        ) {
                            this._showQuantityErrorMessages(r);
                            return;
                        }
                        c && this.ajaxEnabled && this._updateItemQuantity(n, r, a, o);
                    }
                },
                _updateItemQuantity: function (t, r, n, a) {
                    var o = r.getAttribute(s.cartItemKey);
                    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json;" }, body: JSON.stringify({ line: Number(r.getAttribute(s.cartItemIndex)), quantity: a }) })
                        .then(function (e) {
                            return e.json();
                        })
                        .then(
                            function (t) {
                                if ((this._setCartCountBubble(t.item_count), !t.item_count)) {
                                    this._emptyCart();
                                    return;
                                }
                                if ((this._createCart(t), !a)) {
                                    this._showRemoveMessage(r.cloneNode(!0));
                                    return;
                                }
                                var s = document.querySelector("[data-cart-item-key='" + o + "']"),
                                    n = this.getItem(o, t),
                                    c = this.mql.matches ? e.quantityInputDesktop : e.quantityInputMobile;
                                this._updateLiveRegion(n), s && s.querySelector(c).focus();
                            }.bind(this)
                        )
                        .catch(
                            function () {
                                this._showCartError(null);
                            }.bind(this)
                        );
                },
                getItem: function (e, t) {
                    return t.items.find(function (t) {
                        return t.key === e;
                    });
                },
                _liveRegionText: function (e) {
                    var t = theme.strings.update + ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";
                    t = t.replace("[QuantityLabel]", theme.strings.quantity).replace("[Quantity]", e.quantity);
                    var s = "",
                        r = theme.Currency.formatMoney(e.original_line_price, theme.moneyFormat),
                        n = "",
                        a = "",
                        o = "";
                    return (
                        e.original_line_price > e.final_line_price &&
                            ((s = theme.strings.regularTotal), (n = theme.strings.discountedTotal), (a = theme.Currency.formatMoney(e.final_line_price, theme.moneyFormat)), (o = theme.strings.priceColumn)),
                        (t = t.replace("[Regular]", s).replace("[$$]", r).replace("[DiscountedPrice]", n).replace("[$]", a).replace("[PriceInformation]", o).trim())
                    );
                },
                _updateLiveRegion: function (t) {
                    if (t) {
                        var s = this.container.querySelector(e.cartStatus);
                        (s.textContent = this._liveRegionText(t)),
                            s.setAttribute("aria-hidden", !1),
                            setTimeout(function () {
                                s.setAttribute("aria-hidden", !0);
                            }, 1e3);
                    }
                },
                _createCart: function (s) {
                    var r = this._createCartDiscountList(s),
                        n = this.container.querySelector(e.cartLineItems);
                    (n.innerHTML = ""),
                        this._createLineItemList(s).forEach(function (e) {
                            n.appendChild(e);
                        }),
                        this.setQuantityFormControllers(),
                        (this.cartNotes = this.cartNotes || this.container.querySelector(e.cartNote)),
                        this.cartNotes && (this.cartNotes.value = s.note);
                    var a = this.container.querySelector(e.cartDiscountWrapper);
                    0 === r.length
                        ? ((a.innerHTML = ""), a.classList.add(t.hide))
                        : ((a.innerHTML = ""),
                          r.forEach(function (e) {
                              a.appendChild(e);
                          }),
                          a.classList.remove(t.hide)),
                        (this.container.querySelector(e.cartSubtotal).innerHTML = theme.Currency.formatMoney(s.total_price, theme.moneyFormatWithCurrency));
                },
                _createCartDiscountList: function (t) {
                    return t.cart_level_discount_applications.map(
                        function (t) {
                            var s = this.cartDiscountTemplate.cloneNode(!0);
                            return (s.querySelector(e.cartDiscountTitle).textContent = t.title), (s.querySelector(e.cartDiscountAmount).innerHTML = theme.Currency.formatMoney(t.total_allocated_amount, theme.moneyFormat)), s;
                        }.bind(this)
                    );
                },
                _createLineItemList: function (t) {
                    return t.items.map(
                        function (t, s) {
                            var r = this.itemTemplate.cloneNode(!0),
                                n = this.itemPriceListTemplate.cloneNode(!0);
                            this._setLineItemAttributes(r, t, s), this._setLineItemImage(r, t.featured_image);
                            var a = r.querySelector(e.cartItemTitle);
                            (a.textContent = t.product_title), a.setAttribute("href", t.url);
                            var o = t.selling_plan_allocation ? t.selling_plan_allocation.selling_plan.name : null,
                                c = this._createProductDetailsList(t.product_has_only_default_variant, t.options_with_values, t.properties, o);
                            this._setProductDetailsList(r, c),
                                this._setItemRemove(r, t.title),
                                (n.innerHTML = this._createItemPrice(t.original_price, t.final_price).outerHTML),
                                t.unit_price_measurement && n.appendChild(this._createUnitPrice(t.unit_price, t.unit_price_measurement)),
                                this._setItemPrice(r, n);
                            var l = this._createItemDiscountList(t);
                            this._setItemDiscountList(r, l), this._setQuantityInputs(r, t, s);
                            var d = this._createItemPrice(t.original_line_price, t.final_line_price);
                            return this._setItemLinePrice(r, d), r;
                        }.bind(this)
                    );
                },
                _setLineItemAttributes: function (e, t, r) {
                    e.setAttribute(s.cartItemKey, t.key), e.setAttribute(s.cartItemUrl, t.url), e.setAttribute(s.cartItemTitle, t.title), e.setAttribute(s.cartItemIndex, r + 1), e.setAttribute(s.cartItemQuantity, t.quantity);
                },
                _setLineItemImage: function (s, r) {
                    var n = s.querySelector(e.cartItemImage),
                        a = null !== r.url ? theme.Images.getSizedImageUrl(r.url, "x190") : null;
                    a ? (n.setAttribute("alt", r.alt), n.setAttribute("src", a), n.classList.remove(t.hide)) : n.parentNode.removeChild(n);
                },
                _setProductDetailsList: function (s, r) {
                    var n = s.querySelector(e.cartItemDetails);
                    if (r.length) {
                        n.classList.remove(t.hide),
                            (n.innerHTML = r.reduce(function (e, t) {
                                return e + t.outerHTML;
                            }, ""));
                        return;
                    }
                    n.classList.add(t.hide), (n.textContent = "");
                },
                _setItemPrice: function (t, s) {
                    t.querySelector(e.cartItemPrice).innerHTML = s.outerHTML;
                },
                _setItemDiscountList: function (s, r) {
                    var n = s.querySelector(e.cartItemDiscountList);
                    0 === r.length
                        ? ((n.innerHTML = ""), n.classList.add(t.hide))
                        : ((n.innerHTML = r.reduce(function (e, t) {
                              return e + t.outerHTML;
                          }, "")),
                          n.classList.remove(t.hide));
                },
                _setItemRemove: function (t, s) {
                    t.querySelector(e.cartRemove).setAttribute("aria-label", theme.strings.removeLabel.replace("[product]", s));
                },
                _setQuantityInputs: function (t, r, n) {
                    var a = t.querySelector(e.quantityInputMobile),
                        o = t.querySelector(e.quantityInputDesktop);
                    a.setAttribute("id", "updates_" + r.key),
                        o.setAttribute("id", "updates_large_" + r.key),
                        [a, o].forEach(function (e) {
                            e.setAttribute(s.quantityItem, n + 1), (e.value = r.quantity);
                        }),
                        t.querySelector(e.quantityLabelMobile).setAttribute("for", "updates_" + r.key),
                        t.querySelector(e.quantityLabelDesktop).setAttribute("for", "updates_large_" + r.key);
                },
                setQuantityFormControllers: function () {
                  if(true == true){
                    var t = document.querySelectorAll(e.quantityInputDesktop),
                        s = document.querySelectorAll(e.quantityInputMobile);
                    function r(e) {
                        e.forEach(function (e) {
                            e.setAttribute("name", "updates[" + e.getAttribute("data-id") + "]");
                            //e.setAttribute("name", "updates[]");
                        });
                    }
                    function n(e) {
                        e.forEach(function (e) {
                            e.removeAttribute("name");
                        });
                    }
                    this.mql.matches ? (r(t), n(s)) : (r(s), n(t));
                  }
                },
                _setItemLinePrice: function (t, s) {
                    t.querySelector(e.cartItemLinePrice).innerHTML = s.outerHTML;
                },
                _createProductDetailsList: function (e, t, s, r) {
                    var n = [];
                    return e || (n = n.concat(this._getOptionList(t))), r && (n = n.concat(this._getSellingPlanName(r))), null !== s && 0 !== Object.keys(s).length && (n = n.concat(this._getPropertyList(s))), n;
                },
                _getOptionList: function (e) {
                    return e.map(
                        function (e) {
                            var s = this.itemOptionTemplate.cloneNode(!0);
                            return (s.textContent = e.name + ": " + e.value), s.classList.remove(t.hide), s;
                        }.bind(this)
                    );
                },
                _getPropertyList: function (s) {
                    return (null !== s ? Object.entries(s) : [])
                        .filter(function (e) {
                            return "_" !== e[0].charAt(0) && 0 !== e[1].length;
                        })
                        .map(
                            function (s) {
                                var r = this.itemPropertyTemplate.cloneNode(!0);
                                return (
                                    (r.querySelector(e.cartItemPropertyName).textContent = s[0] + ": "),
                                    -1 === s[0].indexOf("/uploads/")
                                        ? (r.querySelector(e.cartItemPropertyValue).textContent = s[1])
                                        : (r.querySelector(e.cartItemPropertyValue).innerHTML = '<a href="' + s[1] + '"> ' + s[1].split("/").pop() + "</a>"),
                                    r.classList.remove(t.hide),
                                    r
                                );
                            }.bind(this)
                        );
                },
                _getSellingPlanName: function (e) {
                    var s = this.itemSellingPlanNameTemplate.cloneNode(!0);
                    return (s.textContent = e), s.classList.remove(t.hide), s;
                },
                _createItemPrice: function (s, r) {
                    var n,
                        a = theme.Currency.formatMoney(s, theme.moneyFormat);
                    return (
                        s !== r
                            ? (((n = this.itemPriceListTemplate.querySelector(e.cartItemDiscountedPriceGroup).cloneNode(!0)).querySelector(e.cartItemOriginalPrice).innerHTML = a),
                              (n.querySelector(e.cartItemFinalPrice).innerHTML = theme.Currency.formatMoney(r, theme.moneyFormat)))
                            : ((n = this.itemPriceListTemplate.querySelector(e.cartItemRegularPriceGroup).cloneNode(!0)).querySelector(e.cartItemRegularPrice).innerHTML = a),
                        n.classList.remove(t.hide),
                        n
                    );
                },
                _createUnitPrice: function (s, r) {
                    var n = this.itemPriceListTemplate.querySelector(e.unitPriceGroup).cloneNode(!0),
                        a = (1 !== r.reference_value ? r.reference_value : "") + r.reference_unit;
                    return (n.querySelector(e.unitPriceBaseUnit).textContent = a), (n.querySelector(e.unitPrice).innerHTML = theme.Currency.formatMoney(s, theme.moneyFormat)), n.classList.remove(t.hide), n;
                },
                _createItemDiscountList: function (t) {
                    return t.line_level_discount_allocations.map(
                        function (t) {
                            var s = this.itemDiscountTemplate.cloneNode(!0);
                            return (s.querySelector(e.cartItemDiscountTitle).textContent = t.discount_application.title), (s.querySelector(e.cartItemDiscountAmount).innerHTML = theme.Currency.formatMoney(t.amount, theme.moneyFormat)), s;
                        }.bind(this)
                    );
                },
                _showQuantityErrorMessages: function (s) {
                    s.querySelectorAll(e.cartQuantityErrorMessage).forEach(function (e) {
                        e.textContent = theme.strings.quantityMinimumMessage;
                    }),
                        s.querySelectorAll(e.cartQuantityErrorMessageWrapper).forEach(function (e) {
                            e.classList.remove(t.hide);
                        }),
                        s.querySelectorAll(e.inputQty).forEach(function (e) {
                            e.classList.add(t.inputError), e.focus();
                        });
                },
                _hideQuantityErrorMessage: function () {
                    document.querySelectorAll(e.cartQuantityErrorMessageWrapper).forEach(function (s) {
                        s.classList.add(t.hide), (s.querySelector(e.cartQuantityErrorMessage).textContent = "");
                    }),
                        this.container.querySelectorAll(e.inputQty).forEach(function (e) {
                            e.classList.remove(t.inputError);
                        });
                },
                _handleThumbnailClick: function (s) {
                    s.target.classList.contains(t.thumbnails) && (window.location.href = s.target.closest(e.cartItem).getAttribute("data-cart-item-url"));
                },
                _onNoteChange: function (e) {
                    if (e.target.hasAttribute("data-cart-notes")) {
                        var t = e.target.value;
                        this._hideCartError(),
                            this._hideQuantityErrorMessage(),
                            fetch("/cart/update.js", { method: "POST", headers: new Headers({ "Content-Type": "application/json" }), body: JSON.stringify({ note: t }) }).catch(
                                function () {
                                    this._showCartError(e.target);
                                }.bind(this)
                            );
                    }
                },
                _showCartError: function (s) {
                    (document.querySelector(e.cartErrorMessage).textContent = theme.strings.cartError), document.querySelector(e.cartErrorMessageWrapper).classList.remove(t.hide), s && s.focus();
                },
                _hideCartError: function () {
                    document.querySelector(e.cartErrorMessageWrapper).classList.add(t.hide), (document.querySelector(e.cartErrorMessage).textContent = "");
                },
                _onRemoveItem: function (t) {
                    if (t.target.hasAttribute("data-cart-remove")) {
                        t.preventDefault();
                        var r = t.target.closest(e.cartItem),
                            n = Number(r.getAttribute(s.cartItemIndex));
                        this._hideCartError(),
                            fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json;" }, body: JSON.stringify({ line: n, quantity: 0 }) })
                                .then(function (e) {
                                    return e.json();
                                })
                                .then(
                                    function (e) {
                                        0 === e.item_count ? this._emptyCart() : (this._createCart(e), this._showRemoveMessage(r.cloneNode(!0))), this._setCartCountBubble(e.item_count);
                                    }.bind(this)
                                )
                                .catch(
                                    function () {
                                        this._showCartError(null);
                                    }.bind(this)
                                );
                    }
                },
                _showRemoveMessage: function (e) {
                    var t = e.getAttribute("data-cart-item-index"),
                        s = this._getRemoveMessage(e);
                    t - 1 == 0
                        ? this.container.querySelector('[data-cart-item-index="1"]').insertAdjacentHTML("beforebegin", s.outerHTML)
                        : this.container.querySelector("[data-cart-item-index='" + (t - 1) + "']").insertAdjacentHTML("afterend", s.outerHTML),
                        this.container.querySelector("[data-removed-item-row]").focus();
                },
                _getRemoveMessage: function (s) {
                    var r = this._formatRemoveMessage(s),
                        n = s.querySelector(e.cartTableCell).cloneNode(!0);
                    return (
                        n.removeAttribute("class"),
                        n.classList.add(t.cartRemovedProduct),
                        n.setAttribute("colspan", "4"),
                        (n.innerHTML = r),
                        s.setAttribute("role", "alert"),
                        s.setAttribute("tabindex", "-1"),
                        s.setAttribute("data-removed-item-row", !0),
                        (s.innerHTML = n.outerHTML),
                        s
                    );
                },
                _formatRemoveMessage: function (e) {
                    var t = e.getAttribute("data-cart-item-quantity"),
                        r = e.getAttribute(s.cartItemUrl),
                        n = e.getAttribute(s.cartItemTitle);
                    return theme.strings.removedItemMessage.replace("[quantity]", t).replace("[link]", '<a href="' + r + '" class="text-link text-link--accent">' + n + "</a>");
                },
                _setCartCountBubble: function (s) {
                    (this.cartCountBubble = this.cartCountBubble || document.querySelector(e.cartCountBubble)),
                        (this.cartCount = this.cartCount || document.querySelector(e.cartCount)),
                        s > 0 ? (this.cartCountBubble.classList.remove(t.hide), (this.cartCount.textContent = s)) : (this.cartCountBubble.classList.add(t.hide), (this.cartCount.textContent = ""));
                },
                _emptyCart: function () {
                    (this.emptyPageContent = this.emptyPageContent || this.container.querySelector(e.emptyPageContent)),
                        (this.cartWrapper = this.cartWrapper || this.container.querySelector(e.cartWrapper)),
                        this.emptyPageContent.classList.remove(t.hide),
                        this.cartWrapper.classList.add(t.hide);
                },
            })),
            n
        );
    })()),
    (window.theme = window.theme || {}),
    (theme.Filters = (function () {
        var e = { mediaQueryMediumUp: "(min-width: " + theme.breakpoints.medium + "px)" },
            t = { filterSelection: "#FilterTags", sortSelection: "#SortBy", selectInput: "[data-select-input]" };
        function s(s) {
            (this.filterSelect = s.querySelector(t.filterSelection)),
                (this.sortSelect = s.querySelector(t.sortSelection)),
                (this.selects = document.querySelectorAll(t.selectInput)),
                this.sortSelect && (this.defaultSort = this._getDefaultSortValue()),
                this.selects.length &&
                    this.selects.forEach(function (e) {
                        e.classList.remove("hidden");
                    }),
                (this.initBreakpoints = this._initBreakpoints.bind(this)),
                (this.mql = window.matchMedia(e.mediaQueryMediumUp)),
                this.mql.addListener(this.initBreakpoints),
                this.filterSelect && this.filterSelect.addEventListener("change", this._onFilterChange.bind(this)),
                this.sortSelect && this.sortSelect.addEventListener("change", this._onSortChange.bind(this)),
                theme.Helpers.promiseStylesheet().then(
                    function () {
                        this._initBreakpoints();
                    }.bind(this)
                ),
                this._initParams();
        }
        return (
            (s.prototype = Object.assign({}, s.prototype, {
                _initBreakpoints: function () {
                    this.mql.matches && slate.utils.resizeSelects(this.selects);
                },
                _initParams: function () {
                    if (((this.queryParams = {}), location.search.length))
                        for (var e, t = location.search.substr(1).split("&"), s = 0; s < t.length; s++) (e = t[s].split("=")).length > 1 && (this.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1]));
                },
                _onSortChange: function () {
                    (this.queryParams.sort_by = this._getSortValue()), this.queryParams.page && delete this.queryParams.page, (window.location.search = decodeURIComponent(new URLSearchParams(Object.entries(this.queryParams)).toString()));
                },
                _onFilterChange: function () {
                    document.location.href = this._getFilterValue();
                },
                _getFilterValue: function () {
                    return this.filterSelect.value;
                },
                _getSortValue: function () {
                    return this.sortSelect.value || this.defaultSort;
                },
                _getDefaultSortValue: function () {
                    return this.sortSelect.dataset.defaultSortby;
                },
                onUnload: function () {
                    this.filterSelect && this.filterSelect.removeEventListener("change", this._onFilterChange),
                        this.sortSelect && this.sortSelect.removeEventListener("change", this._onSortChange),
                        this.mql.removeListener(this.initBreakpoints);
                },
            })),
            s
        );
    })()),
    (window.theme = window.theme || {}),
    (theme.HeaderSection = (function () {
        function e() {
            theme.Header.init(), theme.MobileNav.init(), theme.Search.init();
        }
        return (
            (e.prototype = Object.assign({}, e.prototype, {
                onUnload: function () {
                    theme.Header.unload(), theme.Search.unload(), theme.MobileNav.unload();
                },
            })),
            e
        );
    })()),
    (theme.Maps = (function () {
        var e = { zoom: 14 },
            t = null,
            s = [],
            r = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError },
            n = { section: '[data-section-type="map"]', map: "[data-map]", mapOverlay: "[data-map-overlay]" },
            a = { mapError: "map-section--load-error", errorMsg: "map-section__error errors text-center" };
        function o(e) {
            (this.map = e.querySelector(n.map)),
                this.map &&
                    ((this.key = this.map.dataset.apiKey),
                    void 0 !== this.key &&
                        ("loaded" === t
                            ? this.createMap()
                            : (s.push(this),
                              "loading" !== t &&
                                  ((t = "loading"),
                                  void 0 === window.google &&
                                      theme.Helpers.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
                                          (t = "loaded"),
                                              s.forEach(function (e) {
                                                  e.createMap();
                                              });
                                      })))));
        }
        return (
            (window.gm_authFailure = function () {
                Shopify.designMode &&
                    (document.querySelector(n.section).classList.add(a.mapError),
                    document.querySelector(n.map).remove(),
                    document.querySelector(n.mapOverlay).insertAdjacentHTML("afterend", '<div class="' + a.errorMsg + '">' + theme.strings.authError + "</div>"));
            }),
            (o.prototype = Object.assign({}, o.prototype, {
                createMap: function () {
                    var t;
                    return ((t = this.map),
                    new Promise(function (e, s) {
                        var r = new google.maps.Geocoder(),
                            n = t.dataset.addressSetting;
                        r.geocode({ address: n }, function (t, r) {
                            r !== google.maps.GeocoderStatus.OK && s(r), e(t);
                        });
                    }))
                        .then(
                            function (t) {
                                var s = { zoom: e.zoom, center: t[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                    r = (this.map = new google.maps.Map(this.map, s)),
                                    n = (this.center = r.getCenter());
                                new google.maps.Marker({ map: r, position: r.getCenter() }),
                                    google.maps.event.addDomListener(
                                        window,
                                        "resize",
                                        theme.Helpers.debounce(
                                            function () {
                                                google.maps.event.trigger(r, "resize"), r.setCenter(n), this.map.removeAttribute("style");
                                            }.bind(this),
                                            250
                                        )
                                    );
                            }.bind(this)
                        )
                        .catch(
                            function () {
                                var e;
                                switch (status) {
                                    case "ZERO_RESULTS":
                                        e = r.addressNoResults;
                                        break;
                                    case "OVER_QUERY_LIMIT":
                                        e = r.addressQueryLimit;
                                        break;
                                    case "REQUEST_DENIED":
                                        e = r.authError;
                                        break;
                                    default:
                                        e = r.addressError;
                                }
                                Shopify.designMode && (this.map.parentNode.classList.add(a.mapError), (this.map.parentNode.innerHTML = '<div class="' + a.errorMsg + '">' + e + "</div>"));
                            }.bind(this)
                        );
                },
                onUnload: function () {
                    this.map && google.maps.event.clearListeners(this.map, "resize");
                },
            })),
            o
        );
    })()),
    (theme.Product = (function () {
        function e(e) {
            this.container = e;
            var s = e.getAttribute("data-section-id");
            (this.zoomPictures = []),
                (this.ajaxEnabled = "true" === e.getAttribute("data-ajax-enabled")),
                (this.settings = {
                    mediaQueryMediumUp: "screen and (min-width: 750px)",
                    mediaQuerySmall: "screen and (max-width: 749px)",
                    bpSmall: !1,
                    enableHistoryState: e.getAttribute("data-enable-history-state") || !1,
                    namespace: ".slideshow-" + s,
                    sectionId: s,
                    sliderActive: !1,
                    zoomEnabled: !1,
                }),
                (this.selectors = {
                    addToCart: "[data-add-to-cart]",
                    addToCartText: "[data-add-to-cart-text]",
                    cartCount: "[data-cart-count]",
                    cartCountBubble: "[data-cart-count-bubble]",
                    cartPopup: "[data-cart-popup]",
                    cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
                    cartPopupClose: "[data-cart-popup-close]",
                    cartPopupDismiss: "[data-cart-popup-dismiss]",
                    cartPopupImage: "[data-cart-popup-image]",
                    cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
                    cartPopupImagePlaceholder: "[data-image-loading-animation]",
                    cartPopupProductDetails: "[data-cart-popup-product-details]",
                    cartPopupQuantity: "[data-cart-popup-quantity]",
                    cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
                    cartPopupTitle: "[data-cart-popup-title]",
                    cartPopupWrapper: "[data-cart-popup-wrapper]",
                    loader: "[data-loader]",
                    loaderStatus: "[data-loader-status]",
                    quantity: "[data-quantity-input]",
                    SKU: ".variant-sku",
                    productStatus: "[data-product-status]",
                    originalSelectorId: "#ProductSelect-" + s,
                    productForm: "[data-product-form]",
                    errorMessage: "[data-error-message]",
                    errorMessageWrapper: "[data-error-message-wrapper]",
                    imageZoomWrapper: "[data-image-zoom-wrapper]",
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    productThumbImages: ".product-single__thumbnail--" + s,
                    productThumbs: ".product-single__thumbnails-" + s,
                    productThumbListItem: ".product-single__thumbnails-item",
                    productThumbsWrapper: ".thumbnails-wrapper",
                    saleLabel: ".product-price__sale-label-" + s,
                    singleOptionSelector: ".single-option-selector-" + s,
                    shopifyPaymentButton: ".shopify-payment-button",
                    productMediaTypeVideo: "[data-product-media-type-video]",
                    productMediaTypeModel: "[data-product-media-type-model]",
                    priceContainer: "[data-price]",
                    regularPrice: "[data-regular-price]",
                    bffPrice: "[data-bff-price]",
                    salePrice: "[data-sale-price]",
                    unitPrice: "[data-unit-price]",
                    unitPriceBaseUnit: "[data-unit-price-base-unit]",
                    productPolicies: "[data-product-policies]",
                    storeAvailabilityContainer: "[data-store-availability-container]",
                }),
                (this.classes = {
                    cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
                    hidden: "hide",
                    visibilityHidden: "visibility-hidden",
                    inputError: "input--error",
                    jsZoomEnabled: "js-zoom-enabled",
                    productOnSale: "price--on-sale",
                    productUnitAvailable: "price--unit-available",
                    productUnavailable: "price--unavailable",
                    productSoldOut: "price--sold-out",
                    cartImage: "cart-popup-item__image",
                    productFormErrorMessageWrapperHidden: "product-form__error-message-wrapper--hidden",
                    activeClass: "active-thumb",
                    variantSoldOut: "product-form--variant-sold-out",
                }),
                (this.eventHandlers = {}),
                (this.quantityInput = e.querySelector(this.selectors.quantity)),
                (this.errorMessageWrapper = e.querySelector(this.selectors.errorMessageWrapper)),
                (this.productForm = e.querySelector(this.selectors.productForm)),
                (this.addToCart = e.querySelector(this.selectors.addToCart)),
                (this.addToCartText = this.addToCart.querySelector(this.selectors.addToCartText)),
                (this.shopifyPaymentButton = e.querySelector(this.selectors.shopifyPaymentButton)),
                (this.productPolicies = e.querySelector(this.selectors.productPolicies)),
                (this.storeAvailabilityContainer = e.querySelector(this.selectors.storeAvailabilityContainer)),
                this.storeAvailabilityContainer && this._initStoreAvailability(),
                (this.loader = this.addToCart.querySelector(this.selectors.loader)),
                (this.loaderStatus = e.querySelector(this.selectors.loaderStatus)),
                (this.imageZoomWrapper = e.querySelectorAll(this.selectors.imageZoomWrapper));
            var r = document.getElementById("ProductJson-" + s);
            r &&
                r.innerHTML.length &&
                ((this.productSingleObject = JSON.parse(r.innerHTML)),
                (this.productState = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1 }),
                (this.settings.zoomEnabled = this.imageZoomWrapper.length > 0 && this.imageZoomWrapper[0].classList.contains(this.classes.jsZoomEnabled)),
                (this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this)),
                (this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this)),
                (this.mqlSmall = window.matchMedia(this.settings.mediaQuerySmall)),
                this.mqlSmall.addListener(this.initMobileBreakpoint),
                (this.mqlMediumUp = window.matchMedia(this.settings.mediaQueryMediumUp)),
                this.mqlMediumUp.addListener(this.initDesktopBreakpoint),
                this.initMobileBreakpoint(),
                this.initDesktopBreakpoint(),
                this._stringOverrides(),
                this._initVariants(),
                this._initMediaSwitch(),
                this._initAddToCart(),
                this._setActiveThumbnail(),
                this._initProductVideo(),
                this._initModelViewerLibraries(),
                this._initShopifyXrLaunch(),
                t("default"));
        }
        var t = function (e) {
        	if($(".installment-container").length){
	            var t = $(".installment-container").data();
	            "default" == e && (e = parseFloat(t.price) || 0), "1" == $.trim(t.bff) && (e *= 0.9);
	            var s = { "{{price}}": theme.Currency.formatMoney(e / t.installment_months, theme.moneyFormatWithCurrency), "{{logo}}": '<img src="' + t.installment_logo + '">', "{{months}}": t.installment_months },
	                r = t.installment_message;
	            "zh-TW" == Shopify.locale && "" != $.trim(t.installment_message_zhtw) && (r = t.installment_message_zhtw),
	                $.each(s, function (e, t) {
	                    r = r.replaceAll(e, t);
	                }),
	                $(".installment-container").html(r);
        	}
        };
        return (
            (e.prototype = Object.assign({}, e.prototype, {
                _stringOverrides: function () {
                    (theme.productStrings = theme.productStrings || {}), (theme.strings = Object.assign({}, theme.strings, theme.productStrings));
                },
                _initStoreAvailability: function () {
                    this.storeAvailability = new theme.StoreAvailability(this.storeAvailabilityContainer);
                    var e = function (e) {
                        this.cartPopupWrapper && !this.cartPopupWrapper.classList.contains(this.classes.cartPopupWrapperHidden) && this._hideCartPopup(e);
                    };
                    this.storeAvailabilityContainer.addEventListener("storeAvailabilityModalOpened", e.bind(this));
                },
                _initMobileBreakpoint: function () {
                    this.mqlSmall.matches
                        ? (this.container.querySelectorAll(this.selectors.productThumbImages).length > 4 && this._initThumbnailSlider(),
                          this.settings.zoomEnabled &&
                              this.imageZoomWrapper.forEach(
                                  function (e, t) {
                                      this._destroyZoom(t);
                                  }.bind(this)
                              ),
                          (this.settings.bpSmall = !0))
                        : (this.settings.sliderActive && this._destroyThumbnailSlider(), (this.settings.bpSmall = !1));
                },
                _initDesktopBreakpoint: function () {
                    this.mqlMediumUp.matches &&
                        this.settings.zoomEnabled &&
                        this.imageZoomWrapper.forEach(
                            function (e, t) {
                                this._enableZoom(e, t);
                            }.bind(this)
                        );
                },
                _initVariants: function () {
                    var e = {
                        container: this.container,
                        enableHistoryState: this.container.getAttribute("data-enable-history-state") || !1,
                        singleOptionSelector: this.selectors.singleOptionSelector,
                        originalSelectorId: this.selectors.originalSelectorId,
                        product: this.productSingleObject,
                    };
                    (this.variants = new slate.Variants(e)),
                        this.storeAvailability && this.variants.currentVariant.available && this.storeAvailability.updateContent(this.variants.currentVariant.id),
                        (this.eventHandlers.updateAvailability = this._updateAvailability.bind(this)),
                        (this.eventHandlers.updateMedia = this._updateMedia.bind(this)),
                        (this.eventHandlers.updatePrice = this._updatePrice.bind(this)),
                        (this.eventHandlers.updateSKU = this._updateSKU.bind(this)),
                        this.container.addEventListener("variantChange", this.eventHandlers.updateAvailability),
                        this.container.addEventListener("variantImageChange", this.eventHandlers.updateMedia),
                        this.container.addEventListener("variantPriceChange", this.eventHandlers.updatePrice),
                        this.container.addEventListener("variantSKUChange", this.eventHandlers.updateSKU);
                },
                _initMediaSwitch: function () {
                    if (document.querySelector(this.selectors.productThumbImages)) {
                        var e = this,
                            t = document.querySelectorAll(this.selectors.productThumbImages);
                        (this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this)),
                            t.forEach(function (t) {
                                t.addEventListener("click", function (s) {
                                    s.preventDefault();
                                    var r = t.getAttribute("data-thumbnail-id");
                                    e._switchMedia(r), e._setActiveThumbnail(r);
                                }),
                                    t.addEventListener("keyup", e.eventHandlers.handleMediaFocus);
                            });
                    }
                },
                _initAddToCart: function () {
                    var e = this;
                    $("[data-product-form]").each(function (t, s) {
                        $(s).submit(function (t) {
                            if ("true" === $(s).find("[data-add-to-cart]").attr("aria-disabled")) {
                                t.preventDefault();
                                return;
                            }
                            if (e.ajaxEnabled) {
                                t.preventDefault(), (e.previouslyFocusedElement = document.activeElement);
                                var r = !!e.quantityInput && e.quantityInput.value <= 0;
                                if (r) {
                                    e._showErrorMessage(theme.strings.quantityMinimumMessage);
                                    return;
                                }
                                if (!r && e.ajaxEnabled) {
                                    e._handleButtonLoadingStateBtn($(s).find("[data-add-to-cart]"), !0), e._addItemToCart(s);
                                    return;
                                }
                            }
                        });
                    });
                },
                _initProductVideo: function () {
                    var e = this.settings.sectionId;
                    this.container.querySelectorAll(this.selectors.productMediaTypeVideo).forEach(function (t) {
                        theme.ProductVideo.init(t, e);
                    });
                },
                _initModelViewerLibraries: function () {
                    var e = this.container.querySelectorAll(this.selectors.productMediaTypeModel);
                    e.length < 1 || theme.ProductModel.init(e, this.settings.sectionId);
                },
                _initShopifyXrLaunch: function () {
                    (this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(this)), document.addEventListener("shopify_xr_launch", this.eventHandlers.initShopifyXrLaunchHandler);
                },
                _initShopifyXrLaunchHandler: function () {
                    this.container.querySelector(this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")").dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                },
                _addItemToCart: function (e) {
                    var t = this;
                    fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded", "X-Requested-With": "XMLHttpRequest" }, body: theme.Helpers.serialize(e) })
                        .then(function (e) {
                            return e.json();
                        })
                        .then(function (e) {
                            if (e.status && 200 !== e.status) {
                                var s = Error(e.description);
                                throw ((s.isFromServer = !0), s);
                            }
                            t._hideErrorMessage(), t._setupCartPopup(e), CartTrackingKlaviyo(e);
                        })
                        .catch(function (e) {
                            t.previouslyFocusedElement.focus(),
                                t._showErrorMessage(e.isFromServer && e.message.length ? e.message : theme.strings.cartError),
                                t._handleButtonLoadingState(!1),
                                t._handleButtonLoadingStateBtn(!1, !1),
                                console.log(e);
                        });
                },
                _handleButtonLoadingStateBtn: function (e, t) {
                    t ? ($(e).addClass("btn-loading"), $(e).prop("disabled", !0)) : ($(".btn-loading").prop("disabled", !1), $(".btn-loading").removeClass("btn-loading"));
                },
                _handleButtonLoadingState: function (e) {
                    e
                        ? (this.addToCart.setAttribute("aria-disabled", !0),
                          this.addToCartText.classList.add(this.classes.hidden),
                          this.loader.classList.remove(this.classes.hidden),
                          this.shopifyPaymentButton && this.shopifyPaymentButton.setAttribute("disabled", !0),
                          this.loaderStatus.setAttribute("aria-hidden", !1))
                        : (this.addToCart.removeAttribute("aria-disabled"),
                          this.addToCartText.classList.remove(this.classes.hidden),
                          this.loader.classList.add(this.classes.hidden),
                          this.shopifyPaymentButton && this.shopifyPaymentButton.removeAttribute("disabled"),
                          this.loaderStatus.setAttribute("aria-hidden", !0));
                },
                _showErrorMessage: function (e) {
                    var t = this.container.querySelector(this.selectors.errorMessage);
                    console.log(this.selectors.errorMessage),
                        (t.innerHTML = e),
                        this.quantityInput && this.quantityInput.classList.add(this.classes.inputError),
                        this.errorMessageWrapper.classList.remove(this.classes.productFormErrorMessageWrapperHidden),
                        this.errorMessageWrapper.setAttribute("aria-hidden", !0),
                        this.errorMessageWrapper.removeAttribute("aria-hidden");
                },
                _hideErrorMessage: function () {
                    this.errorMessageWrapper.classList.add(this.classes.productFormErrorMessageWrapperHidden), this.quantityInput && this.quantityInput.classList.remove(this.classes.inputError);
                },
                _setupCartPopup: function (e) {
                    (this.cartPopup = this.cartPopup || document.querySelector(this.selectors.cartPopup)),
                        (this.cartPopupWrapper = this.cartPopupWrapper || document.querySelector(this.selectors.cartPopupWrapper)),
                        (this.cartPopupTitle = this.cartPopupTitle || document.querySelector(this.selectors.cartPopupTitle)),
                        (this.cartPopupQuantity = this.cartPopupQuantity || document.querySelector(this.selectors.cartPopupQuantity)),
                        (this.cartPopupQuantityLabel = this.cartPopupQuantityLabel || document.querySelector(this.selectors.cartPopupQuantityLabel)),
                        (this.cartPopupClose = this.cartPopupClose || document.querySelector(this.selectors.cartPopupClose)),
                        (this.cartPopupDismiss = this.cartPopupDismiss || document.querySelector(this.selectors.cartPopupDismiss)),
                        (this.cartPopupImagePlaceholder = this.cartPopupImagePlaceholder || document.querySelector(this.selectors.cartPopupImagePlaceholder)),
                        this._setupCartPopupEventListeners(),
                        this._updateCartPopupContent(e);
                },
                _updateCartPopupContent: function (e) {
                    var t = this,
                        s = this.quantityInput ? this.quantityInput.value : 1,
                        r = e.selling_plan_allocation ? e.selling_plan_allocation.selling_plan.name : null;
                    (this.cartPopupTitle.textContent = e.product_title),
                        (this.cartPopupQuantity.textContent = s),
                        (this.cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace("[count]", s)),
                        this._setCartPopupPlaceholder(e.featured_image.url),
                        this._setCartPopupImage(e.featured_image.url, e.featured_image.alt),
                        this._setCartPopupProductDetails(e.product_has_only_default_variant, e.options_with_values, e.properties, r),
                        fetch("/cart.js", { credentials: "same-origin" })
                            .then(function (e) {
                                return e.json();
                            })
                            .then(function (e) {
                                t._setCartQuantity(e.item_count), t._setCartCountBubble(e.item_count), t._showCartPopup();
                            })
                            .catch(function (e) {
                                console.log(e);
                            });
                },
                _setupCartPopupEventListeners: function () {
                    (this.eventHandlers.cartPopupWrapperKeyupHandler = this._cartPopupWrapperKeyupHandler.bind(this)),
                        (this.eventHandlers.hideCartPopup = this._hideCartPopup.bind(this)),
                        (this.eventHandlers.onBodyClick = this._onBodyClick.bind(this)),
                        this.cartPopupWrapper.addEventListener("keyup", this.eventHandlers.cartPopupWrapperKeyupHandler),
                        this.cartPopupClose.addEventListener("click", this.eventHandlers.hideCartPopup),
                        this.cartPopupDismiss.addEventListener("click", this.eventHandlers.hideCartPopup),
                        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                },
                _cartPopupWrapperKeyupHandler: function (e) {
                    e.keyCode === slate.utils.keyboardKeys.ESCAPE && this._hideCartPopup(e);
                },
                _setCartPopupPlaceholder: function (e) {
                    if (((this.cartPopupImageWrapper = this.cartPopupImageWrapper || document.querySelector(this.selectors.cartPopupImageWrapper)), null === e)) {
                        this.cartPopupImageWrapper.classList.add(this.classes.hidden);
                        return;
                    }
                },
                _setCartPopupImage: function (e, t) {
                    if (null !== e) {
                        this.cartPopupImageWrapper.classList.remove(this.classes.hidden);
                        var s = theme.Images.getSizedImageUrl(e, "200x"),
                            r = document.createElement("img");
                        (r.src = s),
                            (r.alt = t),
                            r.classList.add(this.classes.cartImage),
                            r.setAttribute("data-cart-popup-image", ""),
                            (r.onload = function () {
                                this.cartPopupImagePlaceholder.removeAttribute("data-image-loading-animation"), this.cartPopupImageWrapper.append(r);
                            }.bind(this));
                    }
                },
                _setCartPopupProductDetails: function (e, t, s, r) {
                    this.cartPopupProductDetails = this.cartPopupProductDetails || document.querySelector(this.selectors.cartPopupProductDetails);
                    var n = "";
                    e || (n += this._getVariantOptionList(t)),
                        r && (n += this._getSellingPlanHTML(r)),
                        null !== s && 0 !== Object.keys(s).length && (n += this._getPropertyList(s)),
                        0 === n.length
                            ? ((this.cartPopupProductDetails.innerHTML = ""), this.cartPopupProductDetails.setAttribute("hidden", ""))
                            : ((this.cartPopupProductDetails.innerHTML = n), this.cartPopupProductDetails.removeAttribute("hidden"));
                },
                _getVariantOptionList: function (e) {
                    var t = "";
                    return (
                        e.forEach(function (e) {
                            t = t + '<li class="product-details__item product-details__item--variant-option">' + e.name + ": " + e.value + "</li>";
                        }),
                        t
                    );
                },
                _getPropertyList: function (e) {
                    var t = "";
                    return (
                        Object.entries(e).forEach(function (e) {
                            "_" !== e[0].charAt(0) && 0 !== e[1].length && (t = t + '<li class="product-details__item product-details__item--property"><span class="product-details__property-label">' + e[0] + ": </span>" + e[1]);
                        }),
                        t
                    );
                },
                _getSellingPlanHTML: function (e) {
                    return '<li class="product-details__item product-details__item--property">' + e + "</li>";
                },
                _setCartQuantity: function (e) {
                    var t;
                    (this.cartPopupCartQuantity = this.cartPopupCartQuantity || document.querySelector(this.selectors.cartPopupCartQuantity)),
                        1 === e ? (t = theme.strings.oneCartCount) : e > 1 && (t = theme.strings.otherCartCount.replace("[count]", e)),
                        (this.cartPopupCartQuantity.textContent = e),
                        this.cartPopupCartQuantity.setAttribute("aria-label", t);
                },
                _setCartCountBubble: function (e) {
                    (this.cartCountBubble = this.cartCountBubble || document.querySelector(this.selectors.cartCountBubble)),
                        (this.cartCount = this.cartCount || document.querySelector(this.selectors.cartCount)),
                        this.cartCountBubble.classList.remove(this.classes.hidden),
                        (this.cartCount.textContent = e);
                },
                _showCartPopup: function () {
                    theme.Helpers.prepareTransition(this.cartPopupWrapper),
                        this.cartPopupWrapper.classList.remove(this.classes.cartPopupWrapperHidden),
                        this._handleButtonLoadingState(!1),
                        this._handleButtonLoadingStateBtn(!1, !1),
                        slate.a11y.trapFocus({ container: this.cartPopupWrapper, elementToFocus: this.cartPopup, namespace: "cartPopupFocus" });
                },
                _hideCartPopup: function (e) {
                    var t = 0 === e.detail;
                    theme.Helpers.prepareTransition(this.cartPopupWrapper), this.cartPopupWrapper.classList.add(this.classes.cartPopupWrapperHidden);
                    var s = document.querySelector(this.selectors.cartPopupImage);
                    s && s.remove(),
                        this.cartPopupImagePlaceholder.setAttribute("data-image-loading-animation", ""),
                        slate.a11y.removeTrapFocus({ container: this.cartPopupWrapper, namespace: "cartPopupFocus" }),
                        t && this.previouslyFocusedElement.focus(),
                        this.cartPopupWrapper.removeEventListener("keyup", this.eventHandlers.cartPopupWrapperKeyupHandler),
                        this.cartPopupClose.removeEventListener("click", this.eventHandlers.hideCartPopup),
                        this.cartPopupDismiss.removeEventListener("click", this.eventHandlers.hideCartPopup),
                        document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                },
                _onBodyClick: function (e) {
                    var t = e.target;
                    t === this.cartPopupWrapper || t.closest(this.selectors.cartPopup) || this._hideCartPopup(e);
                },
                _setActiveThumbnail: function (e) {
                    if (void 0 === e) {
                        var t,
                            s = this.container.querySelector(this.selectors.productMediaWrapper + ":not(.hide)");
                        if (!s) return;
                        e = s.getAttribute("data-media-id");
                    }
                    this.container.querySelectorAll(this.selectors.productThumbListItem + ":not(.slick-cloned)").forEach(
                        function (s) {
                            var r = s.querySelector(this.selectors.productThumbImages + "[data-thumbnail-id='" + e + "']");
                            r && (t = r);
                        }.bind(this)
                    ),
                        document.querySelectorAll(this.selectors.productThumbImages).forEach(
                            function (e) {
                                e.classList.remove(this.classes.activeClass), e.removeAttribute("aria-current");
                            }.bind(this)
                        ),
                        t && (t.classList.add(this.classes.activeClass), t.setAttribute("aria-current", !0), this._adjustThumbnailSlider(t));
                },
                _adjustThumbnailSlider: function (e) {
                    var t = e.closest("[data-slider-item]");
                    if (t) {
                        var s = 3 * Math.floor(Number(t.getAttribute("data-slider-slide-index")) / 3);
                        window.setTimeout(
                            function () {
                                this.slideshow && this.slideshow.goToSlideByIndex(s);
                            }.bind(this),
                            251
                        );
                    }
                },
                _switchMedia: function (e) {
                    var t = this.container.querySelector(this.selectors.productMediaWrapper + ":not(." + this.classes.hidden + ")"),
                        s = this.container.querySelector(this.selectors.productMediaWrapper + "[data-media-id='" + e + "']"),
                        r = this.container.querySelectorAll(this.selectors.productMediaWrapper + ":not([data-media-id='" + e + "'])");
                        /*t.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })),
                        s.classList.remove(this.classes.hidden),
                        s.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })),
                        r.forEach(
                            function (e) {
                                e.classList.add(this.classes.hidden);
                            }.bind(this)
                        );*/
                },
                _handleMediaFocus: function (e) {
                    if (e.keyCode === slate.utils.keyboardKeys.ENTER) {
                        var t = e.currentTarget.getAttribute("data-thumbnail-id");
                        this.container.querySelector(this.selectors.productMediaWrapper + "[data-media-id='" + t + "']").focus();
                    }
                },
                _initThumbnailSlider: function () {
                    setTimeout(
                        function () {
                            (this.slideshow = new theme.Slideshow(this.container.querySelector("[data-thumbnail-slider]"), { canUseTouchEvents: !0, type: "slide", slideActiveClass: "slick-active", slidesToShow: 3, slidesToScroll: 3 })),
                                (this.settings.sliderActive = !0);
                        }.bind(this),
                        250
                    );
                },
                _destroyThumbnailSlider: function () {
                    var e = this.container.querySelectorAll("[data-slider-button]"),
                        t = this.container.querySelector("[data-slider-track]"),
                        s = t.querySelectorAll("[data-slider-item");
                    (this.settings.sliderActive = !1),
                        t &&
                            (t.removeAttribute("style"),
                            s.forEach(function (e) {
                                var t = e.querySelector("[data-slider-item-link]");
                                e.classList.remove("slick-active"), e.removeAttribute("style"), e.removeAttribute("tabindex"), e.removeAttribute("aria-hidden"), t.removeAttribute("tabindex");
                            })),
                        e.forEach(function (e) {
                            e.removeAttribute("aria-disabled");
                        }),
                        this.slideshow.destroy(),
                        (this.slideshow = null);
                },
                _liveRegionText: function (e) {
                    var t = "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";
                    if (!this.productState.available) return theme.strings.unavailable;
                    var s = this.productState.soldOut ? theme.strings.soldOut + "," : "";
                    t = t.replace("[Availability]", s);
                    var r = "",
                        n = theme.Currency.formatMoney(e.price, theme.moneyFormat),
                        a = "",
                        o = "",
                        c = "",
                        l = "";
                    return (
                        this.productState.onSale &&
                            ((r = theme.strings.regularPrice), (n = theme.Currency.formatMoney(e.compare_at_price, theme.moneyFormat) + ","), (a = theme.strings.sale), (o = theme.Currency.formatMoney(e.price, theme.moneyFormat))),
                        this.productState.showUnitPrice && ((c = theme.strings.unitPrice), (l = theme.Currency.formatMoney(e.unit_price, theme.moneyFormat) + " " + theme.strings.unitPriceSeparator + " " + this._getBaseUnit(e))),
                        (t = t.replace("[Regular]", r).replace("[$$]", n).replace("[Sale]", a).replace("[$]", o).replace("[UnitPrice]", c).replace("[$$$]", l).trim())
                    );
                },
                _updateLiveRegion: function (e) {
                    var t = e.detail.variant,
                        s = this.container.querySelector(this.selectors.productStatus);
                    (s.innerHTML = this._liveRegionText(t)),
                        s.setAttribute("aria-hidden", !1),
                        setTimeout(function () {
                            s.setAttribute("aria-hidden", !0);
                        }, 1e3);
                },
                _enableAddToCart: function (e) {
                    this.addToCart.removeAttribute("aria-disabled"), this.addToCart.setAttribute("aria-label", e), (this.addToCartText.innerHTML = e), this.productForm.classList.remove(this.classes.variantSoldOut);
                },
                _disableAddToCart: function (e) {
                    (e = e || theme.strings.unavailable),
                        this.addToCart.setAttribute("aria-disabled", !0),
                        this.addToCart.setAttribute("aria-label", e),
                        (this.addToCartText.innerHTML = e),
                        this.productForm.classList.add(this.classes.variantSoldOut);
                },
                _updateAddToCart: function () {
                    if (!this.productState.available) {
                        this._disableAddToCart(theme.strings.unavailable);
                        return;
                    }
                    if (this.productState.soldOut) {
                        this._disableAddToCart(theme.strings.soldOut);
                        return;
                    }
                    this._enableAddToCart(theme.strings.addToCart);
                },
                _setProductState: function (e) {
                    var t = e.detail.variant;
                    if (!t) {
                        this.productState.available = !1;
                        return;
                    }
                    (this.productState.available = !0), (this.productState.soldOut = !t.available), (this.productState.onSale = t.compare_at_price > t.price), (this.productState.showUnitPrice = !!t.unit_price);
                    var s = $("#qty_variant_" + e.detail.variant.id).val(),
                        r = "";
                    for (i = 1; i <= s; i++) r += `<option value='${i}'>${i}</option>`;
                    $(".qty-select select").html(r);
                },
                _updateAvailability: function (e) {
                    this._hideErrorMessage(), this._setProductState(e), this._updateStoreAvailabilityContent(e), this._updateAddToCart(), this._updateLiveRegion(e), this._updatePrice(e);
                },
                _updateStoreAvailabilityContent: function (e) {
                    this.storeAvailability && (this.productState.available && !this.productState.soldOut ? this.storeAvailability.updateContent(e.detail.variant.id) : this.storeAvailability.clearContent());
                },
                _updateMedia: function (e) {
                    var t = e.detail.variant.featured_media.id,
                        s = this.settings.sectionId + "-" + t;
                    this._switchMedia(s), this._setActiveThumbnail(s);
                },
                _updatePrice: function (e) {
                    var s = e.detail.variant,
                        r = this.container.querySelector(this.selectors.priceContainer),
                        n = this.container.querySelector(this.selectors.bffPrice),
                        a = r.querySelectorAll(this.selectors.regularPrice),
                        o = r.querySelector(this.selectors.salePrice),
                        c = r.querySelector(this.selectors.unitPrice),
                        l = r.querySelector(this.selectors.unitPriceBaseUnit),
                        d = function (e, t) {
                            (e.innerHTML = theme.Currency.formatMoney(t, theme.moneyFormatWithCurrency));
                            if(n){
                               n.innerHTML = theme.Currency.formatMoney(0.9 * t, theme.moneyFormatWithCurrency)
                            }
                        };
                    if (
                        (r.classList.remove(this.classes.productUnavailable, this.classes.productOnSale, this.classes.productUnitAvailable, this.classes.productSoldOut),
                        r.removeAttribute("aria-hidden"),
                        this.productPolicies && this.productPolicies.classList.remove(this.classes.visibilityHidden),
                        !this.productState.available)
                    ) {
                        r.classList.add(this.classes.productUnavailable), r.setAttribute("aria-hidden", !0), this.productPolicies && this.productPolicies.classList.add(this.classes.visibilityHidden);
                        return;
                    }
                    this.productState.soldOut && r.classList.add(this.classes.productSoldOut),
                        t(this.productState.onSale ? s.compare_at_price : s.price),
                        this.productState.onSale
                            ? (a.forEach(function (e) {
                                  d(e, s.compare_at_price);
                              }),
                              (o.innerHTML = theme.Currency.formatMoney(s.price, theme.moneyFormatWithCurrency)),
                              r.classList.add(this.classes.productOnSale))
                            : a.forEach(function (e) {
                                  d(e, s.price);
                              }),
                        this.productState.showUnitPrice && ((c.innerHTML = theme.Currency.formatMoney(s.unit_price, theme.moneyFormatWithCurrency)), (l.innerHTML = this._getBaseUnit(s)), r.classList.add(this.classes.productUnitAvailable));
                },
                _getBaseUnit: function (e) {
                    return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                },
                _updateSKU: function (e) {
                    var t = e.detail.variant,
                        s = document.querySelector(this.selectors.SKU);
                    s && (s.innerHTML = t.sku);
                },
                _enableZoom: function (e, t) {
                    this.zoomPictures[t] = new theme.Zoom(e);
                },
                _destroyZoom: function (e) {
                    0 !== this.zoomPictures.length && this.zoomPictures[e].unload();
                },
                onUnload: function () {
                    this.container.removeEventListener("variantChange", this.eventHandlers.updateAvailability),
                        this.container.removeEventListener("variantImageChange", this.eventHandlers.updateMedia),
                        this.container.removeEventListener("variantPriceChange", this.eventHandlers.updatePrice),
                        this.container.removeEventListener("variantSKUChange", this.eventHandlers.updateSKU),
                        theme.ProductVideo.removeSectionVideos(this.settings.sectionId),
                        theme.ProductModel.removeSectionModels(this.settings.sectionId),
                        this.mqlSmall && this.mqlSmall.removeListener(this.initMobileBreakpoint),
                        this.mqlMediumUp && this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
                },
            })),
            e
        );
    })()),
    (theme.ProductRecommendations = function e(t) {
        var s = t.dataset.baseUrl,
            r = t.dataset.productId;
        window.performance.mark("debut:product:fetch_product_recommendations.start"),
            fetch(s + "?section_id=product-recommendations&product_id=" + r + "&limit=6")
                .then(function (e) {
                    return e.text();
                })
                .then(function (e) {
                    "" !== e.trim() &&
                        ((t.innerHTML = e),
                        (t.innerHTML = t.firstElementChild.innerHTML),
                        window.performance.mark("debut:product:fetch_product_recommendations.end"),
                        performance.measure("debut:product:fetch_product_recommendations", "debut:product:fetch_product_recommendations.start", "debut:product:fetch_product_recommendations.end"));
                });
    }),
    (theme.Quotes = (function () {
        var e = { mediaQuerySmall: "screen and (max-width: 749px)", mediaQueryMediumUp: "screen and (min-width: 750px)", slideCount: 0 },
            t = { canUseKeyboardArrows: !1, type: "slide", slidesToShow: 3 };
        function s(s) {
            this.container = s;
            var r = s.getAttribute("data-section-id");
            (this.slider = document.getElementById("Quotes-" + r)),
                (this.sliderActive = !1),
                (this.mobileOptions = Object.assign({}, t, { canUseTouchEvents: !0, slidesToShow: 1 })),
                (this.desktopOptions = Object.assign({}, t, { slidesToShow: Math.min(t.slidesToShow, this.slider.getAttribute("data-count")) })),
                (this.initMobileSlider = this._initMobileSlider.bind(this)),
                (this.initDesktopSlider = this._initDesktopSlider.bind(this)),
                (this.mqlSmall = window.matchMedia(e.mediaQuerySmall)),
                this.mqlSmall.addListener(this.initMobileSlider),
                (this.mqlMediumUp = window.matchMedia(e.mediaQueryMediumUp)),
                this.mqlMediumUp.addListener(this.initDesktopSlider),
                this.initMobileSlider(),
                this.initDesktopSlider();
        }
        return (
            (s.prototype = Object.assign({}, s.prototype, {
                onUnload: function () {
                    this.mqlSmall.removeListener(this.initMobileSlider), this.mqlMediumUp.removeListener(this.initDesktopSlider), this.slideshow.destroy();
                },
                onBlockSelect: function (e) {
                    var t = Number(document.querySelector(".quotes-slide--" + e.detail.blockId).getAttribute("data-slider-slide-index"));
                    this.mqlMediumUp.matches && (t = Math.max(0, Math.min(t, this.slideshow.slides.length - 3))), this.slideshow.goToSlideByIndex(t);
                },
                _initMobileSlider: function () {
                    this.mqlSmall.matches && this._initSlider(this.mobileOptions);
                },
                _initDesktopSlider: function () {
                    this.mqlMediumUp.matches && this._initSlider(this.desktopOptions);
                },
                _initSlider: function (e) {
                    this.sliderActive && (this.slideshow.destroy(), (this.sliderActive = !1)), (this.slideshow = new theme.Slideshow(this.container, e)), (this.sliderActive = !0);
                },
            })),
            s
        );
    })()),
    (theme.SlideshowSection = (function () {
        var e = { sliderMobileContentIndex: "[data-slider-mobile-content-index]" };
        return function t(s) {
            var r = s.dataset.sectionId;
            (this.container = s),
                (this.eventHandlers = {}),
                (this.slideshowDom = s.querySelector("#Slideshow-" + r)),
                (this.sliderMobileContentIndex = s.querySelectorAll(e.sliderMobileContentIndex)),
                (this.slideshow = new theme.Slideshow(s, { autoplay: "true" === this.slideshowDom.getAttribute("data-autorotate"), slideInterval: this.slideshowDom.getAttribute("data-speed") })),
                this._setupEventListeners();
        };
    })()),
    (theme.SlideshowSection.prototype = Object.assign({}, theme.SlideshowSection.prototype, {
        _setupEventListeners: function () {
            (this.eventHandlers.onSliderSlideChanged = function (e) {
                this._onSliderSlideChanged(e.detail);
            }.bind(this)),
                this.container.addEventListener("slider_slide_changed", this.eventHandlers.onSliderSlideChanged);
        },
        _onSliderSlideChanged: function (e) {
            var t = "slideshow__text-content--mobile-active";
            this.sliderMobileContentIndex.forEach(function (s) {
                Number(s.getAttribute("data-slider-mobile-content-index")) === e ? s.classList.add(t) : s.classList.remove(t);
            });
        },
        onUnload: function () {
            this.slideshow.destroy();
        },
        onBlockSelect: function (e) {
            this.slideshow.adaptHeight && this.slideshow.setSlideshowHeight();
            var t = this.container.querySelector(".slideshow__slide--" + e.detail.blockId).getAttribute("data-slider-slide-index");
            this.slideshow.setSlide(t), this.slideshow.stopAutoplay();
        },
        onBlockDeselect: function () {
            this.slideshow.startAutoplay();
        },
    })),
    (window.theme = window.theme || {}),
    (theme.StoreAvailability = (function () {
        var e = {
                storeAvailabilityModalOpen: "[data-store-availability-modal-open]",
                storeAvailabilityModalProductTitle: "[data-store-availability-modal-product-title]",
                storeAvailabilityModalVariantTitle: "[data-store-availability-modal-variant-title]",
            },
            t = { hidden: "hide" };
        function s(e) {
            (this.container = e), (this.productTitle = this.container.dataset.productTitle), (this.hasOnlyDefaultVariant = "true" === this.container.dataset.hasOnlyDefaultVariant);
        }
        return (
            (s.prototype = Object.assign({}, s.prototype, {
                updateContent: function (t) {
                    var s = this.container.dataset.baseUrl + "/variants/" + t + "/?section_id=store-availability",
                        r = this,
                        n = r.container.querySelector(e.storeAvailabilityModalOpen);
                    (this.container.style.opacity = 0.5),
                        n && ((n.disabled = !0), n.setAttribute("aria-busy", !0)),
                        fetch(s)
                            .then(function (e) {
                                return e.text();
                            })
                            .then(function (t) {
                                if ("" !== t.trim())
                                    (r.container.innerHTML = t),
                                        (r.container.innerHTML = r.container.firstElementChild.innerHTML),
                                        (r.container.style.opacity = 1),
                                        (n = r.container.querySelector(e.storeAvailabilityModalOpen)) &&
                                            (n.addEventListener("click", r._onClickModalOpen.bind(r)), (r.modal = r._initModal()), r._updateProductTitle(), r.hasOnlyDefaultVariant && r._hideVariantTitle());
                            });
                },
                clearContent: function () {
                    this.container.innerHTML = "";
                },
                _onClickModalOpen: function () {
                    this.container.dispatchEvent(new CustomEvent("storeAvailabilityModalOpened", { bubbles: !0, cancelable: !0 }));
                },
                _initModal: function () {
                    return new window.Modals("StoreAvailabilityModal", "store-availability-modal", { close: ".js-modal-close-store-availability-modal", closeModalOnClick: !0, openClass: "store-availabilities-modal--active" });
                },
                _updateProductTitle: function () {
                    this.container.querySelector(e.storeAvailabilityModalProductTitle).textContent = this.productTitle;
                },
                _hideVariantTitle: function () {
                    this.container.querySelector(e.storeAvailabilityModalVariantTitle).classList.add(t.hidden);
                },
            })),
            s
        );
    })()),
    (theme.VideoSection = function e(t) {
        t.querySelectorAll(".video").forEach(function (e) {
            theme.Video.init(e), theme.Video.editorLoadVideo(e.id);
        });
    }),
    (theme.VideoSection.prototype = Object.assign({}, theme.VideoSection.prototype, {
        onUnload: function () {
            theme.Video.removeEvents();
        },
    })),
    (theme.heros = {}),
    (theme.HeroSection = function e(t) {
        var s = t.getAttribute("data-section-id"),
            r = "#Hero-" + s;
        theme.heros[r] = new theme.Hero(r, s);
    }),
    (window.theme = window.theme || {});
var selectors = { disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]" };
function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos(), theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}
function removeImageLoadingAnimation(e) {
    var t = e.hasAttribute("data-image-loading-animation") ? e : e.closest("[data-image-loading-animation]");
    t && t.removeAttribute("data-image-loading-animation");
}
(theme.FooterSection = (function () {
    function e(e) {
        (this.container = e),
            (this.cache = {}),
            this.cacheSelectors(),
            this.cache.localeDisclosure && (this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure)),
            this.cache.currencyDisclosure && (this.currencyDisclosure = new theme.Disclosure(this.cache.currencyDisclosure));
    }
    return (
        (e.prototype = Object.assign({}, e.prototype, {
            cacheSelectors: function () {
                this.cache = { localeDisclosure: this.container.querySelector(selectors.disclosureLocale), currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency) };
            },
            onUnload: function () {
                this.cache.localeDisclosure && this.localeDisclosure.destroy(), this.cache.currencyDisclosure && this.currencyDisclosure.destroy();
            },
        })),
        e
    );
})()),
    document.addEventListener("DOMContentLoaded", function () {
        var e = new theme.Sections();
        e.register("cart-template", theme.Cart),
            e.register("product", theme.Product),
            e.register("collection-template", theme.Filters),
            e.register("product-template", theme.Product),
            e.register("header-section", theme.HeaderSection),
            e.register("map", theme.Maps),
            e.register("slideshow-section", theme.SlideshowSection),
            e.register("store-availability", theme.StoreAvailability),
            e.register("video-section", theme.VideoSection),
            e.register("quotes", theme.Quotes),
            e.register("hero-section", theme.HeroSection),
            e.register("product-recommendations", theme.ProductRecommendations),
            e.register("footer-section", theme.FooterSection),
            theme.customerTemplates.init(),
            slate.rte.wrapTable({ tables: document.querySelectorAll(".rte table,.custom__item-inner--html table"), tableWrapperClass: "scrollable-wrapper" }),
            slate.rte.wrapIframe({
                iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]'),
                iframeWrapperClass: "video-wrapper",
            }),
            slate.a11y.pageLinkFocus(document.getElementById(window.location.hash.substr(1)));
        var t = document.querySelector(".in-page-link");
        t &&
            t.addEventListener("click", function (e) {
                slate.a11y.pageLinkFocus(document.getElementById(e.currentTarget.hash.substr(1)));
            }),
            document.querySelectorAll('a[href="#"]').forEach(function (e) {
                e.addEventListener("click", function (e) {
                    e.preventDefault();
                });
            }),
            slate.a11y.accessibleLinks({
                messages: { newWindow: theme.strings.newWindow, external: theme.strings.external, newWindowExternal: theme.strings.newWindowExternal },
                links: document.querySelectorAll("a[href]:not([aria-describedby]), .product-single__thumbnail"),
            }),
            theme.FormStatus.init();
        var s = { image: "[data-image]", lazyloaded: ".lazyloaded" };
        document.addEventListener("lazyloaded", function (e) {
            var t = e.target;
            if ((removeImageLoadingAnimation(t), document.body.classList.contains("template-index"))) {
                var r = document.getElementById("MainContent");
                if (r && r.children && r.children.length) {
                    var n = document.getElementsByClassName("index-section")[0];
                    if (!n || !n.contains(t)) return;
                    window.performance.mark("debut:index:first_image_visible");
                }
            }
            if (t.hasAttribute("data-bgset")) {
                var a = t.querySelector(s.lazyloaded);
                if (a) {
                    var o = t.getAttribute("data-alt"),
                        c = a.hasAttribute("data-src") ? a.getAttribute("data-src") : t.getAttribute("data-bg");
                    t.setAttribute("alt", o || ""), t.setAttribute("src", c || "");
                }
            }
            if (!t.hasAttribute("data-image")) return;
        }),
            document.querySelectorAll(".lazyloaded").forEach(function (e) {
                removeImageLoadingAnimation(e);
            }),
            document.addEventListener(
                "touchstart",
                function () {
                    theme.Helpers.setTouch();
                },
                { once: !0 }
            ),
            document.fonts &&
                document.fonts.ready.then(function () {
                    window.performance.mark("debut:fonts_loaded");
                });
    });
var _getVariantOptionList = function (e) {
        var t = "";
        return (
            e.forEach(function (e) {
                t = t + '<li class="product-details__item product-details__item--variant-option">' + e.name + ": " + e.value + "</li>";
            }),
            t
        );
    },
    _getSellingPlanHTML = function (e) {
        return '<li class="product-details__item product-details__item--property">' + e + "</li>";
    },
    _getPropertyList = function (e) {
        return (null !== e ? Object.entries(e) : [])
            .filter(function (e) {
                return "_" !== e[0].charAt(0) && 0 !== e[1].length;
            })
            .map(
                function (e) {
                    var t = this.itemPropertyTemplate.cloneNode(!0);
                    return (
                        (t.querySelector(selectors.cartItemPropertyName).textContent = e[0] + ": "),
                        -1 === e[0].indexOf("/uploads/")
                            ? (t.querySelector(selectors.cartItemPropertyValue).textContent = e[1])
                            : (t.querySelector(selectors.cartItemPropertyValue).innerHTML = '<a href="' + e[1] + '"> ' + e[1].split("/").pop() + "</a>"),
                        t.classList.remove(classes.hide),
                        t
                    );
                }.bind(this)
            );
    },
    _hideCartPopup = function () {
        var e = { cartPopup: "[data-cart-popup]", cartPopupImage: "[data-cart-popup-image]", cartPopupWrapper: "[data-cart-popup-wrapper]", cartPopupImagePlaceholder: "[data-image-loading-animation]" };
        document.querySelector(e.cartPopup);
        var t = document.querySelector(e.cartPopupWrapper),
            s = document.querySelector(e.cartPopupImagePlaceholder);
        theme.Helpers.prepareTransition(t), t.classList.add("cart-popup-wrapper--hidden");
        var r = document.querySelector(e.cartPopupImage);
        r && r.remove(), s.setAttribute("data-image-loading-animation", ""), slate.a11y.removeTrapFocus({ container: t, namespace: "cartPopupFocus" });
    };
function CartTrackingKlaviyo(e) {
    var t = window._learnq || [],
        s = { total_price: e.final_line_price / 100, $value: e.final_line_price / 100, total_discount: e.total_discount, original_total_price: e.final_price / 100, items: e.items };
    "undefined" !== e && ((s = Object.assign(s, e)), "function" == typeof t.push && (t.push(["track", "Added to Cart", s]), console.log("Added to Cart")));
}
($.fn.print_stars = function () {
    return this.each(function () {
        var e = $(this),
            t = e.data("stars");
        e.find("i").each(function (e) {
            var s = "fa fa-star";
            t < e + 1 && (s += "-o"), $(this).attr("class", s);
        });
    });
}),
    ($.fn.print_stars = function () {
        return this.each(function () {
            var e = $(this),
                t = e.data("stars");
            e.find("i").each(function (e) {
                var s = "fa fa-star";
                t < e + 1 && (s += "-o"), $(this).attr("class", s);
            });
        });
    }),
    $("#shopify-section-collection-template").delegate("[data-product-form]", "submit", function (e) {
        var t = $(this);
        e.preventDefault(),
            $(t).find("button[type=submit]").addClass("btn-loading"),
            fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/x-www-form-urlencoded", "X-Requested-With": "XMLHttpRequest" }, body: theme.Helpers.serialize(t[0]) })
                .then(function (e) {
                    return $(t).find("button[type=submit]").removeClass("btn-loading"), e.json();
                })
                .then(function (e) {
                    if (e.status && 200 !== e.status) {
                        $(t).find(".add-cart-error").remove();
                        var s = document.createElement("div");
                        (s.innerHTML = e.description),
                            (s.className = "add-cart-error"),
                            (s.onclick = function () {
                                s.remove();
                            }),
                            $(t).find("button[type=submit]").after(s);
                    } else {
                        var r = e.quantity;
                        CartTrackingKlaviyo(e);
                        var n = e.selling_plan_allocation ? e.selling_plan_allocation.selling_plan.name : null,
                            a = {
                                cartPopup: "[data-cart-popup]",
                                cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
                                cartPopupClose: "[data-cart-popup-close]",
                                cartPopupDismiss: "[data-cart-popup-dismiss]",
                                cartPopupImage: "[data-cart-popup-image]",
                                cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
                                cartPopupImagePlaceholder: "[data-image-loading-animation]",
                                cartPopupProductDetails: "[data-cart-popup-product-details]",
                                cartPopupQuantity: "[data-cart-popup-quantity]",
                                cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
                                cartPopupTitle: "[data-cart-popup-title]",
                                cartPopupWrapper: "[data-cart-popup-wrapper]",
                                cartCountBubble: "[data-cart-count-bubble]",
                                cartCount: "[data-cart-count]",
                            },
                            o = document.querySelector(a.cartPopup),
                            c = document.querySelector(a.cartPopupWrapper),
                            l = document.querySelector(a.cartPopupTitle),
                            d = document.querySelector(a.cartPopupQuantity),
                            u = document.querySelector(a.cartPopupQuantityLabel),
                            h = document.querySelector(a.cartPopupClose);
                        document.querySelector(a.cartPopupDismiss);
                        var p = document.querySelector(a.cartPopupImagePlaceholder);
                        (l.textContent = e.product_title), (d.textContent = r), (u.textContent = theme.strings.quantityLabel.replace("[count]", r));
                        var m = document.querySelector(a.cartPopupImageWrapper);
                        if (null === e.featured_image.url) {
                            m.classList.add("hide");
                            return;
                        }
                        if (e.featured_image.url) {
                            m.classList.remove("hide");
                            var v = theme.Images.getSizedImageUrl(e.featured_image.url, "200x"),
                                f = document.createElement("img");
                            (f.src = v),
                                (f.alt = e.featured_image.alt),
                                f.classList.add("cart-popup-item__image"),
                                f.setAttribute("data-cart-popup-image", ""),
                                (f.onload = function () {
                                    $(".cart-popup-item__image").remove(), p.removeAttribute("data-image-loading-animation"), m.append(f);
                                }.bind(this));
                        }
                        var y = document.querySelector(a.cartPopupProductDetails),
                            g = "";
                        e.product_has_only_default_variant || (g += _getVariantOptionList(options)),
                            n && (g += _getSellingPlanHTML(n)),
                            null !== e.properties && 0 !== Object.keys(e.properties).length && (g += _getPropertyList(e.properties)),
                            0 === g.length ? ((y.innerHTML = ""), y.setAttribute("hidden", "")) : ((y.innerHTML = g), y.removeAttribute("hidden")),
                            h.addEventListener("click", _hideCartPopup),
                            fetch("/cart.js", { credentials: "same-origin" })
                                .then(function (e) {
                                    return e.json();
                                })
                                .then(function (e) {
                                    var t,
                                        s = document.querySelector(a.cartPopupCartQuantity);
                                    1 === e.item_count ? (t = theme.strings.oneCartCount) : e.item_count > 1 && (t = theme.strings.otherCartCount.replace("[count]", e.item_count)),
                                        (s.textContent = e.item_count),
                                        s.setAttribute("aria-label", t);
                                    var r = document.querySelector(a.cartCountBubble),
                                        n = document.querySelector(a.cartCount);
                                    r.classList.remove("hide"),
                                        (n.textContent = e.item_count),
                                        theme.Helpers.prepareTransition(c),
                                        c.classList.remove("cart-popup-wrapper--hidden"),
                                        slate.a11y.trapFocus({ container: c, elementToFocus: o, namespace: "cartPopupFocus" });
                                })
                                .catch(function (e) {
                                    console.log(e);
                                });
                    }
                });
    }),
    $(".mobile-continue-shopping").click(function () {
        window.appPaymentStatusCallBack && window.appPaymentStatusCallBack.postMessage ? appPaymentStatusCallBack.postMessage("success") : (window.location.href = "/");
    });
